/* tslint:disable */
/* eslint-disable */
/**
 * market-place-2022
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { __assign, __awaiter, __extends, __generator } from "tslib";
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError } from './base';
/**
 * AppApi - axios parameter creator
 * @export
 */
export var AppApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * hello world
         * @summary hello world
         * @param {string} [name]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        helloWorld: function (name, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/hello-world";
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (name !== undefined) {
                        localVarQueryParameter['name'] = name;
                    }
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
/**
 * AppApi - functional programming interface
 * @export
 */
export var AppApiFp = function (configuration) {
    return {
        /**
         * hello world
         * @summary hello world
         * @param {string} [name]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        helloWorld: function (name, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, AppApiAxiosParamCreator(configuration).helloWorld(name, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
    };
};
/**
 * AppApi - factory interface
 * @export
 */
export var AppApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         * hello world
         * @summary hello world
         * @param {string} [name]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        helloWorld: function (name, options) {
            return AppApiFp(configuration).helloWorld(name, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * AppApi - object-oriented interface
 * @export
 * @class AppApi
 * @extends {BaseAPI}
 */
var AppApi = /** @class */ (function (_super) {
    __extends(AppApi, _super);
    function AppApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * hello world
     * @summary hello world
     * @param {AppApiHelloWorldRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppApi
     */
    AppApi.prototype.helloWorld = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return AppApiFp(this.configuration).helloWorld(requestParameters.name, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return AppApi;
}(BaseAPI));
export { AppApi };
/**
 * CorporateApi - axios parameter creator
 * @export
 */
export var CorporateApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * count corporate by search conditions
         * @summary count corporate
         * @param {Array<string>} [allowReferer]
         * @param {number} [commissionRate]
         * @param {boolean} [commissionUse]
         * @param {string} [cursor]
         * @param {number} [id]
         * @param {number} [limit]
         * @param {string} [logoURL]
         * @param {string} [name]
         * @param {string} [orderBy]
         * @param {Array<string>} [scheduleTimes]
         * @param {number} [scheduleUnit]
         * @param {string} [siteName]
         * @param {string} [stripePublicKeyLive]
         * @param {string} [stripePublicKeyTest]
         * @param {boolean} [useCoupon]
         * @param {boolean} [useSubscription]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countCorporate: function (allowReferer, commissionRate, commissionUse, cursor, id, limit, logoURL, name, orderBy, scheduleTimes, scheduleUnit, siteName, stripePublicKeyLive, stripePublicKeyTest, useCoupon, useSubscription, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/corporates/count";
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (allowReferer) {
                        localVarQueryParameter['allowReferer'] = allowReferer.join(COLLECTION_FORMATS.csv);
                    }
                    if (commissionRate !== undefined) {
                        localVarQueryParameter['commissionRate'] = commissionRate;
                    }
                    if (commissionUse !== undefined) {
                        localVarQueryParameter['commissionUse'] = commissionUse;
                    }
                    if (cursor !== undefined) {
                        localVarQueryParameter['cursor'] = cursor;
                    }
                    if (id !== undefined) {
                        localVarQueryParameter['id'] = id;
                    }
                    if (limit !== undefined) {
                        localVarQueryParameter['limit'] = limit;
                    }
                    if (logoURL !== undefined) {
                        localVarQueryParameter['logoURL'] = logoURL;
                    }
                    if (name !== undefined) {
                        localVarQueryParameter['name'] = name;
                    }
                    if (orderBy !== undefined) {
                        localVarQueryParameter['orderBy'] = orderBy;
                    }
                    if (scheduleTimes) {
                        localVarQueryParameter['scheduleTimes'] = scheduleTimes.join(COLLECTION_FORMATS.csv);
                    }
                    if (scheduleUnit !== undefined) {
                        localVarQueryParameter['scheduleUnit'] = scheduleUnit;
                    }
                    if (siteName !== undefined) {
                        localVarQueryParameter['siteName'] = siteName;
                    }
                    if (stripePublicKeyLive !== undefined) {
                        localVarQueryParameter['stripePublicKeyLive'] = stripePublicKeyLive;
                    }
                    if (stripePublicKeyTest !== undefined) {
                        localVarQueryParameter['stripePublicKeyTest'] = stripePublicKeyTest;
                    }
                    if (useCoupon !== undefined) {
                        localVarQueryParameter['useCoupon'] = useCoupon;
                    }
                    if (useSubscription !== undefined) {
                        localVarQueryParameter['useSubscription'] = useSubscription;
                    }
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * create corporate
         * @summary create corporate
         * @param {ModelCorporate} body Corporate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCorporate: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    if (body === null || body === undefined) {
                        throw new RequiredError('body', 'Required parameter body was null or undefined when calling createCorporate.');
                    }
                    localVarPath = "/corporate";
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                    localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * delete corporate
         * @summary delete corporate
         * @param {number} id CorporateID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCorporate: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    if (id === null || id === undefined) {
                        throw new RequiredError('id', 'Required parameter id was null or undefined when calling deleteCorporate.');
                    }
                    localVarPath = "/corporate/{id}"
                        .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * get corporate
         * @summary get corporate
         * @param {number} id CorporateID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCorporate: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    if (id === null || id === undefined) {
                        throw new RequiredError('id', 'Required parameter id was null or undefined when calling getCorporate.');
                    }
                    localVarPath = "/corporate/{id}"
                        .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * get corporates
         * @summary get corporates
         * @param {string} ids Comma Separated CorporateID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCorporates: function (ids, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'ids' is not null or undefined
                    if (ids === null || ids === undefined) {
                        throw new RequiredError('ids', 'Required parameter ids was null or undefined when calling getCorporates.');
                    }
                    localVarPath = "/corporates/{ids}"
                        .replace("{" + "ids" + "}", encodeURIComponent(String(ids)));
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * patch corporate
         * @summary patch corporate
         * @param {number} id CorporateID
         * @param {ModelCorporate} body Corporate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchCorporate: function (id, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    if (id === null || id === undefined) {
                        throw new RequiredError('id', 'Required parameter id was null or undefined when calling patchCorporate.');
                    }
                    // verify required parameter 'body' is not null or undefined
                    if (body === null || body === undefined) {
                        throw new RequiredError('body', 'Required parameter body was null or undefined when calling patchCorporate.');
                    }
                    localVarPath = "/corporate/{id}"
                        .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                    localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * search corporate by search conditions
         * @summary search corporate
         * @param {Array<string>} [allowReferer]
         * @param {number} [commissionRate]
         * @param {boolean} [commissionUse]
         * @param {string} [cursor]
         * @param {number} [id]
         * @param {number} [limit]
         * @param {string} [logoURL]
         * @param {string} [name]
         * @param {string} [orderBy]
         * @param {Array<string>} [scheduleTimes]
         * @param {number} [scheduleUnit]
         * @param {string} [siteName]
         * @param {string} [stripePublicKeyLive]
         * @param {string} [stripePublicKeyTest]
         * @param {boolean} [useCoupon]
         * @param {boolean} [useSubscription]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchCorporate: function (allowReferer, commissionRate, commissionUse, cursor, id, limit, logoURL, name, orderBy, scheduleTimes, scheduleUnit, siteName, stripePublicKeyLive, stripePublicKeyTest, useCoupon, useSubscription, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/corporates";
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (allowReferer) {
                        localVarQueryParameter['allowReferer'] = allowReferer.join(COLLECTION_FORMATS.csv);
                    }
                    if (commissionRate !== undefined) {
                        localVarQueryParameter['commissionRate'] = commissionRate;
                    }
                    if (commissionUse !== undefined) {
                        localVarQueryParameter['commissionUse'] = commissionUse;
                    }
                    if (cursor !== undefined) {
                        localVarQueryParameter['cursor'] = cursor;
                    }
                    if (id !== undefined) {
                        localVarQueryParameter['id'] = id;
                    }
                    if (limit !== undefined) {
                        localVarQueryParameter['limit'] = limit;
                    }
                    if (logoURL !== undefined) {
                        localVarQueryParameter['logoURL'] = logoURL;
                    }
                    if (name !== undefined) {
                        localVarQueryParameter['name'] = name;
                    }
                    if (orderBy !== undefined) {
                        localVarQueryParameter['orderBy'] = orderBy;
                    }
                    if (scheduleTimes) {
                        localVarQueryParameter['scheduleTimes'] = scheduleTimes.join(COLLECTION_FORMATS.csv);
                    }
                    if (scheduleUnit !== undefined) {
                        localVarQueryParameter['scheduleUnit'] = scheduleUnit;
                    }
                    if (siteName !== undefined) {
                        localVarQueryParameter['siteName'] = siteName;
                    }
                    if (stripePublicKeyLive !== undefined) {
                        localVarQueryParameter['stripePublicKeyLive'] = stripePublicKeyLive;
                    }
                    if (stripePublicKeyTest !== undefined) {
                        localVarQueryParameter['stripePublicKeyTest'] = stripePublicKeyTest;
                    }
                    if (useCoupon !== undefined) {
                        localVarQueryParameter['useCoupon'] = useCoupon;
                    }
                    if (useSubscription !== undefined) {
                        localVarQueryParameter['useSubscription'] = useSubscription;
                    }
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * update corporate
         * @summary update corporate
         * @param {number} id CorporateID
         * @param {ModelCorporate} body Corporate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCorporate: function (id, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    if (id === null || id === undefined) {
                        throw new RequiredError('id', 'Required parameter id was null or undefined when calling updateCorporate.');
                    }
                    // verify required parameter 'body' is not null or undefined
                    if (body === null || body === undefined) {
                        throw new RequiredError('body', 'Required parameter body was null or undefined when calling updateCorporate.');
                    }
                    localVarPath = "/corporate/{id}"
                        .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                    localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
/**
 * CorporateApi - functional programming interface
 * @export
 */
export var CorporateApiFp = function (configuration) {
    return {
        /**
         * count corporate by search conditions
         * @summary count corporate
         * @param {Array<string>} [allowReferer]
         * @param {number} [commissionRate]
         * @param {boolean} [commissionUse]
         * @param {string} [cursor]
         * @param {number} [id]
         * @param {number} [limit]
         * @param {string} [logoURL]
         * @param {string} [name]
         * @param {string} [orderBy]
         * @param {Array<string>} [scheduleTimes]
         * @param {number} [scheduleUnit]
         * @param {string} [siteName]
         * @param {string} [stripePublicKeyLive]
         * @param {string} [stripePublicKeyTest]
         * @param {boolean} [useCoupon]
         * @param {boolean} [useSubscription]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countCorporate: function (allowReferer, commissionRate, commissionUse, cursor, id, limit, logoURL, name, orderBy, scheduleTimes, scheduleUnit, siteName, stripePublicKeyLive, stripePublicKeyTest, useCoupon, useSubscription, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, CorporateApiAxiosParamCreator(configuration).countCorporate(allowReferer, commissionRate, commissionUse, cursor, id, limit, logoURL, name, orderBy, scheduleTimes, scheduleUnit, siteName, stripePublicKeyLive, stripePublicKeyTest, useCoupon, useSubscription, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * create corporate
         * @summary create corporate
         * @param {ModelCorporate} body Corporate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCorporate: function (body, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, CorporateApiAxiosParamCreator(configuration).createCorporate(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * delete corporate
         * @summary delete corporate
         * @param {number} id CorporateID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCorporate: function (id, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, CorporateApiAxiosParamCreator(configuration).deleteCorporate(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * get corporate
         * @summary get corporate
         * @param {number} id CorporateID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCorporate: function (id, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, CorporateApiAxiosParamCreator(configuration).getCorporate(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * get corporates
         * @summary get corporates
         * @param {string} ids Comma Separated CorporateID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCorporates: function (ids, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, CorporateApiAxiosParamCreator(configuration).getCorporates(ids, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * patch corporate
         * @summary patch corporate
         * @param {number} id CorporateID
         * @param {ModelCorporate} body Corporate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchCorporate: function (id, body, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, CorporateApiAxiosParamCreator(configuration).patchCorporate(id, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * search corporate by search conditions
         * @summary search corporate
         * @param {Array<string>} [allowReferer]
         * @param {number} [commissionRate]
         * @param {boolean} [commissionUse]
         * @param {string} [cursor]
         * @param {number} [id]
         * @param {number} [limit]
         * @param {string} [logoURL]
         * @param {string} [name]
         * @param {string} [orderBy]
         * @param {Array<string>} [scheduleTimes]
         * @param {number} [scheduleUnit]
         * @param {string} [siteName]
         * @param {string} [stripePublicKeyLive]
         * @param {string} [stripePublicKeyTest]
         * @param {boolean} [useCoupon]
         * @param {boolean} [useSubscription]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchCorporate: function (allowReferer, commissionRate, commissionUse, cursor, id, limit, logoURL, name, orderBy, scheduleTimes, scheduleUnit, siteName, stripePublicKeyLive, stripePublicKeyTest, useCoupon, useSubscription, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, CorporateApiAxiosParamCreator(configuration).searchCorporate(allowReferer, commissionRate, commissionUse, cursor, id, limit, logoURL, name, orderBy, scheduleTimes, scheduleUnit, siteName, stripePublicKeyLive, stripePublicKeyTest, useCoupon, useSubscription, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * update corporate
         * @summary update corporate
         * @param {number} id CorporateID
         * @param {ModelCorporate} body Corporate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCorporate: function (id, body, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, CorporateApiAxiosParamCreator(configuration).updateCorporate(id, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
    };
};
/**
 * CorporateApi - factory interface
 * @export
 */
export var CorporateApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         * count corporate by search conditions
         * @summary count corporate
         * @param {Array<string>} [allowReferer]
         * @param {number} [commissionRate]
         * @param {boolean} [commissionUse]
         * @param {string} [cursor]
         * @param {number} [id]
         * @param {number} [limit]
         * @param {string} [logoURL]
         * @param {string} [name]
         * @param {string} [orderBy]
         * @param {Array<string>} [scheduleTimes]
         * @param {number} [scheduleUnit]
         * @param {string} [siteName]
         * @param {string} [stripePublicKeyLive]
         * @param {string} [stripePublicKeyTest]
         * @param {boolean} [useCoupon]
         * @param {boolean} [useSubscription]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countCorporate: function (allowReferer, commissionRate, commissionUse, cursor, id, limit, logoURL, name, orderBy, scheduleTimes, scheduleUnit, siteName, stripePublicKeyLive, stripePublicKeyTest, useCoupon, useSubscription, options) {
            return CorporateApiFp(configuration).countCorporate(allowReferer, commissionRate, commissionUse, cursor, id, limit, logoURL, name, orderBy, scheduleTimes, scheduleUnit, siteName, stripePublicKeyLive, stripePublicKeyTest, useCoupon, useSubscription, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * create corporate
         * @summary create corporate
         * @param {ModelCorporate} body Corporate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCorporate: function (body, options) {
            return CorporateApiFp(configuration).createCorporate(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * delete corporate
         * @summary delete corporate
         * @param {number} id CorporateID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCorporate: function (id, options) {
            return CorporateApiFp(configuration).deleteCorporate(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * get corporate
         * @summary get corporate
         * @param {number} id CorporateID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCorporate: function (id, options) {
            return CorporateApiFp(configuration).getCorporate(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * get corporates
         * @summary get corporates
         * @param {string} ids Comma Separated CorporateID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCorporates: function (ids, options) {
            return CorporateApiFp(configuration).getCorporates(ids, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * patch corporate
         * @summary patch corporate
         * @param {number} id CorporateID
         * @param {ModelCorporate} body Corporate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchCorporate: function (id, body, options) {
            return CorporateApiFp(configuration).patchCorporate(id, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * search corporate by search conditions
         * @summary search corporate
         * @param {Array<string>} [allowReferer]
         * @param {number} [commissionRate]
         * @param {boolean} [commissionUse]
         * @param {string} [cursor]
         * @param {number} [id]
         * @param {number} [limit]
         * @param {string} [logoURL]
         * @param {string} [name]
         * @param {string} [orderBy]
         * @param {Array<string>} [scheduleTimes]
         * @param {number} [scheduleUnit]
         * @param {string} [siteName]
         * @param {string} [stripePublicKeyLive]
         * @param {string} [stripePublicKeyTest]
         * @param {boolean} [useCoupon]
         * @param {boolean} [useSubscription]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchCorporate: function (allowReferer, commissionRate, commissionUse, cursor, id, limit, logoURL, name, orderBy, scheduleTimes, scheduleUnit, siteName, stripePublicKeyLive, stripePublicKeyTest, useCoupon, useSubscription, options) {
            return CorporateApiFp(configuration).searchCorporate(allowReferer, commissionRate, commissionUse, cursor, id, limit, logoURL, name, orderBy, scheduleTimes, scheduleUnit, siteName, stripePublicKeyLive, stripePublicKeyTest, useCoupon, useSubscription, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * update corporate
         * @summary update corporate
         * @param {number} id CorporateID
         * @param {ModelCorporate} body Corporate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCorporate: function (id, body, options) {
            return CorporateApiFp(configuration).updateCorporate(id, body, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * CorporateApi - object-oriented interface
 * @export
 * @class CorporateApi
 * @extends {BaseAPI}
 */
var CorporateApi = /** @class */ (function (_super) {
    __extends(CorporateApi, _super);
    function CorporateApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * count corporate by search conditions
     * @summary count corporate
     * @param {CorporateApiCountCorporateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CorporateApi
     */
    CorporateApi.prototype.countCorporate = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return CorporateApiFp(this.configuration).countCorporate(requestParameters.allowReferer, requestParameters.commissionRate, requestParameters.commissionUse, requestParameters.cursor, requestParameters.id, requestParameters.limit, requestParameters.logoURL, requestParameters.name, requestParameters.orderBy, requestParameters.scheduleTimes, requestParameters.scheduleUnit, requestParameters.siteName, requestParameters.stripePublicKeyLive, requestParameters.stripePublicKeyTest, requestParameters.useCoupon, requestParameters.useSubscription, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * create corporate
     * @summary create corporate
     * @param {CorporateApiCreateCorporateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CorporateApi
     */
    CorporateApi.prototype.createCorporate = function (requestParameters, options) {
        var _this = this;
        return CorporateApiFp(this.configuration).createCorporate(requestParameters.body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * delete corporate
     * @summary delete corporate
     * @param {CorporateApiDeleteCorporateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CorporateApi
     */
    CorporateApi.prototype.deleteCorporate = function (requestParameters, options) {
        var _this = this;
        return CorporateApiFp(this.configuration).deleteCorporate(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * get corporate
     * @summary get corporate
     * @param {CorporateApiGetCorporateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CorporateApi
     */
    CorporateApi.prototype.getCorporate = function (requestParameters, options) {
        var _this = this;
        return CorporateApiFp(this.configuration).getCorporate(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * get corporates
     * @summary get corporates
     * @param {CorporateApiGetCorporatesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CorporateApi
     */
    CorporateApi.prototype.getCorporates = function (requestParameters, options) {
        var _this = this;
        return CorporateApiFp(this.configuration).getCorporates(requestParameters.ids, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * patch corporate
     * @summary patch corporate
     * @param {CorporateApiPatchCorporateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CorporateApi
     */
    CorporateApi.prototype.patchCorporate = function (requestParameters, options) {
        var _this = this;
        return CorporateApiFp(this.configuration).patchCorporate(requestParameters.id, requestParameters.body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * search corporate by search conditions
     * @summary search corporate
     * @param {CorporateApiSearchCorporateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CorporateApi
     */
    CorporateApi.prototype.searchCorporate = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return CorporateApiFp(this.configuration).searchCorporate(requestParameters.allowReferer, requestParameters.commissionRate, requestParameters.commissionUse, requestParameters.cursor, requestParameters.id, requestParameters.limit, requestParameters.logoURL, requestParameters.name, requestParameters.orderBy, requestParameters.scheduleTimes, requestParameters.scheduleUnit, requestParameters.siteName, requestParameters.stripePublicKeyLive, requestParameters.stripePublicKeyTest, requestParameters.useCoupon, requestParameters.useSubscription, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * update corporate
     * @summary update corporate
     * @param {CorporateApiUpdateCorporateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CorporateApi
     */
    CorporateApi.prototype.updateCorporate = function (requestParameters, options) {
        var _this = this;
        return CorporateApiFp(this.configuration).updateCorporate(requestParameters.id, requestParameters.body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return CorporateApi;
}(BaseAPI));
export { CorporateApi };
/**
 * CouponApi - axios parameter creator
 * @export
 */
export var CouponApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * count coupon by search conditions
         * @summary count coupon
         * @param {boolean} [active]
         * @param {number} [corporateID]
         * @param {number} [couponAmount]
         * @param {number} [couponCount]
         * @param {string} [cursor]
         * @param {number} [customerID]
         * @param {string} [customerName]
         * @param {Array<number>} [entryIDs]
         * @param {number} [id]
         * @param {number} [limit]
         * @param {string} [orderBy]
         * @param {string} [purchaseDate]
         * @param {string} [stripePaymentID]
         * @param {Array<string>} [useDates]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countCoupon: function (active, corporateID, couponAmount, couponCount, cursor, customerID, customerName, entryIDs, id, limit, orderBy, purchaseDate, stripePaymentID, useDates, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/coupons/count";
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (active !== undefined) {
                        localVarQueryParameter['active'] = active;
                    }
                    if (corporateID !== undefined) {
                        localVarQueryParameter['corporateID'] = corporateID;
                    }
                    if (couponAmount !== undefined) {
                        localVarQueryParameter['couponAmount'] = couponAmount;
                    }
                    if (couponCount !== undefined) {
                        localVarQueryParameter['couponCount'] = couponCount;
                    }
                    if (cursor !== undefined) {
                        localVarQueryParameter['cursor'] = cursor;
                    }
                    if (customerID !== undefined) {
                        localVarQueryParameter['customerID'] = customerID;
                    }
                    if (customerName !== undefined) {
                        localVarQueryParameter['customerName'] = customerName;
                    }
                    if (entryIDs) {
                        localVarQueryParameter['entryIDs'] = entryIDs.join(COLLECTION_FORMATS.csv);
                    }
                    if (id !== undefined) {
                        localVarQueryParameter['id'] = id;
                    }
                    if (limit !== undefined) {
                        localVarQueryParameter['limit'] = limit;
                    }
                    if (orderBy !== undefined) {
                        localVarQueryParameter['orderBy'] = orderBy;
                    }
                    if (purchaseDate !== undefined) {
                        localVarQueryParameter['purchaseDate'] = purchaseDate;
                    }
                    if (stripePaymentID !== undefined) {
                        localVarQueryParameter['stripePaymentID'] = stripePaymentID;
                    }
                    if (useDates) {
                        localVarQueryParameter['useDates'] = useDates.join(COLLECTION_FORMATS.csv);
                    }
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * create coupon
         * @summary create coupon
         * @param {ModelCoupon} body Coupon
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCoupon: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    if (body === null || body === undefined) {
                        throw new RequiredError('body', 'Required parameter body was null or undefined when calling createCoupon.');
                    }
                    localVarPath = "/coupon";
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                    localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * delete coupon
         * @summary delete coupon
         * @param {number} id CouponID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCoupon: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    if (id === null || id === undefined) {
                        throw new RequiredError('id', 'Required parameter id was null or undefined when calling deleteCoupon.');
                    }
                    localVarPath = "/coupon/{id}"
                        .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * get coupon
         * @summary get coupon
         * @param {number} id CouponID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCoupon: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    if (id === null || id === undefined) {
                        throw new RequiredError('id', 'Required parameter id was null or undefined when calling getCoupon.');
                    }
                    localVarPath = "/coupon/{id}"
                        .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * get coupons
         * @summary get coupons
         * @param {string} ids Comma Separated CouponID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCoupons: function (ids, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'ids' is not null or undefined
                    if (ids === null || ids === undefined) {
                        throw new RequiredError('ids', 'Required parameter ids was null or undefined when calling getCoupons.');
                    }
                    localVarPath = "/coupons/{ids}"
                        .replace("{" + "ids" + "}", encodeURIComponent(String(ids)));
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * patch coupon
         * @summary patch coupon
         * @param {number} id CouponID
         * @param {ModelCoupon} body Coupon
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchCoupon: function (id, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    if (id === null || id === undefined) {
                        throw new RequiredError('id', 'Required parameter id was null or undefined when calling patchCoupon.');
                    }
                    // verify required parameter 'body' is not null or undefined
                    if (body === null || body === undefined) {
                        throw new RequiredError('body', 'Required parameter body was null or undefined when calling patchCoupon.');
                    }
                    localVarPath = "/coupon/{id}"
                        .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                    localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * search coupon by search conditions
         * @summary search coupon
         * @param {boolean} [active]
         * @param {number} [corporateID]
         * @param {number} [couponAmount]
         * @param {number} [couponCount]
         * @param {string} [cursor]
         * @param {number} [customerID]
         * @param {string} [customerName]
         * @param {Array<number>} [entryIDs]
         * @param {number} [id]
         * @param {number} [limit]
         * @param {string} [orderBy]
         * @param {string} [purchaseDate]
         * @param {string} [stripePaymentID]
         * @param {Array<string>} [useDates]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchCoupon: function (active, corporateID, couponAmount, couponCount, cursor, customerID, customerName, entryIDs, id, limit, orderBy, purchaseDate, stripePaymentID, useDates, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/coupons";
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (active !== undefined) {
                        localVarQueryParameter['active'] = active;
                    }
                    if (corporateID !== undefined) {
                        localVarQueryParameter['corporateID'] = corporateID;
                    }
                    if (couponAmount !== undefined) {
                        localVarQueryParameter['couponAmount'] = couponAmount;
                    }
                    if (couponCount !== undefined) {
                        localVarQueryParameter['couponCount'] = couponCount;
                    }
                    if (cursor !== undefined) {
                        localVarQueryParameter['cursor'] = cursor;
                    }
                    if (customerID !== undefined) {
                        localVarQueryParameter['customerID'] = customerID;
                    }
                    if (customerName !== undefined) {
                        localVarQueryParameter['customerName'] = customerName;
                    }
                    if (entryIDs) {
                        localVarQueryParameter['entryIDs'] = entryIDs.join(COLLECTION_FORMATS.csv);
                    }
                    if (id !== undefined) {
                        localVarQueryParameter['id'] = id;
                    }
                    if (limit !== undefined) {
                        localVarQueryParameter['limit'] = limit;
                    }
                    if (orderBy !== undefined) {
                        localVarQueryParameter['orderBy'] = orderBy;
                    }
                    if (purchaseDate !== undefined) {
                        localVarQueryParameter['purchaseDate'] = purchaseDate;
                    }
                    if (stripePaymentID !== undefined) {
                        localVarQueryParameter['stripePaymentID'] = stripePaymentID;
                    }
                    if (useDates) {
                        localVarQueryParameter['useDates'] = useDates.join(COLLECTION_FORMATS.csv);
                    }
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * update coupon
         * @summary update coupon
         * @param {number} id CouponID
         * @param {ModelCoupon} body Coupon
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCoupon: function (id, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    if (id === null || id === undefined) {
                        throw new RequiredError('id', 'Required parameter id was null or undefined when calling updateCoupon.');
                    }
                    // verify required parameter 'body' is not null or undefined
                    if (body === null || body === undefined) {
                        throw new RequiredError('body', 'Required parameter body was null or undefined when calling updateCoupon.');
                    }
                    localVarPath = "/coupon/{id}"
                        .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                    localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
/**
 * CouponApi - functional programming interface
 * @export
 */
export var CouponApiFp = function (configuration) {
    return {
        /**
         * count coupon by search conditions
         * @summary count coupon
         * @param {boolean} [active]
         * @param {number} [corporateID]
         * @param {number} [couponAmount]
         * @param {number} [couponCount]
         * @param {string} [cursor]
         * @param {number} [customerID]
         * @param {string} [customerName]
         * @param {Array<number>} [entryIDs]
         * @param {number} [id]
         * @param {number} [limit]
         * @param {string} [orderBy]
         * @param {string} [purchaseDate]
         * @param {string} [stripePaymentID]
         * @param {Array<string>} [useDates]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countCoupon: function (active, corporateID, couponAmount, couponCount, cursor, customerID, customerName, entryIDs, id, limit, orderBy, purchaseDate, stripePaymentID, useDates, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, CouponApiAxiosParamCreator(configuration).countCoupon(active, corporateID, couponAmount, couponCount, cursor, customerID, customerName, entryIDs, id, limit, orderBy, purchaseDate, stripePaymentID, useDates, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * create coupon
         * @summary create coupon
         * @param {ModelCoupon} body Coupon
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCoupon: function (body, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, CouponApiAxiosParamCreator(configuration).createCoupon(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * delete coupon
         * @summary delete coupon
         * @param {number} id CouponID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCoupon: function (id, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, CouponApiAxiosParamCreator(configuration).deleteCoupon(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * get coupon
         * @summary get coupon
         * @param {number} id CouponID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCoupon: function (id, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, CouponApiAxiosParamCreator(configuration).getCoupon(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * get coupons
         * @summary get coupons
         * @param {string} ids Comma Separated CouponID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCoupons: function (ids, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, CouponApiAxiosParamCreator(configuration).getCoupons(ids, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * patch coupon
         * @summary patch coupon
         * @param {number} id CouponID
         * @param {ModelCoupon} body Coupon
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchCoupon: function (id, body, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, CouponApiAxiosParamCreator(configuration).patchCoupon(id, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * search coupon by search conditions
         * @summary search coupon
         * @param {boolean} [active]
         * @param {number} [corporateID]
         * @param {number} [couponAmount]
         * @param {number} [couponCount]
         * @param {string} [cursor]
         * @param {number} [customerID]
         * @param {string} [customerName]
         * @param {Array<number>} [entryIDs]
         * @param {number} [id]
         * @param {number} [limit]
         * @param {string} [orderBy]
         * @param {string} [purchaseDate]
         * @param {string} [stripePaymentID]
         * @param {Array<string>} [useDates]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchCoupon: function (active, corporateID, couponAmount, couponCount, cursor, customerID, customerName, entryIDs, id, limit, orderBy, purchaseDate, stripePaymentID, useDates, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, CouponApiAxiosParamCreator(configuration).searchCoupon(active, corporateID, couponAmount, couponCount, cursor, customerID, customerName, entryIDs, id, limit, orderBy, purchaseDate, stripePaymentID, useDates, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * update coupon
         * @summary update coupon
         * @param {number} id CouponID
         * @param {ModelCoupon} body Coupon
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCoupon: function (id, body, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, CouponApiAxiosParamCreator(configuration).updateCoupon(id, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
    };
};
/**
 * CouponApi - factory interface
 * @export
 */
export var CouponApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         * count coupon by search conditions
         * @summary count coupon
         * @param {boolean} [active]
         * @param {number} [corporateID]
         * @param {number} [couponAmount]
         * @param {number} [couponCount]
         * @param {string} [cursor]
         * @param {number} [customerID]
         * @param {string} [customerName]
         * @param {Array<number>} [entryIDs]
         * @param {number} [id]
         * @param {number} [limit]
         * @param {string} [orderBy]
         * @param {string} [purchaseDate]
         * @param {string} [stripePaymentID]
         * @param {Array<string>} [useDates]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countCoupon: function (active, corporateID, couponAmount, couponCount, cursor, customerID, customerName, entryIDs, id, limit, orderBy, purchaseDate, stripePaymentID, useDates, options) {
            return CouponApiFp(configuration).countCoupon(active, corporateID, couponAmount, couponCount, cursor, customerID, customerName, entryIDs, id, limit, orderBy, purchaseDate, stripePaymentID, useDates, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * create coupon
         * @summary create coupon
         * @param {ModelCoupon} body Coupon
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCoupon: function (body, options) {
            return CouponApiFp(configuration).createCoupon(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * delete coupon
         * @summary delete coupon
         * @param {number} id CouponID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCoupon: function (id, options) {
            return CouponApiFp(configuration).deleteCoupon(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * get coupon
         * @summary get coupon
         * @param {number} id CouponID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCoupon: function (id, options) {
            return CouponApiFp(configuration).getCoupon(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * get coupons
         * @summary get coupons
         * @param {string} ids Comma Separated CouponID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCoupons: function (ids, options) {
            return CouponApiFp(configuration).getCoupons(ids, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * patch coupon
         * @summary patch coupon
         * @param {number} id CouponID
         * @param {ModelCoupon} body Coupon
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchCoupon: function (id, body, options) {
            return CouponApiFp(configuration).patchCoupon(id, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * search coupon by search conditions
         * @summary search coupon
         * @param {boolean} [active]
         * @param {number} [corporateID]
         * @param {number} [couponAmount]
         * @param {number} [couponCount]
         * @param {string} [cursor]
         * @param {number} [customerID]
         * @param {string} [customerName]
         * @param {Array<number>} [entryIDs]
         * @param {number} [id]
         * @param {number} [limit]
         * @param {string} [orderBy]
         * @param {string} [purchaseDate]
         * @param {string} [stripePaymentID]
         * @param {Array<string>} [useDates]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchCoupon: function (active, corporateID, couponAmount, couponCount, cursor, customerID, customerName, entryIDs, id, limit, orderBy, purchaseDate, stripePaymentID, useDates, options) {
            return CouponApiFp(configuration).searchCoupon(active, corporateID, couponAmount, couponCount, cursor, customerID, customerName, entryIDs, id, limit, orderBy, purchaseDate, stripePaymentID, useDates, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * update coupon
         * @summary update coupon
         * @param {number} id CouponID
         * @param {ModelCoupon} body Coupon
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCoupon: function (id, body, options) {
            return CouponApiFp(configuration).updateCoupon(id, body, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * CouponApi - object-oriented interface
 * @export
 * @class CouponApi
 * @extends {BaseAPI}
 */
var CouponApi = /** @class */ (function (_super) {
    __extends(CouponApi, _super);
    function CouponApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * count coupon by search conditions
     * @summary count coupon
     * @param {CouponApiCountCouponRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouponApi
     */
    CouponApi.prototype.countCoupon = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return CouponApiFp(this.configuration).countCoupon(requestParameters.active, requestParameters.corporateID, requestParameters.couponAmount, requestParameters.couponCount, requestParameters.cursor, requestParameters.customerID, requestParameters.customerName, requestParameters.entryIDs, requestParameters.id, requestParameters.limit, requestParameters.orderBy, requestParameters.purchaseDate, requestParameters.stripePaymentID, requestParameters.useDates, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * create coupon
     * @summary create coupon
     * @param {CouponApiCreateCouponRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouponApi
     */
    CouponApi.prototype.createCoupon = function (requestParameters, options) {
        var _this = this;
        return CouponApiFp(this.configuration).createCoupon(requestParameters.body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * delete coupon
     * @summary delete coupon
     * @param {CouponApiDeleteCouponRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouponApi
     */
    CouponApi.prototype.deleteCoupon = function (requestParameters, options) {
        var _this = this;
        return CouponApiFp(this.configuration).deleteCoupon(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * get coupon
     * @summary get coupon
     * @param {CouponApiGetCouponRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouponApi
     */
    CouponApi.prototype.getCoupon = function (requestParameters, options) {
        var _this = this;
        return CouponApiFp(this.configuration).getCoupon(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * get coupons
     * @summary get coupons
     * @param {CouponApiGetCouponsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouponApi
     */
    CouponApi.prototype.getCoupons = function (requestParameters, options) {
        var _this = this;
        return CouponApiFp(this.configuration).getCoupons(requestParameters.ids, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * patch coupon
     * @summary patch coupon
     * @param {CouponApiPatchCouponRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouponApi
     */
    CouponApi.prototype.patchCoupon = function (requestParameters, options) {
        var _this = this;
        return CouponApiFp(this.configuration).patchCoupon(requestParameters.id, requestParameters.body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * search coupon by search conditions
     * @summary search coupon
     * @param {CouponApiSearchCouponRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouponApi
     */
    CouponApi.prototype.searchCoupon = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return CouponApiFp(this.configuration).searchCoupon(requestParameters.active, requestParameters.corporateID, requestParameters.couponAmount, requestParameters.couponCount, requestParameters.cursor, requestParameters.customerID, requestParameters.customerName, requestParameters.entryIDs, requestParameters.id, requestParameters.limit, requestParameters.orderBy, requestParameters.purchaseDate, requestParameters.stripePaymentID, requestParameters.useDates, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * update coupon
     * @summary update coupon
     * @param {CouponApiUpdateCouponRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouponApi
     */
    CouponApi.prototype.updateCoupon = function (requestParameters, options) {
        var _this = this;
        return CouponApiFp(this.configuration).updateCoupon(requestParameters.id, requestParameters.body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return CouponApi;
}(BaseAPI));
export { CouponApi };
/**
 * CustomerApi - axios parameter creator
 * @export
 */
export var CustomerApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * count customer by search conditions
         * @summary count customer
         * @param {string} [address]
         * @param {boolean} [approvalFlag]
         * @param {number} [corporateID]
         * @param {string} [cursor]
         * @param {number} [customerType]
         * @param {string} [email]
         * @param {number} [id]
         * @param {number} [limit]
         * @param {string} [name]
         * @param {string} [nameKana]
         * @param {string} [orderBy]
         * @param {string} [phone]
         * @param {string} [postCode]
         * @param {string} [stripeCustomerID]
         * @param {string} [stripePaymentMethodID]
         * @param {string} [userID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countCustomer: function (address, approvalFlag, corporateID, cursor, customerType, email, id, limit, name, nameKana, orderBy, phone, postCode, stripeCustomerID, stripePaymentMethodID, userID, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/customers/count";
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (address !== undefined) {
                        localVarQueryParameter['address'] = address;
                    }
                    if (approvalFlag !== undefined) {
                        localVarQueryParameter['approvalFlag'] = approvalFlag;
                    }
                    if (corporateID !== undefined) {
                        localVarQueryParameter['corporateID'] = corporateID;
                    }
                    if (cursor !== undefined) {
                        localVarQueryParameter['cursor'] = cursor;
                    }
                    if (customerType !== undefined) {
                        localVarQueryParameter['customerType'] = customerType;
                    }
                    if (email !== undefined) {
                        localVarQueryParameter['email'] = email;
                    }
                    if (id !== undefined) {
                        localVarQueryParameter['id'] = id;
                    }
                    if (limit !== undefined) {
                        localVarQueryParameter['limit'] = limit;
                    }
                    if (name !== undefined) {
                        localVarQueryParameter['name'] = name;
                    }
                    if (nameKana !== undefined) {
                        localVarQueryParameter['nameKana'] = nameKana;
                    }
                    if (orderBy !== undefined) {
                        localVarQueryParameter['orderBy'] = orderBy;
                    }
                    if (phone !== undefined) {
                        localVarQueryParameter['phone'] = phone;
                    }
                    if (postCode !== undefined) {
                        localVarQueryParameter['postCode'] = postCode;
                    }
                    if (stripeCustomerID !== undefined) {
                        localVarQueryParameter['stripeCustomerID'] = stripeCustomerID;
                    }
                    if (stripePaymentMethodID !== undefined) {
                        localVarQueryParameter['stripePaymentMethodID'] = stripePaymentMethodID;
                    }
                    if (userID !== undefined) {
                        localVarQueryParameter['userID'] = userID;
                    }
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * create customer
         * @summary create customer
         * @param {ModelCustomer} body Customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCustomer: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    if (body === null || body === undefined) {
                        throw new RequiredError('body', 'Required parameter body was null or undefined when calling createCustomer.');
                    }
                    localVarPath = "/customer";
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                    localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * delete customer
         * @summary delete customer
         * @param {number} id CustomerID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCustomer: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    if (id === null || id === undefined) {
                        throw new RequiredError('id', 'Required parameter id was null or undefined when calling deleteCustomer.');
                    }
                    localVarPath = "/customer/{id}"
                        .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * get customer
         * @summary get customer
         * @param {number} id CustomerID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomer: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    if (id === null || id === undefined) {
                        throw new RequiredError('id', 'Required parameter id was null or undefined when calling getCustomer.');
                    }
                    localVarPath = "/customer/{id}"
                        .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * get customers
         * @summary get customers
         * @param {string} ids Comma Separated CustomerID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomers: function (ids, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'ids' is not null or undefined
                    if (ids === null || ids === undefined) {
                        throw new RequiredError('ids', 'Required parameter ids was null or undefined when calling getCustomers.');
                    }
                    localVarPath = "/customers/{ids}"
                        .replace("{" + "ids" + "}", encodeURIComponent(String(ids)));
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * patch customer
         * @summary patch customer
         * @param {number} id CustomerID
         * @param {ModelCustomer} body Customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchCustomer: function (id, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    if (id === null || id === undefined) {
                        throw new RequiredError('id', 'Required parameter id was null or undefined when calling patchCustomer.');
                    }
                    // verify required parameter 'body' is not null or undefined
                    if (body === null || body === undefined) {
                        throw new RequiredError('body', 'Required parameter body was null or undefined when calling patchCustomer.');
                    }
                    localVarPath = "/customer/{id}"
                        .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                    localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * search customer by search conditions
         * @summary search customer
         * @param {string} [address]
         * @param {boolean} [approvalFlag]
         * @param {number} [corporateID]
         * @param {string} [cursor]
         * @param {number} [customerType]
         * @param {string} [email]
         * @param {number} [id]
         * @param {number} [limit]
         * @param {string} [name]
         * @param {string} [nameKana]
         * @param {string} [orderBy]
         * @param {string} [phone]
         * @param {string} [postCode]
         * @param {string} [stripeCustomerID]
         * @param {string} [stripePaymentMethodID]
         * @param {string} [userID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchCustomer: function (address, approvalFlag, corporateID, cursor, customerType, email, id, limit, name, nameKana, orderBy, phone, postCode, stripeCustomerID, stripePaymentMethodID, userID, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/customers";
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (address !== undefined) {
                        localVarQueryParameter['address'] = address;
                    }
                    if (approvalFlag !== undefined) {
                        localVarQueryParameter['approvalFlag'] = approvalFlag;
                    }
                    if (corporateID !== undefined) {
                        localVarQueryParameter['corporateID'] = corporateID;
                    }
                    if (cursor !== undefined) {
                        localVarQueryParameter['cursor'] = cursor;
                    }
                    if (customerType !== undefined) {
                        localVarQueryParameter['customerType'] = customerType;
                    }
                    if (email !== undefined) {
                        localVarQueryParameter['email'] = email;
                    }
                    if (id !== undefined) {
                        localVarQueryParameter['id'] = id;
                    }
                    if (limit !== undefined) {
                        localVarQueryParameter['limit'] = limit;
                    }
                    if (name !== undefined) {
                        localVarQueryParameter['name'] = name;
                    }
                    if (nameKana !== undefined) {
                        localVarQueryParameter['nameKana'] = nameKana;
                    }
                    if (orderBy !== undefined) {
                        localVarQueryParameter['orderBy'] = orderBy;
                    }
                    if (phone !== undefined) {
                        localVarQueryParameter['phone'] = phone;
                    }
                    if (postCode !== undefined) {
                        localVarQueryParameter['postCode'] = postCode;
                    }
                    if (stripeCustomerID !== undefined) {
                        localVarQueryParameter['stripeCustomerID'] = stripeCustomerID;
                    }
                    if (stripePaymentMethodID !== undefined) {
                        localVarQueryParameter['stripePaymentMethodID'] = stripePaymentMethodID;
                    }
                    if (userID !== undefined) {
                        localVarQueryParameter['userID'] = userID;
                    }
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * update customer
         * @summary update customer
         * @param {number} id CustomerID
         * @param {ModelCustomer} body Customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCustomer: function (id, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    if (id === null || id === undefined) {
                        throw new RequiredError('id', 'Required parameter id was null or undefined when calling updateCustomer.');
                    }
                    // verify required parameter 'body' is not null or undefined
                    if (body === null || body === undefined) {
                        throw new RequiredError('body', 'Required parameter body was null or undefined when calling updateCustomer.');
                    }
                    localVarPath = "/customer/{id}"
                        .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                    localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
/**
 * CustomerApi - functional programming interface
 * @export
 */
export var CustomerApiFp = function (configuration) {
    return {
        /**
         * count customer by search conditions
         * @summary count customer
         * @param {string} [address]
         * @param {boolean} [approvalFlag]
         * @param {number} [corporateID]
         * @param {string} [cursor]
         * @param {number} [customerType]
         * @param {string} [email]
         * @param {number} [id]
         * @param {number} [limit]
         * @param {string} [name]
         * @param {string} [nameKana]
         * @param {string} [orderBy]
         * @param {string} [phone]
         * @param {string} [postCode]
         * @param {string} [stripeCustomerID]
         * @param {string} [stripePaymentMethodID]
         * @param {string} [userID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countCustomer: function (address, approvalFlag, corporateID, cursor, customerType, email, id, limit, name, nameKana, orderBy, phone, postCode, stripeCustomerID, stripePaymentMethodID, userID, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, CustomerApiAxiosParamCreator(configuration).countCustomer(address, approvalFlag, corporateID, cursor, customerType, email, id, limit, name, nameKana, orderBy, phone, postCode, stripeCustomerID, stripePaymentMethodID, userID, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * create customer
         * @summary create customer
         * @param {ModelCustomer} body Customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCustomer: function (body, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, CustomerApiAxiosParamCreator(configuration).createCustomer(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * delete customer
         * @summary delete customer
         * @param {number} id CustomerID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCustomer: function (id, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, CustomerApiAxiosParamCreator(configuration).deleteCustomer(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * get customer
         * @summary get customer
         * @param {number} id CustomerID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomer: function (id, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, CustomerApiAxiosParamCreator(configuration).getCustomer(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * get customers
         * @summary get customers
         * @param {string} ids Comma Separated CustomerID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomers: function (ids, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, CustomerApiAxiosParamCreator(configuration).getCustomers(ids, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * patch customer
         * @summary patch customer
         * @param {number} id CustomerID
         * @param {ModelCustomer} body Customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchCustomer: function (id, body, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, CustomerApiAxiosParamCreator(configuration).patchCustomer(id, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * search customer by search conditions
         * @summary search customer
         * @param {string} [address]
         * @param {boolean} [approvalFlag]
         * @param {number} [corporateID]
         * @param {string} [cursor]
         * @param {number} [customerType]
         * @param {string} [email]
         * @param {number} [id]
         * @param {number} [limit]
         * @param {string} [name]
         * @param {string} [nameKana]
         * @param {string} [orderBy]
         * @param {string} [phone]
         * @param {string} [postCode]
         * @param {string} [stripeCustomerID]
         * @param {string} [stripePaymentMethodID]
         * @param {string} [userID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchCustomer: function (address, approvalFlag, corporateID, cursor, customerType, email, id, limit, name, nameKana, orderBy, phone, postCode, stripeCustomerID, stripePaymentMethodID, userID, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, CustomerApiAxiosParamCreator(configuration).searchCustomer(address, approvalFlag, corporateID, cursor, customerType, email, id, limit, name, nameKana, orderBy, phone, postCode, stripeCustomerID, stripePaymentMethodID, userID, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * update customer
         * @summary update customer
         * @param {number} id CustomerID
         * @param {ModelCustomer} body Customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCustomer: function (id, body, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, CustomerApiAxiosParamCreator(configuration).updateCustomer(id, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
    };
};
/**
 * CustomerApi - factory interface
 * @export
 */
export var CustomerApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         * count customer by search conditions
         * @summary count customer
         * @param {string} [address]
         * @param {boolean} [approvalFlag]
         * @param {number} [corporateID]
         * @param {string} [cursor]
         * @param {number} [customerType]
         * @param {string} [email]
         * @param {number} [id]
         * @param {number} [limit]
         * @param {string} [name]
         * @param {string} [nameKana]
         * @param {string} [orderBy]
         * @param {string} [phone]
         * @param {string} [postCode]
         * @param {string} [stripeCustomerID]
         * @param {string} [stripePaymentMethodID]
         * @param {string} [userID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countCustomer: function (address, approvalFlag, corporateID, cursor, customerType, email, id, limit, name, nameKana, orderBy, phone, postCode, stripeCustomerID, stripePaymentMethodID, userID, options) {
            return CustomerApiFp(configuration).countCustomer(address, approvalFlag, corporateID, cursor, customerType, email, id, limit, name, nameKana, orderBy, phone, postCode, stripeCustomerID, stripePaymentMethodID, userID, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * create customer
         * @summary create customer
         * @param {ModelCustomer} body Customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCustomer: function (body, options) {
            return CustomerApiFp(configuration).createCustomer(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * delete customer
         * @summary delete customer
         * @param {number} id CustomerID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCustomer: function (id, options) {
            return CustomerApiFp(configuration).deleteCustomer(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * get customer
         * @summary get customer
         * @param {number} id CustomerID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomer: function (id, options) {
            return CustomerApiFp(configuration).getCustomer(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * get customers
         * @summary get customers
         * @param {string} ids Comma Separated CustomerID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomers: function (ids, options) {
            return CustomerApiFp(configuration).getCustomers(ids, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * patch customer
         * @summary patch customer
         * @param {number} id CustomerID
         * @param {ModelCustomer} body Customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchCustomer: function (id, body, options) {
            return CustomerApiFp(configuration).patchCustomer(id, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * search customer by search conditions
         * @summary search customer
         * @param {string} [address]
         * @param {boolean} [approvalFlag]
         * @param {number} [corporateID]
         * @param {string} [cursor]
         * @param {number} [customerType]
         * @param {string} [email]
         * @param {number} [id]
         * @param {number} [limit]
         * @param {string} [name]
         * @param {string} [nameKana]
         * @param {string} [orderBy]
         * @param {string} [phone]
         * @param {string} [postCode]
         * @param {string} [stripeCustomerID]
         * @param {string} [stripePaymentMethodID]
         * @param {string} [userID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchCustomer: function (address, approvalFlag, corporateID, cursor, customerType, email, id, limit, name, nameKana, orderBy, phone, postCode, stripeCustomerID, stripePaymentMethodID, userID, options) {
            return CustomerApiFp(configuration).searchCustomer(address, approvalFlag, corporateID, cursor, customerType, email, id, limit, name, nameKana, orderBy, phone, postCode, stripeCustomerID, stripePaymentMethodID, userID, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * update customer
         * @summary update customer
         * @param {number} id CustomerID
         * @param {ModelCustomer} body Customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCustomer: function (id, body, options) {
            return CustomerApiFp(configuration).updateCustomer(id, body, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * CustomerApi - object-oriented interface
 * @export
 * @class CustomerApi
 * @extends {BaseAPI}
 */
var CustomerApi = /** @class */ (function (_super) {
    __extends(CustomerApi, _super);
    function CustomerApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * count customer by search conditions
     * @summary count customer
     * @param {CustomerApiCountCustomerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    CustomerApi.prototype.countCustomer = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return CustomerApiFp(this.configuration).countCustomer(requestParameters.address, requestParameters.approvalFlag, requestParameters.corporateID, requestParameters.cursor, requestParameters.customerType, requestParameters.email, requestParameters.id, requestParameters.limit, requestParameters.name, requestParameters.nameKana, requestParameters.orderBy, requestParameters.phone, requestParameters.postCode, requestParameters.stripeCustomerID, requestParameters.stripePaymentMethodID, requestParameters.userID, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * create customer
     * @summary create customer
     * @param {CustomerApiCreateCustomerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    CustomerApi.prototype.createCustomer = function (requestParameters, options) {
        var _this = this;
        return CustomerApiFp(this.configuration).createCustomer(requestParameters.body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * delete customer
     * @summary delete customer
     * @param {CustomerApiDeleteCustomerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    CustomerApi.prototype.deleteCustomer = function (requestParameters, options) {
        var _this = this;
        return CustomerApiFp(this.configuration).deleteCustomer(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * get customer
     * @summary get customer
     * @param {CustomerApiGetCustomerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    CustomerApi.prototype.getCustomer = function (requestParameters, options) {
        var _this = this;
        return CustomerApiFp(this.configuration).getCustomer(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * get customers
     * @summary get customers
     * @param {CustomerApiGetCustomersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    CustomerApi.prototype.getCustomers = function (requestParameters, options) {
        var _this = this;
        return CustomerApiFp(this.configuration).getCustomers(requestParameters.ids, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * patch customer
     * @summary patch customer
     * @param {CustomerApiPatchCustomerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    CustomerApi.prototype.patchCustomer = function (requestParameters, options) {
        var _this = this;
        return CustomerApiFp(this.configuration).patchCustomer(requestParameters.id, requestParameters.body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * search customer by search conditions
     * @summary search customer
     * @param {CustomerApiSearchCustomerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    CustomerApi.prototype.searchCustomer = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return CustomerApiFp(this.configuration).searchCustomer(requestParameters.address, requestParameters.approvalFlag, requestParameters.corporateID, requestParameters.cursor, requestParameters.customerType, requestParameters.email, requestParameters.id, requestParameters.limit, requestParameters.name, requestParameters.nameKana, requestParameters.orderBy, requestParameters.phone, requestParameters.postCode, requestParameters.stripeCustomerID, requestParameters.stripePaymentMethodID, requestParameters.userID, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * update customer
     * @summary update customer
     * @param {CustomerApiUpdateCustomerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    CustomerApi.prototype.updateCustomer = function (requestParameters, options) {
        var _this = this;
        return CustomerApiFp(this.configuration).updateCustomer(requestParameters.id, requestParameters.body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return CustomerApi;
}(BaseAPI));
export { CustomerApi };
/**
 * EntryApi - axios parameter creator
 * @export
 */
export var EntryApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * count entry by search conditions
         * @summary count entry
         * @param {string} [comment]
         * @param {number} [corporateID]
         * @param {string} [cursor]
         * @param {number} [customerID]
         * @param {string} [customerName]
         * @param {string} [endDateTime]
         * @param {string} [endDateTimeFrom]
         * @param {string} [endDateTimeTo]
         * @param {number} [id]
         * @param {number} [limit]
         * @param {number} [mainProductID]
         * @param {string} [mainProductName]
         * @param {number} [memberID]
         * @param {string} [memberName]
         * @param {string} [orderBy]
         * @param {number} [paymentMethod]
         * @param {number} [paymentStatus]
         * @param {number} [placeID]
         * @param {string} [placeName]
         * @param {Array<number>} [scheduleIDs]
         * @param {string} [startDateTime]
         * @param {string} [startDateTimeFrom]
         * @param {string} [startDateTimeTo]
         * @param {number} [status]
         * @param {number} [totalAmount]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countEntry: function (comment, corporateID, cursor, customerID, customerName, endDateTime, endDateTimeFrom, endDateTimeTo, id, limit, mainProductID, mainProductName, memberID, memberName, orderBy, paymentMethod, paymentStatus, placeID, placeName, scheduleIDs, startDateTime, startDateTimeFrom, startDateTimeTo, status, totalAmount, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/entries/count";
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (comment !== undefined) {
                        localVarQueryParameter['comment'] = comment;
                    }
                    if (corporateID !== undefined) {
                        localVarQueryParameter['corporateID'] = corporateID;
                    }
                    if (cursor !== undefined) {
                        localVarQueryParameter['cursor'] = cursor;
                    }
                    if (customerID !== undefined) {
                        localVarQueryParameter['customerID'] = customerID;
                    }
                    if (customerName !== undefined) {
                        localVarQueryParameter['customerName'] = customerName;
                    }
                    if (endDateTime !== undefined) {
                        localVarQueryParameter['endDateTime'] = endDateTime;
                    }
                    if (endDateTimeFrom !== undefined) {
                        localVarQueryParameter['endDateTimeFrom'] = endDateTimeFrom;
                    }
                    if (endDateTimeTo !== undefined) {
                        localVarQueryParameter['endDateTimeTo'] = endDateTimeTo;
                    }
                    if (id !== undefined) {
                        localVarQueryParameter['id'] = id;
                    }
                    if (limit !== undefined) {
                        localVarQueryParameter['limit'] = limit;
                    }
                    if (mainProductID !== undefined) {
                        localVarQueryParameter['mainProductID'] = mainProductID;
                    }
                    if (mainProductName !== undefined) {
                        localVarQueryParameter['mainProductName'] = mainProductName;
                    }
                    if (memberID !== undefined) {
                        localVarQueryParameter['memberID'] = memberID;
                    }
                    if (memberName !== undefined) {
                        localVarQueryParameter['memberName'] = memberName;
                    }
                    if (orderBy !== undefined) {
                        localVarQueryParameter['orderBy'] = orderBy;
                    }
                    if (paymentMethod !== undefined) {
                        localVarQueryParameter['paymentMethod'] = paymentMethod;
                    }
                    if (paymentStatus !== undefined) {
                        localVarQueryParameter['paymentStatus'] = paymentStatus;
                    }
                    if (placeID !== undefined) {
                        localVarQueryParameter['placeID'] = placeID;
                    }
                    if (placeName !== undefined) {
                        localVarQueryParameter['placeName'] = placeName;
                    }
                    if (scheduleIDs) {
                        localVarQueryParameter['scheduleIDs'] = scheduleIDs.join(COLLECTION_FORMATS.csv);
                    }
                    if (startDateTime !== undefined) {
                        localVarQueryParameter['startDateTime'] = startDateTime;
                    }
                    if (startDateTimeFrom !== undefined) {
                        localVarQueryParameter['startDateTimeFrom'] = startDateTimeFrom;
                    }
                    if (startDateTimeTo !== undefined) {
                        localVarQueryParameter['startDateTimeTo'] = startDateTimeTo;
                    }
                    if (status !== undefined) {
                        localVarQueryParameter['status'] = status;
                    }
                    if (totalAmount !== undefined) {
                        localVarQueryParameter['totalAmount'] = totalAmount;
                    }
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * create entry
         * @summary create entry
         * @param {ModelEntry} body Entry
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntry: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    if (body === null || body === undefined) {
                        throw new RequiredError('body', 'Required parameter body was null or undefined when calling createEntry.');
                    }
                    localVarPath = "/entry";
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                    localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * delete entry
         * @summary delete entry
         * @param {number} id EntryID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntry: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    if (id === null || id === undefined) {
                        throw new RequiredError('id', 'Required parameter id was null or undefined when calling deleteEntry.');
                    }
                    localVarPath = "/entry/{id}"
                        .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * get entries
         * @summary get entries
         * @param {string} ids Comma Separated EntryID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntries: function (ids, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'ids' is not null or undefined
                    if (ids === null || ids === undefined) {
                        throw new RequiredError('ids', 'Required parameter ids was null or undefined when calling getEntries.');
                    }
                    localVarPath = "/entries/{ids}"
                        .replace("{" + "ids" + "}", encodeURIComponent(String(ids)));
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * get entry
         * @summary get entry
         * @param {number} id EntryID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntry: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    if (id === null || id === undefined) {
                        throw new RequiredError('id', 'Required parameter id was null or undefined when calling getEntry.');
                    }
                    localVarPath = "/entry/{id}"
                        .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * patch entry
         * @summary patch entry
         * @param {number} id EntryID
         * @param {ModelEntry} body Entry
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntry: function (id, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    if (id === null || id === undefined) {
                        throw new RequiredError('id', 'Required parameter id was null or undefined when calling patchEntry.');
                    }
                    // verify required parameter 'body' is not null or undefined
                    if (body === null || body === undefined) {
                        throw new RequiredError('body', 'Required parameter body was null or undefined when calling patchEntry.');
                    }
                    localVarPath = "/entry/{id}"
                        .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                    localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * search entry by search conditions
         * @summary search entry
         * @param {string} [comment]
         * @param {number} [corporateID]
         * @param {string} [cursor]
         * @param {number} [customerID]
         * @param {string} [customerName]
         * @param {string} [endDateTime]
         * @param {string} [endDateTimeFrom]
         * @param {string} [endDateTimeTo]
         * @param {number} [id]
         * @param {number} [limit]
         * @param {number} [mainProductID]
         * @param {string} [mainProductName]
         * @param {number} [memberID]
         * @param {string} [memberName]
         * @param {string} [orderBy]
         * @param {number} [paymentMethod]
         * @param {number} [paymentStatus]
         * @param {number} [placeID]
         * @param {string} [placeName]
         * @param {Array<number>} [scheduleIDs]
         * @param {string} [startDateTime]
         * @param {string} [startDateTimeFrom]
         * @param {string} [startDateTimeTo]
         * @param {number} [status]
         * @param {number} [totalAmount]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchEntry: function (comment, corporateID, cursor, customerID, customerName, endDateTime, endDateTimeFrom, endDateTimeTo, id, limit, mainProductID, mainProductName, memberID, memberName, orderBy, paymentMethod, paymentStatus, placeID, placeName, scheduleIDs, startDateTime, startDateTimeFrom, startDateTimeTo, status, totalAmount, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/entries";
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (comment !== undefined) {
                        localVarQueryParameter['comment'] = comment;
                    }
                    if (corporateID !== undefined) {
                        localVarQueryParameter['corporateID'] = corporateID;
                    }
                    if (cursor !== undefined) {
                        localVarQueryParameter['cursor'] = cursor;
                    }
                    if (customerID !== undefined) {
                        localVarQueryParameter['customerID'] = customerID;
                    }
                    if (customerName !== undefined) {
                        localVarQueryParameter['customerName'] = customerName;
                    }
                    if (endDateTime !== undefined) {
                        localVarQueryParameter['endDateTime'] = endDateTime;
                    }
                    if (endDateTimeFrom !== undefined) {
                        localVarQueryParameter['endDateTimeFrom'] = endDateTimeFrom;
                    }
                    if (endDateTimeTo !== undefined) {
                        localVarQueryParameter['endDateTimeTo'] = endDateTimeTo;
                    }
                    if (id !== undefined) {
                        localVarQueryParameter['id'] = id;
                    }
                    if (limit !== undefined) {
                        localVarQueryParameter['limit'] = limit;
                    }
                    if (mainProductID !== undefined) {
                        localVarQueryParameter['mainProductID'] = mainProductID;
                    }
                    if (mainProductName !== undefined) {
                        localVarQueryParameter['mainProductName'] = mainProductName;
                    }
                    if (memberID !== undefined) {
                        localVarQueryParameter['memberID'] = memberID;
                    }
                    if (memberName !== undefined) {
                        localVarQueryParameter['memberName'] = memberName;
                    }
                    if (orderBy !== undefined) {
                        localVarQueryParameter['orderBy'] = orderBy;
                    }
                    if (paymentMethod !== undefined) {
                        localVarQueryParameter['paymentMethod'] = paymentMethod;
                    }
                    if (paymentStatus !== undefined) {
                        localVarQueryParameter['paymentStatus'] = paymentStatus;
                    }
                    if (placeID !== undefined) {
                        localVarQueryParameter['placeID'] = placeID;
                    }
                    if (placeName !== undefined) {
                        localVarQueryParameter['placeName'] = placeName;
                    }
                    if (scheduleIDs) {
                        localVarQueryParameter['scheduleIDs'] = scheduleIDs.join(COLLECTION_FORMATS.csv);
                    }
                    if (startDateTime !== undefined) {
                        localVarQueryParameter['startDateTime'] = startDateTime;
                    }
                    if (startDateTimeFrom !== undefined) {
                        localVarQueryParameter['startDateTimeFrom'] = startDateTimeFrom;
                    }
                    if (startDateTimeTo !== undefined) {
                        localVarQueryParameter['startDateTimeTo'] = startDateTimeTo;
                    }
                    if (status !== undefined) {
                        localVarQueryParameter['status'] = status;
                    }
                    if (totalAmount !== undefined) {
                        localVarQueryParameter['totalAmount'] = totalAmount;
                    }
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * update entry
         * @summary update entry
         * @param {number} id EntryID
         * @param {ModelEntry} body Entry
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntry: function (id, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    if (id === null || id === undefined) {
                        throw new RequiredError('id', 'Required parameter id was null or undefined when calling updateEntry.');
                    }
                    // verify required parameter 'body' is not null or undefined
                    if (body === null || body === undefined) {
                        throw new RequiredError('body', 'Required parameter body was null or undefined when calling updateEntry.');
                    }
                    localVarPath = "/entry/{id}"
                        .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                    localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
/**
 * EntryApi - functional programming interface
 * @export
 */
export var EntryApiFp = function (configuration) {
    return {
        /**
         * count entry by search conditions
         * @summary count entry
         * @param {string} [comment]
         * @param {number} [corporateID]
         * @param {string} [cursor]
         * @param {number} [customerID]
         * @param {string} [customerName]
         * @param {string} [endDateTime]
         * @param {string} [endDateTimeFrom]
         * @param {string} [endDateTimeTo]
         * @param {number} [id]
         * @param {number} [limit]
         * @param {number} [mainProductID]
         * @param {string} [mainProductName]
         * @param {number} [memberID]
         * @param {string} [memberName]
         * @param {string} [orderBy]
         * @param {number} [paymentMethod]
         * @param {number} [paymentStatus]
         * @param {number} [placeID]
         * @param {string} [placeName]
         * @param {Array<number>} [scheduleIDs]
         * @param {string} [startDateTime]
         * @param {string} [startDateTimeFrom]
         * @param {string} [startDateTimeTo]
         * @param {number} [status]
         * @param {number} [totalAmount]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countEntry: function (comment, corporateID, cursor, customerID, customerName, endDateTime, endDateTimeFrom, endDateTimeTo, id, limit, mainProductID, mainProductName, memberID, memberName, orderBy, paymentMethod, paymentStatus, placeID, placeName, scheduleIDs, startDateTime, startDateTimeFrom, startDateTimeTo, status, totalAmount, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, EntryApiAxiosParamCreator(configuration).countEntry(comment, corporateID, cursor, customerID, customerName, endDateTime, endDateTimeFrom, endDateTimeTo, id, limit, mainProductID, mainProductName, memberID, memberName, orderBy, paymentMethod, paymentStatus, placeID, placeName, scheduleIDs, startDateTime, startDateTimeFrom, startDateTimeTo, status, totalAmount, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * create entry
         * @summary create entry
         * @param {ModelEntry} body Entry
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntry: function (body, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, EntryApiAxiosParamCreator(configuration).createEntry(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * delete entry
         * @summary delete entry
         * @param {number} id EntryID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntry: function (id, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, EntryApiAxiosParamCreator(configuration).deleteEntry(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * get entries
         * @summary get entries
         * @param {string} ids Comma Separated EntryID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntries: function (ids, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, EntryApiAxiosParamCreator(configuration).getEntries(ids, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * get entry
         * @summary get entry
         * @param {number} id EntryID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntry: function (id, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, EntryApiAxiosParamCreator(configuration).getEntry(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * patch entry
         * @summary patch entry
         * @param {number} id EntryID
         * @param {ModelEntry} body Entry
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntry: function (id, body, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, EntryApiAxiosParamCreator(configuration).patchEntry(id, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * search entry by search conditions
         * @summary search entry
         * @param {string} [comment]
         * @param {number} [corporateID]
         * @param {string} [cursor]
         * @param {number} [customerID]
         * @param {string} [customerName]
         * @param {string} [endDateTime]
         * @param {string} [endDateTimeFrom]
         * @param {string} [endDateTimeTo]
         * @param {number} [id]
         * @param {number} [limit]
         * @param {number} [mainProductID]
         * @param {string} [mainProductName]
         * @param {number} [memberID]
         * @param {string} [memberName]
         * @param {string} [orderBy]
         * @param {number} [paymentMethod]
         * @param {number} [paymentStatus]
         * @param {number} [placeID]
         * @param {string} [placeName]
         * @param {Array<number>} [scheduleIDs]
         * @param {string} [startDateTime]
         * @param {string} [startDateTimeFrom]
         * @param {string} [startDateTimeTo]
         * @param {number} [status]
         * @param {number} [totalAmount]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchEntry: function (comment, corporateID, cursor, customerID, customerName, endDateTime, endDateTimeFrom, endDateTimeTo, id, limit, mainProductID, mainProductName, memberID, memberName, orderBy, paymentMethod, paymentStatus, placeID, placeName, scheduleIDs, startDateTime, startDateTimeFrom, startDateTimeTo, status, totalAmount, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, EntryApiAxiosParamCreator(configuration).searchEntry(comment, corporateID, cursor, customerID, customerName, endDateTime, endDateTimeFrom, endDateTimeTo, id, limit, mainProductID, mainProductName, memberID, memberName, orderBy, paymentMethod, paymentStatus, placeID, placeName, scheduleIDs, startDateTime, startDateTimeFrom, startDateTimeTo, status, totalAmount, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * update entry
         * @summary update entry
         * @param {number} id EntryID
         * @param {ModelEntry} body Entry
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntry: function (id, body, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, EntryApiAxiosParamCreator(configuration).updateEntry(id, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
    };
};
/**
 * EntryApi - factory interface
 * @export
 */
export var EntryApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         * count entry by search conditions
         * @summary count entry
         * @param {string} [comment]
         * @param {number} [corporateID]
         * @param {string} [cursor]
         * @param {number} [customerID]
         * @param {string} [customerName]
         * @param {string} [endDateTime]
         * @param {string} [endDateTimeFrom]
         * @param {string} [endDateTimeTo]
         * @param {number} [id]
         * @param {number} [limit]
         * @param {number} [mainProductID]
         * @param {string} [mainProductName]
         * @param {number} [memberID]
         * @param {string} [memberName]
         * @param {string} [orderBy]
         * @param {number} [paymentMethod]
         * @param {number} [paymentStatus]
         * @param {number} [placeID]
         * @param {string} [placeName]
         * @param {Array<number>} [scheduleIDs]
         * @param {string} [startDateTime]
         * @param {string} [startDateTimeFrom]
         * @param {string} [startDateTimeTo]
         * @param {number} [status]
         * @param {number} [totalAmount]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countEntry: function (comment, corporateID, cursor, customerID, customerName, endDateTime, endDateTimeFrom, endDateTimeTo, id, limit, mainProductID, mainProductName, memberID, memberName, orderBy, paymentMethod, paymentStatus, placeID, placeName, scheduleIDs, startDateTime, startDateTimeFrom, startDateTimeTo, status, totalAmount, options) {
            return EntryApiFp(configuration).countEntry(comment, corporateID, cursor, customerID, customerName, endDateTime, endDateTimeFrom, endDateTimeTo, id, limit, mainProductID, mainProductName, memberID, memberName, orderBy, paymentMethod, paymentStatus, placeID, placeName, scheduleIDs, startDateTime, startDateTimeFrom, startDateTimeTo, status, totalAmount, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * create entry
         * @summary create entry
         * @param {ModelEntry} body Entry
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEntry: function (body, options) {
            return EntryApiFp(configuration).createEntry(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * delete entry
         * @summary delete entry
         * @param {number} id EntryID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntry: function (id, options) {
            return EntryApiFp(configuration).deleteEntry(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * get entries
         * @summary get entries
         * @param {string} ids Comma Separated EntryID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntries: function (ids, options) {
            return EntryApiFp(configuration).getEntries(ids, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * get entry
         * @summary get entry
         * @param {number} id EntryID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntry: function (id, options) {
            return EntryApiFp(configuration).getEntry(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * patch entry
         * @summary patch entry
         * @param {number} id EntryID
         * @param {ModelEntry} body Entry
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchEntry: function (id, body, options) {
            return EntryApiFp(configuration).patchEntry(id, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * search entry by search conditions
         * @summary search entry
         * @param {string} [comment]
         * @param {number} [corporateID]
         * @param {string} [cursor]
         * @param {number} [customerID]
         * @param {string} [customerName]
         * @param {string} [endDateTime]
         * @param {string} [endDateTimeFrom]
         * @param {string} [endDateTimeTo]
         * @param {number} [id]
         * @param {number} [limit]
         * @param {number} [mainProductID]
         * @param {string} [mainProductName]
         * @param {number} [memberID]
         * @param {string} [memberName]
         * @param {string} [orderBy]
         * @param {number} [paymentMethod]
         * @param {number} [paymentStatus]
         * @param {number} [placeID]
         * @param {string} [placeName]
         * @param {Array<number>} [scheduleIDs]
         * @param {string} [startDateTime]
         * @param {string} [startDateTimeFrom]
         * @param {string} [startDateTimeTo]
         * @param {number} [status]
         * @param {number} [totalAmount]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchEntry: function (comment, corporateID, cursor, customerID, customerName, endDateTime, endDateTimeFrom, endDateTimeTo, id, limit, mainProductID, mainProductName, memberID, memberName, orderBy, paymentMethod, paymentStatus, placeID, placeName, scheduleIDs, startDateTime, startDateTimeFrom, startDateTimeTo, status, totalAmount, options) {
            return EntryApiFp(configuration).searchEntry(comment, corporateID, cursor, customerID, customerName, endDateTime, endDateTimeFrom, endDateTimeTo, id, limit, mainProductID, mainProductName, memberID, memberName, orderBy, paymentMethod, paymentStatus, placeID, placeName, scheduleIDs, startDateTime, startDateTimeFrom, startDateTimeTo, status, totalAmount, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * update entry
         * @summary update entry
         * @param {number} id EntryID
         * @param {ModelEntry} body Entry
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEntry: function (id, body, options) {
            return EntryApiFp(configuration).updateEntry(id, body, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * EntryApi - object-oriented interface
 * @export
 * @class EntryApi
 * @extends {BaseAPI}
 */
var EntryApi = /** @class */ (function (_super) {
    __extends(EntryApi, _super);
    function EntryApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * count entry by search conditions
     * @summary count entry
     * @param {EntryApiCountEntryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntryApi
     */
    EntryApi.prototype.countEntry = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return EntryApiFp(this.configuration).countEntry(requestParameters.comment, requestParameters.corporateID, requestParameters.cursor, requestParameters.customerID, requestParameters.customerName, requestParameters.endDateTime, requestParameters.endDateTimeFrom, requestParameters.endDateTimeTo, requestParameters.id, requestParameters.limit, requestParameters.mainProductID, requestParameters.mainProductName, requestParameters.memberID, requestParameters.memberName, requestParameters.orderBy, requestParameters.paymentMethod, requestParameters.paymentStatus, requestParameters.placeID, requestParameters.placeName, requestParameters.scheduleIDs, requestParameters.startDateTime, requestParameters.startDateTimeFrom, requestParameters.startDateTimeTo, requestParameters.status, requestParameters.totalAmount, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * create entry
     * @summary create entry
     * @param {EntryApiCreateEntryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntryApi
     */
    EntryApi.prototype.createEntry = function (requestParameters, options) {
        var _this = this;
        return EntryApiFp(this.configuration).createEntry(requestParameters.body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * delete entry
     * @summary delete entry
     * @param {EntryApiDeleteEntryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntryApi
     */
    EntryApi.prototype.deleteEntry = function (requestParameters, options) {
        var _this = this;
        return EntryApiFp(this.configuration).deleteEntry(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * get entries
     * @summary get entries
     * @param {EntryApiGetEntriesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntryApi
     */
    EntryApi.prototype.getEntries = function (requestParameters, options) {
        var _this = this;
        return EntryApiFp(this.configuration).getEntries(requestParameters.ids, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * get entry
     * @summary get entry
     * @param {EntryApiGetEntryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntryApi
     */
    EntryApi.prototype.getEntry = function (requestParameters, options) {
        var _this = this;
        return EntryApiFp(this.configuration).getEntry(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * patch entry
     * @summary patch entry
     * @param {EntryApiPatchEntryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntryApi
     */
    EntryApi.prototype.patchEntry = function (requestParameters, options) {
        var _this = this;
        return EntryApiFp(this.configuration).patchEntry(requestParameters.id, requestParameters.body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * search entry by search conditions
     * @summary search entry
     * @param {EntryApiSearchEntryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntryApi
     */
    EntryApi.prototype.searchEntry = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return EntryApiFp(this.configuration).searchEntry(requestParameters.comment, requestParameters.corporateID, requestParameters.cursor, requestParameters.customerID, requestParameters.customerName, requestParameters.endDateTime, requestParameters.endDateTimeFrom, requestParameters.endDateTimeTo, requestParameters.id, requestParameters.limit, requestParameters.mainProductID, requestParameters.mainProductName, requestParameters.memberID, requestParameters.memberName, requestParameters.orderBy, requestParameters.paymentMethod, requestParameters.paymentStatus, requestParameters.placeID, requestParameters.placeName, requestParameters.scheduleIDs, requestParameters.startDateTime, requestParameters.startDateTimeFrom, requestParameters.startDateTimeTo, requestParameters.status, requestParameters.totalAmount, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * update entry
     * @summary update entry
     * @param {EntryApiUpdateEntryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntryApi
     */
    EntryApi.prototype.updateEntry = function (requestParameters, options) {
        var _this = this;
        return EntryApiFp(this.configuration).updateEntry(requestParameters.id, requestParameters.body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return EntryApi;
}(BaseAPI));
export { EntryApi };
/**
 * FeeApi - axios parameter creator
 * @export
 */
export var FeeApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * count fee by search conditions
         * @summary count fee
         * @param {number} [commissionAmount]
         * @param {number} [corporateID]
         * @param {string} [cursor]
         * @param {number} [entryID]
         * @param {string} [expectedPaymentDate]
         * @param {number} [feeAmount]
         * @param {number} [id]
         * @param {number} [limit]
         * @param {number} [memberID]
         * @param {string} [orderBy]
         * @param {string} [paymentedAt]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countFee: function (commissionAmount, corporateID, cursor, entryID, expectedPaymentDate, feeAmount, id, limit, memberID, orderBy, paymentedAt, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/fees/count";
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (commissionAmount !== undefined) {
                        localVarQueryParameter['commissionAmount'] = commissionAmount;
                    }
                    if (corporateID !== undefined) {
                        localVarQueryParameter['corporateID'] = corporateID;
                    }
                    if (cursor !== undefined) {
                        localVarQueryParameter['cursor'] = cursor;
                    }
                    if (entryID !== undefined) {
                        localVarQueryParameter['entryID'] = entryID;
                    }
                    if (expectedPaymentDate !== undefined) {
                        localVarQueryParameter['expectedPaymentDate'] = expectedPaymentDate;
                    }
                    if (feeAmount !== undefined) {
                        localVarQueryParameter['feeAmount'] = feeAmount;
                    }
                    if (id !== undefined) {
                        localVarQueryParameter['id'] = id;
                    }
                    if (limit !== undefined) {
                        localVarQueryParameter['limit'] = limit;
                    }
                    if (memberID !== undefined) {
                        localVarQueryParameter['memberID'] = memberID;
                    }
                    if (orderBy !== undefined) {
                        localVarQueryParameter['orderBy'] = orderBy;
                    }
                    if (paymentedAt !== undefined) {
                        localVarQueryParameter['paymentedAt'] = paymentedAt;
                    }
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * create fee
         * @summary create fee
         * @param {ModelFee} body Fee
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFee: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    if (body === null || body === undefined) {
                        throw new RequiredError('body', 'Required parameter body was null or undefined when calling createFee.');
                    }
                    localVarPath = "/fee";
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                    localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * delete fee
         * @summary delete fee
         * @param {number} id FeeID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFee: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    if (id === null || id === undefined) {
                        throw new RequiredError('id', 'Required parameter id was null or undefined when calling deleteFee.');
                    }
                    localVarPath = "/fee/{id}"
                        .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * get fee
         * @summary get fee
         * @param {number} id FeeID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFee: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    if (id === null || id === undefined) {
                        throw new RequiredError('id', 'Required parameter id was null or undefined when calling getFee.');
                    }
                    localVarPath = "/fee/{id}"
                        .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * get fees
         * @summary get fees
         * @param {string} ids Comma Separated FeeID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFees: function (ids, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'ids' is not null or undefined
                    if (ids === null || ids === undefined) {
                        throw new RequiredError('ids', 'Required parameter ids was null or undefined when calling getFees.');
                    }
                    localVarPath = "/fees/{ids}"
                        .replace("{" + "ids" + "}", encodeURIComponent(String(ids)));
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * patch fee
         * @summary patch fee
         * @param {number} id FeeID
         * @param {ModelFee} body Fee
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchFee: function (id, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    if (id === null || id === undefined) {
                        throw new RequiredError('id', 'Required parameter id was null or undefined when calling patchFee.');
                    }
                    // verify required parameter 'body' is not null or undefined
                    if (body === null || body === undefined) {
                        throw new RequiredError('body', 'Required parameter body was null or undefined when calling patchFee.');
                    }
                    localVarPath = "/fee/{id}"
                        .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                    localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * search fee by search conditions
         * @summary search fee
         * @param {number} [commissionAmount]
         * @param {number} [corporateID]
         * @param {string} [cursor]
         * @param {number} [entryID]
         * @param {string} [expectedPaymentDate]
         * @param {number} [feeAmount]
         * @param {number} [id]
         * @param {number} [limit]
         * @param {number} [memberID]
         * @param {string} [orderBy]
         * @param {string} [paymentedAt]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchFee: function (commissionAmount, corporateID, cursor, entryID, expectedPaymentDate, feeAmount, id, limit, memberID, orderBy, paymentedAt, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/fees";
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (commissionAmount !== undefined) {
                        localVarQueryParameter['commissionAmount'] = commissionAmount;
                    }
                    if (corporateID !== undefined) {
                        localVarQueryParameter['corporateID'] = corporateID;
                    }
                    if (cursor !== undefined) {
                        localVarQueryParameter['cursor'] = cursor;
                    }
                    if (entryID !== undefined) {
                        localVarQueryParameter['entryID'] = entryID;
                    }
                    if (expectedPaymentDate !== undefined) {
                        localVarQueryParameter['expectedPaymentDate'] = expectedPaymentDate;
                    }
                    if (feeAmount !== undefined) {
                        localVarQueryParameter['feeAmount'] = feeAmount;
                    }
                    if (id !== undefined) {
                        localVarQueryParameter['id'] = id;
                    }
                    if (limit !== undefined) {
                        localVarQueryParameter['limit'] = limit;
                    }
                    if (memberID !== undefined) {
                        localVarQueryParameter['memberID'] = memberID;
                    }
                    if (orderBy !== undefined) {
                        localVarQueryParameter['orderBy'] = orderBy;
                    }
                    if (paymentedAt !== undefined) {
                        localVarQueryParameter['paymentedAt'] = paymentedAt;
                    }
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * update fee
         * @summary update fee
         * @param {number} id FeeID
         * @param {ModelFee} body Fee
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFee: function (id, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    if (id === null || id === undefined) {
                        throw new RequiredError('id', 'Required parameter id was null or undefined when calling updateFee.');
                    }
                    // verify required parameter 'body' is not null or undefined
                    if (body === null || body === undefined) {
                        throw new RequiredError('body', 'Required parameter body was null or undefined when calling updateFee.');
                    }
                    localVarPath = "/fee/{id}"
                        .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                    localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
/**
 * FeeApi - functional programming interface
 * @export
 */
export var FeeApiFp = function (configuration) {
    return {
        /**
         * count fee by search conditions
         * @summary count fee
         * @param {number} [commissionAmount]
         * @param {number} [corporateID]
         * @param {string} [cursor]
         * @param {number} [entryID]
         * @param {string} [expectedPaymentDate]
         * @param {number} [feeAmount]
         * @param {number} [id]
         * @param {number} [limit]
         * @param {number} [memberID]
         * @param {string} [orderBy]
         * @param {string} [paymentedAt]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countFee: function (commissionAmount, corporateID, cursor, entryID, expectedPaymentDate, feeAmount, id, limit, memberID, orderBy, paymentedAt, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, FeeApiAxiosParamCreator(configuration).countFee(commissionAmount, corporateID, cursor, entryID, expectedPaymentDate, feeAmount, id, limit, memberID, orderBy, paymentedAt, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * create fee
         * @summary create fee
         * @param {ModelFee} body Fee
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFee: function (body, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, FeeApiAxiosParamCreator(configuration).createFee(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * delete fee
         * @summary delete fee
         * @param {number} id FeeID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFee: function (id, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, FeeApiAxiosParamCreator(configuration).deleteFee(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * get fee
         * @summary get fee
         * @param {number} id FeeID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFee: function (id, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, FeeApiAxiosParamCreator(configuration).getFee(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * get fees
         * @summary get fees
         * @param {string} ids Comma Separated FeeID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFees: function (ids, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, FeeApiAxiosParamCreator(configuration).getFees(ids, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * patch fee
         * @summary patch fee
         * @param {number} id FeeID
         * @param {ModelFee} body Fee
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchFee: function (id, body, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, FeeApiAxiosParamCreator(configuration).patchFee(id, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * search fee by search conditions
         * @summary search fee
         * @param {number} [commissionAmount]
         * @param {number} [corporateID]
         * @param {string} [cursor]
         * @param {number} [entryID]
         * @param {string} [expectedPaymentDate]
         * @param {number} [feeAmount]
         * @param {number} [id]
         * @param {number} [limit]
         * @param {number} [memberID]
         * @param {string} [orderBy]
         * @param {string} [paymentedAt]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchFee: function (commissionAmount, corporateID, cursor, entryID, expectedPaymentDate, feeAmount, id, limit, memberID, orderBy, paymentedAt, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, FeeApiAxiosParamCreator(configuration).searchFee(commissionAmount, corporateID, cursor, entryID, expectedPaymentDate, feeAmount, id, limit, memberID, orderBy, paymentedAt, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * update fee
         * @summary update fee
         * @param {number} id FeeID
         * @param {ModelFee} body Fee
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFee: function (id, body, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, FeeApiAxiosParamCreator(configuration).updateFee(id, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
    };
};
/**
 * FeeApi - factory interface
 * @export
 */
export var FeeApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         * count fee by search conditions
         * @summary count fee
         * @param {number} [commissionAmount]
         * @param {number} [corporateID]
         * @param {string} [cursor]
         * @param {number} [entryID]
         * @param {string} [expectedPaymentDate]
         * @param {number} [feeAmount]
         * @param {number} [id]
         * @param {number} [limit]
         * @param {number} [memberID]
         * @param {string} [orderBy]
         * @param {string} [paymentedAt]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countFee: function (commissionAmount, corporateID, cursor, entryID, expectedPaymentDate, feeAmount, id, limit, memberID, orderBy, paymentedAt, options) {
            return FeeApiFp(configuration).countFee(commissionAmount, corporateID, cursor, entryID, expectedPaymentDate, feeAmount, id, limit, memberID, orderBy, paymentedAt, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * create fee
         * @summary create fee
         * @param {ModelFee} body Fee
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFee: function (body, options) {
            return FeeApiFp(configuration).createFee(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * delete fee
         * @summary delete fee
         * @param {number} id FeeID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFee: function (id, options) {
            return FeeApiFp(configuration).deleteFee(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * get fee
         * @summary get fee
         * @param {number} id FeeID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFee: function (id, options) {
            return FeeApiFp(configuration).getFee(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * get fees
         * @summary get fees
         * @param {string} ids Comma Separated FeeID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFees: function (ids, options) {
            return FeeApiFp(configuration).getFees(ids, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * patch fee
         * @summary patch fee
         * @param {number} id FeeID
         * @param {ModelFee} body Fee
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchFee: function (id, body, options) {
            return FeeApiFp(configuration).patchFee(id, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * search fee by search conditions
         * @summary search fee
         * @param {number} [commissionAmount]
         * @param {number} [corporateID]
         * @param {string} [cursor]
         * @param {number} [entryID]
         * @param {string} [expectedPaymentDate]
         * @param {number} [feeAmount]
         * @param {number} [id]
         * @param {number} [limit]
         * @param {number} [memberID]
         * @param {string} [orderBy]
         * @param {string} [paymentedAt]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchFee: function (commissionAmount, corporateID, cursor, entryID, expectedPaymentDate, feeAmount, id, limit, memberID, orderBy, paymentedAt, options) {
            return FeeApiFp(configuration).searchFee(commissionAmount, corporateID, cursor, entryID, expectedPaymentDate, feeAmount, id, limit, memberID, orderBy, paymentedAt, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * update fee
         * @summary update fee
         * @param {number} id FeeID
         * @param {ModelFee} body Fee
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFee: function (id, body, options) {
            return FeeApiFp(configuration).updateFee(id, body, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * FeeApi - object-oriented interface
 * @export
 * @class FeeApi
 * @extends {BaseAPI}
 */
var FeeApi = /** @class */ (function (_super) {
    __extends(FeeApi, _super);
    function FeeApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * count fee by search conditions
     * @summary count fee
     * @param {FeeApiCountFeeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeeApi
     */
    FeeApi.prototype.countFee = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return FeeApiFp(this.configuration).countFee(requestParameters.commissionAmount, requestParameters.corporateID, requestParameters.cursor, requestParameters.entryID, requestParameters.expectedPaymentDate, requestParameters.feeAmount, requestParameters.id, requestParameters.limit, requestParameters.memberID, requestParameters.orderBy, requestParameters.paymentedAt, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * create fee
     * @summary create fee
     * @param {FeeApiCreateFeeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeeApi
     */
    FeeApi.prototype.createFee = function (requestParameters, options) {
        var _this = this;
        return FeeApiFp(this.configuration).createFee(requestParameters.body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * delete fee
     * @summary delete fee
     * @param {FeeApiDeleteFeeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeeApi
     */
    FeeApi.prototype.deleteFee = function (requestParameters, options) {
        var _this = this;
        return FeeApiFp(this.configuration).deleteFee(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * get fee
     * @summary get fee
     * @param {FeeApiGetFeeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeeApi
     */
    FeeApi.prototype.getFee = function (requestParameters, options) {
        var _this = this;
        return FeeApiFp(this.configuration).getFee(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * get fees
     * @summary get fees
     * @param {FeeApiGetFeesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeeApi
     */
    FeeApi.prototype.getFees = function (requestParameters, options) {
        var _this = this;
        return FeeApiFp(this.configuration).getFees(requestParameters.ids, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * patch fee
     * @summary patch fee
     * @param {FeeApiPatchFeeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeeApi
     */
    FeeApi.prototype.patchFee = function (requestParameters, options) {
        var _this = this;
        return FeeApiFp(this.configuration).patchFee(requestParameters.id, requestParameters.body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * search fee by search conditions
     * @summary search fee
     * @param {FeeApiSearchFeeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeeApi
     */
    FeeApi.prototype.searchFee = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return FeeApiFp(this.configuration).searchFee(requestParameters.commissionAmount, requestParameters.corporateID, requestParameters.cursor, requestParameters.entryID, requestParameters.expectedPaymentDate, requestParameters.feeAmount, requestParameters.id, requestParameters.limit, requestParameters.memberID, requestParameters.orderBy, requestParameters.paymentedAt, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * update fee
     * @summary update fee
     * @param {FeeApiUpdateFeeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeeApi
     */
    FeeApi.prototype.updateFee = function (requestParameters, options) {
        var _this = this;
        return FeeApiFp(this.configuration).updateFee(requestParameters.id, requestParameters.body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return FeeApi;
}(BaseAPI));
export { FeeApi };
/**
 * ImageApi - axios parameter creator
 * @export
 */
export var ImageApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * upload image
         * @summary upload image
         * @param {string} name image name
         * @param {string} dir save directory
         * @param {boolean} thumbnail make thumbnail
         * @param {any} image raw image
         * @param {number} [resize] resize size
         * @param {number} [thumbnailSize] thumbnail size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadImage: function (name, dir, thumbnail, image, resize, thumbnailSize, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarFormParams, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'name' is not null or undefined
                    if (name === null || name === undefined) {
                        throw new RequiredError('name', 'Required parameter name was null or undefined when calling uploadImage.');
                    }
                    // verify required parameter 'dir' is not null or undefined
                    if (dir === null || dir === undefined) {
                        throw new RequiredError('dir', 'Required parameter dir was null or undefined when calling uploadImage.');
                    }
                    // verify required parameter 'thumbnail' is not null or undefined
                    if (thumbnail === null || thumbnail === undefined) {
                        throw new RequiredError('thumbnail', 'Required parameter thumbnail was null or undefined when calling uploadImage.');
                    }
                    // verify required parameter 'image' is not null or undefined
                    if (image === null || image === undefined) {
                        throw new RequiredError('image', 'Required parameter image was null or undefined when calling uploadImage.');
                    }
                    localVarPath = "/image";
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarFormParams = new FormData();
                    if (name !== undefined) {
                        localVarFormParams.append('name', name);
                    }
                    if (dir !== undefined) {
                        localVarFormParams.append('dir', dir);
                    }
                    if (resize !== undefined) {
                        localVarFormParams.append('resize', resize);
                    }
                    if (thumbnail !== undefined) {
                        localVarFormParams.append('thumbnail', thumbnail);
                    }
                    if (thumbnailSize !== undefined) {
                        localVarFormParams.append('thumbnailSize', thumbnailSize);
                    }
                    if (image !== undefined) {
                        localVarFormParams.append('image', image);
                    }
                    localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = localVarFormParams;
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
/**
 * ImageApi - functional programming interface
 * @export
 */
export var ImageApiFp = function (configuration) {
    return {
        /**
         * upload image
         * @summary upload image
         * @param {string} name image name
         * @param {string} dir save directory
         * @param {boolean} thumbnail make thumbnail
         * @param {any} image raw image
         * @param {number} [resize] resize size
         * @param {number} [thumbnailSize] thumbnail size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadImage: function (name, dir, thumbnail, image, resize, thumbnailSize, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, ImageApiAxiosParamCreator(configuration).uploadImage(name, dir, thumbnail, image, resize, thumbnailSize, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
    };
};
/**
 * ImageApi - factory interface
 * @export
 */
export var ImageApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         * upload image
         * @summary upload image
         * @param {string} name image name
         * @param {string} dir save directory
         * @param {boolean} thumbnail make thumbnail
         * @param {any} image raw image
         * @param {number} [resize] resize size
         * @param {number} [thumbnailSize] thumbnail size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadImage: function (name, dir, thumbnail, image, resize, thumbnailSize, options) {
            return ImageApiFp(configuration).uploadImage(name, dir, thumbnail, image, resize, thumbnailSize, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * ImageApi - object-oriented interface
 * @export
 * @class ImageApi
 * @extends {BaseAPI}
 */
var ImageApi = /** @class */ (function (_super) {
    __extends(ImageApi, _super);
    function ImageApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * upload image
     * @summary upload image
     * @param {ImageApiUploadImageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImageApi
     */
    ImageApi.prototype.uploadImage = function (requestParameters, options) {
        var _this = this;
        return ImageApiFp(this.configuration).uploadImage(requestParameters.name, requestParameters.dir, requestParameters.thumbnail, requestParameters.image, requestParameters.resize, requestParameters.thumbnailSize, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ImageApi;
}(BaseAPI));
export { ImageApi };
/**
 * MemberApi - axios parameter creator
 * @export
 */
export var MemberApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * count member by search conditions
         * @summary count member
         * @param {number} [corporateID]
         * @param {string} [cursor]
         * @param {number} [id]
         * @param {number} [limit]
         * @param {string} [name]
         * @param {string} [orderBy]
         * @param {string} [photo]
         * @param {string} [profile]
         * @param {number} [roleType]
         * @param {string} [userID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countMember: function (corporateID, cursor, id, limit, name, orderBy, photo, profile, roleType, userID, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/members/count";
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (corporateID !== undefined) {
                        localVarQueryParameter['corporateID'] = corporateID;
                    }
                    if (cursor !== undefined) {
                        localVarQueryParameter['cursor'] = cursor;
                    }
                    if (id !== undefined) {
                        localVarQueryParameter['id'] = id;
                    }
                    if (limit !== undefined) {
                        localVarQueryParameter['limit'] = limit;
                    }
                    if (name !== undefined) {
                        localVarQueryParameter['name'] = name;
                    }
                    if (orderBy !== undefined) {
                        localVarQueryParameter['orderBy'] = orderBy;
                    }
                    if (photo !== undefined) {
                        localVarQueryParameter['photo'] = photo;
                    }
                    if (profile !== undefined) {
                        localVarQueryParameter['profile'] = profile;
                    }
                    if (roleType !== undefined) {
                        localVarQueryParameter['roleType'] = roleType;
                    }
                    if (userID !== undefined) {
                        localVarQueryParameter['userID'] = userID;
                    }
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * create member
         * @summary create member
         * @param {ModelMember} body Member
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMember: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    if (body === null || body === undefined) {
                        throw new RequiredError('body', 'Required parameter body was null or undefined when calling createMember.');
                    }
                    localVarPath = "/member";
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                    localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * delete member
         * @summary delete member
         * @param {number} id MemberID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMember: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    if (id === null || id === undefined) {
                        throw new RequiredError('id', 'Required parameter id was null or undefined when calling deleteMember.');
                    }
                    localVarPath = "/member/{id}"
                        .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * get member
         * @summary get member
         * @param {number} id MemberID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMember: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    if (id === null || id === undefined) {
                        throw new RequiredError('id', 'Required parameter id was null or undefined when calling getMember.');
                    }
                    localVarPath = "/member/{id}"
                        .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * get members
         * @summary get members
         * @param {string} ids Comma Separated MemberID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMembers: function (ids, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'ids' is not null or undefined
                    if (ids === null || ids === undefined) {
                        throw new RequiredError('ids', 'Required parameter ids was null or undefined when calling getMembers.');
                    }
                    localVarPath = "/members/{ids}"
                        .replace("{" + "ids" + "}", encodeURIComponent(String(ids)));
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * patch member
         * @summary patch member
         * @param {number} id MemberID
         * @param {ModelMember} body Member
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchMember: function (id, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    if (id === null || id === undefined) {
                        throw new RequiredError('id', 'Required parameter id was null or undefined when calling patchMember.');
                    }
                    // verify required parameter 'body' is not null or undefined
                    if (body === null || body === undefined) {
                        throw new RequiredError('body', 'Required parameter body was null or undefined when calling patchMember.');
                    }
                    localVarPath = "/member/{id}"
                        .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                    localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * search member by search conditions
         * @summary search member
         * @param {number} [corporateID]
         * @param {string} [cursor]
         * @param {number} [id]
         * @param {number} [limit]
         * @param {string} [name]
         * @param {string} [orderBy]
         * @param {string} [photo]
         * @param {string} [profile]
         * @param {number} [roleType]
         * @param {string} [userID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchMember: function (corporateID, cursor, id, limit, name, orderBy, photo, profile, roleType, userID, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/members";
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (corporateID !== undefined) {
                        localVarQueryParameter['corporateID'] = corporateID;
                    }
                    if (cursor !== undefined) {
                        localVarQueryParameter['cursor'] = cursor;
                    }
                    if (id !== undefined) {
                        localVarQueryParameter['id'] = id;
                    }
                    if (limit !== undefined) {
                        localVarQueryParameter['limit'] = limit;
                    }
                    if (name !== undefined) {
                        localVarQueryParameter['name'] = name;
                    }
                    if (orderBy !== undefined) {
                        localVarQueryParameter['orderBy'] = orderBy;
                    }
                    if (photo !== undefined) {
                        localVarQueryParameter['photo'] = photo;
                    }
                    if (profile !== undefined) {
                        localVarQueryParameter['profile'] = profile;
                    }
                    if (roleType !== undefined) {
                        localVarQueryParameter['roleType'] = roleType;
                    }
                    if (userID !== undefined) {
                        localVarQueryParameter['userID'] = userID;
                    }
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * update member
         * @summary update member
         * @param {number} id MemberID
         * @param {ModelMember} body Member
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMember: function (id, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    if (id === null || id === undefined) {
                        throw new RequiredError('id', 'Required parameter id was null or undefined when calling updateMember.');
                    }
                    // verify required parameter 'body' is not null or undefined
                    if (body === null || body === undefined) {
                        throw new RequiredError('body', 'Required parameter body was null or undefined when calling updateMember.');
                    }
                    localVarPath = "/member/{id}"
                        .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                    localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
/**
 * MemberApi - functional programming interface
 * @export
 */
export var MemberApiFp = function (configuration) {
    return {
        /**
         * count member by search conditions
         * @summary count member
         * @param {number} [corporateID]
         * @param {string} [cursor]
         * @param {number} [id]
         * @param {number} [limit]
         * @param {string} [name]
         * @param {string} [orderBy]
         * @param {string} [photo]
         * @param {string} [profile]
         * @param {number} [roleType]
         * @param {string} [userID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countMember: function (corporateID, cursor, id, limit, name, orderBy, photo, profile, roleType, userID, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, MemberApiAxiosParamCreator(configuration).countMember(corporateID, cursor, id, limit, name, orderBy, photo, profile, roleType, userID, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * create member
         * @summary create member
         * @param {ModelMember} body Member
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMember: function (body, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, MemberApiAxiosParamCreator(configuration).createMember(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * delete member
         * @summary delete member
         * @param {number} id MemberID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMember: function (id, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, MemberApiAxiosParamCreator(configuration).deleteMember(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * get member
         * @summary get member
         * @param {number} id MemberID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMember: function (id, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, MemberApiAxiosParamCreator(configuration).getMember(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * get members
         * @summary get members
         * @param {string} ids Comma Separated MemberID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMembers: function (ids, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, MemberApiAxiosParamCreator(configuration).getMembers(ids, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * patch member
         * @summary patch member
         * @param {number} id MemberID
         * @param {ModelMember} body Member
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchMember: function (id, body, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, MemberApiAxiosParamCreator(configuration).patchMember(id, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * search member by search conditions
         * @summary search member
         * @param {number} [corporateID]
         * @param {string} [cursor]
         * @param {number} [id]
         * @param {number} [limit]
         * @param {string} [name]
         * @param {string} [orderBy]
         * @param {string} [photo]
         * @param {string} [profile]
         * @param {number} [roleType]
         * @param {string} [userID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchMember: function (corporateID, cursor, id, limit, name, orderBy, photo, profile, roleType, userID, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, MemberApiAxiosParamCreator(configuration).searchMember(corporateID, cursor, id, limit, name, orderBy, photo, profile, roleType, userID, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * update member
         * @summary update member
         * @param {number} id MemberID
         * @param {ModelMember} body Member
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMember: function (id, body, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, MemberApiAxiosParamCreator(configuration).updateMember(id, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
    };
};
/**
 * MemberApi - factory interface
 * @export
 */
export var MemberApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         * count member by search conditions
         * @summary count member
         * @param {number} [corporateID]
         * @param {string} [cursor]
         * @param {number} [id]
         * @param {number} [limit]
         * @param {string} [name]
         * @param {string} [orderBy]
         * @param {string} [photo]
         * @param {string} [profile]
         * @param {number} [roleType]
         * @param {string} [userID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countMember: function (corporateID, cursor, id, limit, name, orderBy, photo, profile, roleType, userID, options) {
            return MemberApiFp(configuration).countMember(corporateID, cursor, id, limit, name, orderBy, photo, profile, roleType, userID, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * create member
         * @summary create member
         * @param {ModelMember} body Member
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMember: function (body, options) {
            return MemberApiFp(configuration).createMember(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * delete member
         * @summary delete member
         * @param {number} id MemberID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMember: function (id, options) {
            return MemberApiFp(configuration).deleteMember(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * get member
         * @summary get member
         * @param {number} id MemberID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMember: function (id, options) {
            return MemberApiFp(configuration).getMember(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * get members
         * @summary get members
         * @param {string} ids Comma Separated MemberID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMembers: function (ids, options) {
            return MemberApiFp(configuration).getMembers(ids, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * patch member
         * @summary patch member
         * @param {number} id MemberID
         * @param {ModelMember} body Member
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchMember: function (id, body, options) {
            return MemberApiFp(configuration).patchMember(id, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * search member by search conditions
         * @summary search member
         * @param {number} [corporateID]
         * @param {string} [cursor]
         * @param {number} [id]
         * @param {number} [limit]
         * @param {string} [name]
         * @param {string} [orderBy]
         * @param {string} [photo]
         * @param {string} [profile]
         * @param {number} [roleType]
         * @param {string} [userID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchMember: function (corporateID, cursor, id, limit, name, orderBy, photo, profile, roleType, userID, options) {
            return MemberApiFp(configuration).searchMember(corporateID, cursor, id, limit, name, orderBy, photo, profile, roleType, userID, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * update member
         * @summary update member
         * @param {number} id MemberID
         * @param {ModelMember} body Member
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMember: function (id, body, options) {
            return MemberApiFp(configuration).updateMember(id, body, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * MemberApi - object-oriented interface
 * @export
 * @class MemberApi
 * @extends {BaseAPI}
 */
var MemberApi = /** @class */ (function (_super) {
    __extends(MemberApi, _super);
    function MemberApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * count member by search conditions
     * @summary count member
     * @param {MemberApiCountMemberRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MemberApi
     */
    MemberApi.prototype.countMember = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return MemberApiFp(this.configuration).countMember(requestParameters.corporateID, requestParameters.cursor, requestParameters.id, requestParameters.limit, requestParameters.name, requestParameters.orderBy, requestParameters.photo, requestParameters.profile, requestParameters.roleType, requestParameters.userID, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * create member
     * @summary create member
     * @param {MemberApiCreateMemberRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MemberApi
     */
    MemberApi.prototype.createMember = function (requestParameters, options) {
        var _this = this;
        return MemberApiFp(this.configuration).createMember(requestParameters.body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * delete member
     * @summary delete member
     * @param {MemberApiDeleteMemberRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MemberApi
     */
    MemberApi.prototype.deleteMember = function (requestParameters, options) {
        var _this = this;
        return MemberApiFp(this.configuration).deleteMember(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * get member
     * @summary get member
     * @param {MemberApiGetMemberRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MemberApi
     */
    MemberApi.prototype.getMember = function (requestParameters, options) {
        var _this = this;
        return MemberApiFp(this.configuration).getMember(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * get members
     * @summary get members
     * @param {MemberApiGetMembersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MemberApi
     */
    MemberApi.prototype.getMembers = function (requestParameters, options) {
        var _this = this;
        return MemberApiFp(this.configuration).getMembers(requestParameters.ids, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * patch member
     * @summary patch member
     * @param {MemberApiPatchMemberRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MemberApi
     */
    MemberApi.prototype.patchMember = function (requestParameters, options) {
        var _this = this;
        return MemberApiFp(this.configuration).patchMember(requestParameters.id, requestParameters.body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * search member by search conditions
     * @summary search member
     * @param {MemberApiSearchMemberRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MemberApi
     */
    MemberApi.prototype.searchMember = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return MemberApiFp(this.configuration).searchMember(requestParameters.corporateID, requestParameters.cursor, requestParameters.id, requestParameters.limit, requestParameters.name, requestParameters.orderBy, requestParameters.photo, requestParameters.profile, requestParameters.roleType, requestParameters.userID, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * update member
     * @summary update member
     * @param {MemberApiUpdateMemberRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MemberApi
     */
    MemberApi.prototype.updateMember = function (requestParameters, options) {
        var _this = this;
        return MemberApiFp(this.configuration).updateMember(requestParameters.id, requestParameters.body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return MemberApi;
}(BaseAPI));
export { MemberApi };
/**
 * MessageApi - axios parameter creator
 * @export
 */
export var MessageApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * count message by search conditions
         * @summary count message
         * @param {number} [corporateID]
         * @param {string} [cursor]
         * @param {number} [customerID]
         * @param {string} [customerName]
         * @param {number} [entryID]
         * @param {number} [id]
         * @param {number} [limit]
         * @param {number} [memberID]
         * @param {string} [memberName]
         * @param {string} [message]
         * @param {string} [orderBy]
         * @param {string} [postDateTime]
         * @param {number} [postFromType]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countMessage: function (corporateID, cursor, customerID, customerName, entryID, id, limit, memberID, memberName, message, orderBy, postDateTime, postFromType, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/messages/count";
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (corporateID !== undefined) {
                        localVarQueryParameter['corporateID'] = corporateID;
                    }
                    if (cursor !== undefined) {
                        localVarQueryParameter['cursor'] = cursor;
                    }
                    if (customerID !== undefined) {
                        localVarQueryParameter['customerID'] = customerID;
                    }
                    if (customerName !== undefined) {
                        localVarQueryParameter['customerName'] = customerName;
                    }
                    if (entryID !== undefined) {
                        localVarQueryParameter['entryID'] = entryID;
                    }
                    if (id !== undefined) {
                        localVarQueryParameter['id'] = id;
                    }
                    if (limit !== undefined) {
                        localVarQueryParameter['limit'] = limit;
                    }
                    if (memberID !== undefined) {
                        localVarQueryParameter['memberID'] = memberID;
                    }
                    if (memberName !== undefined) {
                        localVarQueryParameter['memberName'] = memberName;
                    }
                    if (message !== undefined) {
                        localVarQueryParameter['message'] = message;
                    }
                    if (orderBy !== undefined) {
                        localVarQueryParameter['orderBy'] = orderBy;
                    }
                    if (postDateTime !== undefined) {
                        localVarQueryParameter['postDateTime'] = postDateTime;
                    }
                    if (postFromType !== undefined) {
                        localVarQueryParameter['postFromType'] = postFromType;
                    }
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * create message
         * @summary create message
         * @param {ModelMessage} body Message
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMessage: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    if (body === null || body === undefined) {
                        throw new RequiredError('body', 'Required parameter body was null or undefined when calling createMessage.');
                    }
                    localVarPath = "/message";
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                    localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * delete message
         * @summary delete message
         * @param {number} id MessageID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMessage: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    if (id === null || id === undefined) {
                        throw new RequiredError('id', 'Required parameter id was null or undefined when calling deleteMessage.');
                    }
                    localVarPath = "/message/{id}"
                        .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * get message
         * @summary get message
         * @param {number} id MessageID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMessage: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    if (id === null || id === undefined) {
                        throw new RequiredError('id', 'Required parameter id was null or undefined when calling getMessage.');
                    }
                    localVarPath = "/message/{id}"
                        .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * get messages
         * @summary get messages
         * @param {string} ids Comma Separated MessageID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMessages: function (ids, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'ids' is not null or undefined
                    if (ids === null || ids === undefined) {
                        throw new RequiredError('ids', 'Required parameter ids was null or undefined when calling getMessages.');
                    }
                    localVarPath = "/messages/{ids}"
                        .replace("{" + "ids" + "}", encodeURIComponent(String(ids)));
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * patch message
         * @summary patch message
         * @param {number} id MessageID
         * @param {ModelMessage} body Message
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchMessage: function (id, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    if (id === null || id === undefined) {
                        throw new RequiredError('id', 'Required parameter id was null or undefined when calling patchMessage.');
                    }
                    // verify required parameter 'body' is not null or undefined
                    if (body === null || body === undefined) {
                        throw new RequiredError('body', 'Required parameter body was null or undefined when calling patchMessage.');
                    }
                    localVarPath = "/message/{id}"
                        .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                    localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * search message by search conditions
         * @summary search message
         * @param {number} [corporateID]
         * @param {string} [cursor]
         * @param {number} [customerID]
         * @param {string} [customerName]
         * @param {number} [entryID]
         * @param {number} [id]
         * @param {number} [limit]
         * @param {number} [memberID]
         * @param {string} [memberName]
         * @param {string} [message]
         * @param {string} [orderBy]
         * @param {string} [postDateTime]
         * @param {number} [postFromType]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchMessage: function (corporateID, cursor, customerID, customerName, entryID, id, limit, memberID, memberName, message, orderBy, postDateTime, postFromType, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/messages";
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (corporateID !== undefined) {
                        localVarQueryParameter['corporateID'] = corporateID;
                    }
                    if (cursor !== undefined) {
                        localVarQueryParameter['cursor'] = cursor;
                    }
                    if (customerID !== undefined) {
                        localVarQueryParameter['customerID'] = customerID;
                    }
                    if (customerName !== undefined) {
                        localVarQueryParameter['customerName'] = customerName;
                    }
                    if (entryID !== undefined) {
                        localVarQueryParameter['entryID'] = entryID;
                    }
                    if (id !== undefined) {
                        localVarQueryParameter['id'] = id;
                    }
                    if (limit !== undefined) {
                        localVarQueryParameter['limit'] = limit;
                    }
                    if (memberID !== undefined) {
                        localVarQueryParameter['memberID'] = memberID;
                    }
                    if (memberName !== undefined) {
                        localVarQueryParameter['memberName'] = memberName;
                    }
                    if (message !== undefined) {
                        localVarQueryParameter['message'] = message;
                    }
                    if (orderBy !== undefined) {
                        localVarQueryParameter['orderBy'] = orderBy;
                    }
                    if (postDateTime !== undefined) {
                        localVarQueryParameter['postDateTime'] = postDateTime;
                    }
                    if (postFromType !== undefined) {
                        localVarQueryParameter['postFromType'] = postFromType;
                    }
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * update message
         * @summary update message
         * @param {number} id MessageID
         * @param {ModelMessage} body Message
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMessage: function (id, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    if (id === null || id === undefined) {
                        throw new RequiredError('id', 'Required parameter id was null or undefined when calling updateMessage.');
                    }
                    // verify required parameter 'body' is not null or undefined
                    if (body === null || body === undefined) {
                        throw new RequiredError('body', 'Required parameter body was null or undefined when calling updateMessage.');
                    }
                    localVarPath = "/message/{id}"
                        .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                    localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
/**
 * MessageApi - functional programming interface
 * @export
 */
export var MessageApiFp = function (configuration) {
    return {
        /**
         * count message by search conditions
         * @summary count message
         * @param {number} [corporateID]
         * @param {string} [cursor]
         * @param {number} [customerID]
         * @param {string} [customerName]
         * @param {number} [entryID]
         * @param {number} [id]
         * @param {number} [limit]
         * @param {number} [memberID]
         * @param {string} [memberName]
         * @param {string} [message]
         * @param {string} [orderBy]
         * @param {string} [postDateTime]
         * @param {number} [postFromType]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countMessage: function (corporateID, cursor, customerID, customerName, entryID, id, limit, memberID, memberName, message, orderBy, postDateTime, postFromType, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, MessageApiAxiosParamCreator(configuration).countMessage(corporateID, cursor, customerID, customerName, entryID, id, limit, memberID, memberName, message, orderBy, postDateTime, postFromType, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * create message
         * @summary create message
         * @param {ModelMessage} body Message
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMessage: function (body, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, MessageApiAxiosParamCreator(configuration).createMessage(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * delete message
         * @summary delete message
         * @param {number} id MessageID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMessage: function (id, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, MessageApiAxiosParamCreator(configuration).deleteMessage(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * get message
         * @summary get message
         * @param {number} id MessageID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMessage: function (id, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, MessageApiAxiosParamCreator(configuration).getMessage(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * get messages
         * @summary get messages
         * @param {string} ids Comma Separated MessageID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMessages: function (ids, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, MessageApiAxiosParamCreator(configuration).getMessages(ids, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * patch message
         * @summary patch message
         * @param {number} id MessageID
         * @param {ModelMessage} body Message
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchMessage: function (id, body, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, MessageApiAxiosParamCreator(configuration).patchMessage(id, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * search message by search conditions
         * @summary search message
         * @param {number} [corporateID]
         * @param {string} [cursor]
         * @param {number} [customerID]
         * @param {string} [customerName]
         * @param {number} [entryID]
         * @param {number} [id]
         * @param {number} [limit]
         * @param {number} [memberID]
         * @param {string} [memberName]
         * @param {string} [message]
         * @param {string} [orderBy]
         * @param {string} [postDateTime]
         * @param {number} [postFromType]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchMessage: function (corporateID, cursor, customerID, customerName, entryID, id, limit, memberID, memberName, message, orderBy, postDateTime, postFromType, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, MessageApiAxiosParamCreator(configuration).searchMessage(corporateID, cursor, customerID, customerName, entryID, id, limit, memberID, memberName, message, orderBy, postDateTime, postFromType, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * update message
         * @summary update message
         * @param {number} id MessageID
         * @param {ModelMessage} body Message
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMessage: function (id, body, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, MessageApiAxiosParamCreator(configuration).updateMessage(id, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
    };
};
/**
 * MessageApi - factory interface
 * @export
 */
export var MessageApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         * count message by search conditions
         * @summary count message
         * @param {number} [corporateID]
         * @param {string} [cursor]
         * @param {number} [customerID]
         * @param {string} [customerName]
         * @param {number} [entryID]
         * @param {number} [id]
         * @param {number} [limit]
         * @param {number} [memberID]
         * @param {string} [memberName]
         * @param {string} [message]
         * @param {string} [orderBy]
         * @param {string} [postDateTime]
         * @param {number} [postFromType]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countMessage: function (corporateID, cursor, customerID, customerName, entryID, id, limit, memberID, memberName, message, orderBy, postDateTime, postFromType, options) {
            return MessageApiFp(configuration).countMessage(corporateID, cursor, customerID, customerName, entryID, id, limit, memberID, memberName, message, orderBy, postDateTime, postFromType, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * create message
         * @summary create message
         * @param {ModelMessage} body Message
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createMessage: function (body, options) {
            return MessageApiFp(configuration).createMessage(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * delete message
         * @summary delete message
         * @param {number} id MessageID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMessage: function (id, options) {
            return MessageApiFp(configuration).deleteMessage(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * get message
         * @summary get message
         * @param {number} id MessageID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMessage: function (id, options) {
            return MessageApiFp(configuration).getMessage(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * get messages
         * @summary get messages
         * @param {string} ids Comma Separated MessageID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMessages: function (ids, options) {
            return MessageApiFp(configuration).getMessages(ids, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * patch message
         * @summary patch message
         * @param {number} id MessageID
         * @param {ModelMessage} body Message
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchMessage: function (id, body, options) {
            return MessageApiFp(configuration).patchMessage(id, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * search message by search conditions
         * @summary search message
         * @param {number} [corporateID]
         * @param {string} [cursor]
         * @param {number} [customerID]
         * @param {string} [customerName]
         * @param {number} [entryID]
         * @param {number} [id]
         * @param {number} [limit]
         * @param {number} [memberID]
         * @param {string} [memberName]
         * @param {string} [message]
         * @param {string} [orderBy]
         * @param {string} [postDateTime]
         * @param {number} [postFromType]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchMessage: function (corporateID, cursor, customerID, customerName, entryID, id, limit, memberID, memberName, message, orderBy, postDateTime, postFromType, options) {
            return MessageApiFp(configuration).searchMessage(corporateID, cursor, customerID, customerName, entryID, id, limit, memberID, memberName, message, orderBy, postDateTime, postFromType, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * update message
         * @summary update message
         * @param {number} id MessageID
         * @param {ModelMessage} body Message
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMessage: function (id, body, options) {
            return MessageApiFp(configuration).updateMessage(id, body, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * MessageApi - object-oriented interface
 * @export
 * @class MessageApi
 * @extends {BaseAPI}
 */
var MessageApi = /** @class */ (function (_super) {
    __extends(MessageApi, _super);
    function MessageApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * count message by search conditions
     * @summary count message
     * @param {MessageApiCountMessageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MessageApi
     */
    MessageApi.prototype.countMessage = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return MessageApiFp(this.configuration).countMessage(requestParameters.corporateID, requestParameters.cursor, requestParameters.customerID, requestParameters.customerName, requestParameters.entryID, requestParameters.id, requestParameters.limit, requestParameters.memberID, requestParameters.memberName, requestParameters.message, requestParameters.orderBy, requestParameters.postDateTime, requestParameters.postFromType, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * create message
     * @summary create message
     * @param {MessageApiCreateMessageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MessageApi
     */
    MessageApi.prototype.createMessage = function (requestParameters, options) {
        var _this = this;
        return MessageApiFp(this.configuration).createMessage(requestParameters.body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * delete message
     * @summary delete message
     * @param {MessageApiDeleteMessageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MessageApi
     */
    MessageApi.prototype.deleteMessage = function (requestParameters, options) {
        var _this = this;
        return MessageApiFp(this.configuration).deleteMessage(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * get message
     * @summary get message
     * @param {MessageApiGetMessageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MessageApi
     */
    MessageApi.prototype.getMessage = function (requestParameters, options) {
        var _this = this;
        return MessageApiFp(this.configuration).getMessage(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * get messages
     * @summary get messages
     * @param {MessageApiGetMessagesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MessageApi
     */
    MessageApi.prototype.getMessages = function (requestParameters, options) {
        var _this = this;
        return MessageApiFp(this.configuration).getMessages(requestParameters.ids, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * patch message
     * @summary patch message
     * @param {MessageApiPatchMessageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MessageApi
     */
    MessageApi.prototype.patchMessage = function (requestParameters, options) {
        var _this = this;
        return MessageApiFp(this.configuration).patchMessage(requestParameters.id, requestParameters.body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * search message by search conditions
     * @summary search message
     * @param {MessageApiSearchMessageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MessageApi
     */
    MessageApi.prototype.searchMessage = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return MessageApiFp(this.configuration).searchMessage(requestParameters.corporateID, requestParameters.cursor, requestParameters.customerID, requestParameters.customerName, requestParameters.entryID, requestParameters.id, requestParameters.limit, requestParameters.memberID, requestParameters.memberName, requestParameters.message, requestParameters.orderBy, requestParameters.postDateTime, requestParameters.postFromType, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * update message
     * @summary update message
     * @param {MessageApiUpdateMessageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MessageApi
     */
    MessageApi.prototype.updateMessage = function (requestParameters, options) {
        var _this = this;
        return MessageApiFp(this.configuration).updateMessage(requestParameters.id, requestParameters.body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return MessageApi;
}(BaseAPI));
export { MessageApi };
/**
 * PlaceApi - axios parameter creator
 * @export
 */
export var PlaceApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * count place by search conditions
         * @summary count place
         * @param {number} [corporateID]
         * @param {string} [cursor]
         * @param {number} [id]
         * @param {number} [limit]
         * @param {string} [name]
         * @param {string} [orderBy]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countPlace: function (corporateID, cursor, id, limit, name, orderBy, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/places/count";
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (corporateID !== undefined) {
                        localVarQueryParameter['corporateID'] = corporateID;
                    }
                    if (cursor !== undefined) {
                        localVarQueryParameter['cursor'] = cursor;
                    }
                    if (id !== undefined) {
                        localVarQueryParameter['id'] = id;
                    }
                    if (limit !== undefined) {
                        localVarQueryParameter['limit'] = limit;
                    }
                    if (name !== undefined) {
                        localVarQueryParameter['name'] = name;
                    }
                    if (orderBy !== undefined) {
                        localVarQueryParameter['orderBy'] = orderBy;
                    }
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * create place
         * @summary create place
         * @param {ModelPlace} body Place
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPlace: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    if (body === null || body === undefined) {
                        throw new RequiredError('body', 'Required parameter body was null or undefined when calling createPlace.');
                    }
                    localVarPath = "/place";
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                    localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * delete place
         * @summary delete place
         * @param {number} id PlaceID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePlace: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    if (id === null || id === undefined) {
                        throw new RequiredError('id', 'Required parameter id was null or undefined when calling deletePlace.');
                    }
                    localVarPath = "/place/{id}"
                        .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * get place
         * @summary get place
         * @param {number} id PlaceID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlace: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    if (id === null || id === undefined) {
                        throw new RequiredError('id', 'Required parameter id was null or undefined when calling getPlace.');
                    }
                    localVarPath = "/place/{id}"
                        .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * get places
         * @summary get places
         * @param {string} ids Comma Separated PlaceID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlaces: function (ids, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'ids' is not null or undefined
                    if (ids === null || ids === undefined) {
                        throw new RequiredError('ids', 'Required parameter ids was null or undefined when calling getPlaces.');
                    }
                    localVarPath = "/places/{ids}"
                        .replace("{" + "ids" + "}", encodeURIComponent(String(ids)));
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * patch place
         * @summary patch place
         * @param {number} id PlaceID
         * @param {ModelPlace} body Place
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchPlace: function (id, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    if (id === null || id === undefined) {
                        throw new RequiredError('id', 'Required parameter id was null or undefined when calling patchPlace.');
                    }
                    // verify required parameter 'body' is not null or undefined
                    if (body === null || body === undefined) {
                        throw new RequiredError('body', 'Required parameter body was null or undefined when calling patchPlace.');
                    }
                    localVarPath = "/place/{id}"
                        .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                    localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * search place by search conditions
         * @summary search place
         * @param {number} [corporateID]
         * @param {string} [cursor]
         * @param {number} [id]
         * @param {number} [limit]
         * @param {string} [name]
         * @param {string} [orderBy]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchPlace: function (corporateID, cursor, id, limit, name, orderBy, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/places";
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (corporateID !== undefined) {
                        localVarQueryParameter['corporateID'] = corporateID;
                    }
                    if (cursor !== undefined) {
                        localVarQueryParameter['cursor'] = cursor;
                    }
                    if (id !== undefined) {
                        localVarQueryParameter['id'] = id;
                    }
                    if (limit !== undefined) {
                        localVarQueryParameter['limit'] = limit;
                    }
                    if (name !== undefined) {
                        localVarQueryParameter['name'] = name;
                    }
                    if (orderBy !== undefined) {
                        localVarQueryParameter['orderBy'] = orderBy;
                    }
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * update place
         * @summary update place
         * @param {number} id PlaceID
         * @param {ModelPlace} body Place
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePlace: function (id, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    if (id === null || id === undefined) {
                        throw new RequiredError('id', 'Required parameter id was null or undefined when calling updatePlace.');
                    }
                    // verify required parameter 'body' is not null or undefined
                    if (body === null || body === undefined) {
                        throw new RequiredError('body', 'Required parameter body was null or undefined when calling updatePlace.');
                    }
                    localVarPath = "/place/{id}"
                        .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                    localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
/**
 * PlaceApi - functional programming interface
 * @export
 */
export var PlaceApiFp = function (configuration) {
    return {
        /**
         * count place by search conditions
         * @summary count place
         * @param {number} [corporateID]
         * @param {string} [cursor]
         * @param {number} [id]
         * @param {number} [limit]
         * @param {string} [name]
         * @param {string} [orderBy]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countPlace: function (corporateID, cursor, id, limit, name, orderBy, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, PlaceApiAxiosParamCreator(configuration).countPlace(corporateID, cursor, id, limit, name, orderBy, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * create place
         * @summary create place
         * @param {ModelPlace} body Place
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPlace: function (body, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, PlaceApiAxiosParamCreator(configuration).createPlace(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * delete place
         * @summary delete place
         * @param {number} id PlaceID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePlace: function (id, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, PlaceApiAxiosParamCreator(configuration).deletePlace(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * get place
         * @summary get place
         * @param {number} id PlaceID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlace: function (id, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, PlaceApiAxiosParamCreator(configuration).getPlace(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * get places
         * @summary get places
         * @param {string} ids Comma Separated PlaceID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlaces: function (ids, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, PlaceApiAxiosParamCreator(configuration).getPlaces(ids, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * patch place
         * @summary patch place
         * @param {number} id PlaceID
         * @param {ModelPlace} body Place
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchPlace: function (id, body, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, PlaceApiAxiosParamCreator(configuration).patchPlace(id, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * search place by search conditions
         * @summary search place
         * @param {number} [corporateID]
         * @param {string} [cursor]
         * @param {number} [id]
         * @param {number} [limit]
         * @param {string} [name]
         * @param {string} [orderBy]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchPlace: function (corporateID, cursor, id, limit, name, orderBy, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, PlaceApiAxiosParamCreator(configuration).searchPlace(corporateID, cursor, id, limit, name, orderBy, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * update place
         * @summary update place
         * @param {number} id PlaceID
         * @param {ModelPlace} body Place
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePlace: function (id, body, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, PlaceApiAxiosParamCreator(configuration).updatePlace(id, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
    };
};
/**
 * PlaceApi - factory interface
 * @export
 */
export var PlaceApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         * count place by search conditions
         * @summary count place
         * @param {number} [corporateID]
         * @param {string} [cursor]
         * @param {number} [id]
         * @param {number} [limit]
         * @param {string} [name]
         * @param {string} [orderBy]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countPlace: function (corporateID, cursor, id, limit, name, orderBy, options) {
            return PlaceApiFp(configuration).countPlace(corporateID, cursor, id, limit, name, orderBy, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * create place
         * @summary create place
         * @param {ModelPlace} body Place
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPlace: function (body, options) {
            return PlaceApiFp(configuration).createPlace(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * delete place
         * @summary delete place
         * @param {number} id PlaceID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePlace: function (id, options) {
            return PlaceApiFp(configuration).deletePlace(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * get place
         * @summary get place
         * @param {number} id PlaceID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlace: function (id, options) {
            return PlaceApiFp(configuration).getPlace(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * get places
         * @summary get places
         * @param {string} ids Comma Separated PlaceID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlaces: function (ids, options) {
            return PlaceApiFp(configuration).getPlaces(ids, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * patch place
         * @summary patch place
         * @param {number} id PlaceID
         * @param {ModelPlace} body Place
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchPlace: function (id, body, options) {
            return PlaceApiFp(configuration).patchPlace(id, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * search place by search conditions
         * @summary search place
         * @param {number} [corporateID]
         * @param {string} [cursor]
         * @param {number} [id]
         * @param {number} [limit]
         * @param {string} [name]
         * @param {string} [orderBy]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchPlace: function (corporateID, cursor, id, limit, name, orderBy, options) {
            return PlaceApiFp(configuration).searchPlace(corporateID, cursor, id, limit, name, orderBy, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * update place
         * @summary update place
         * @param {number} id PlaceID
         * @param {ModelPlace} body Place
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePlace: function (id, body, options) {
            return PlaceApiFp(configuration).updatePlace(id, body, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * PlaceApi - object-oriented interface
 * @export
 * @class PlaceApi
 * @extends {BaseAPI}
 */
var PlaceApi = /** @class */ (function (_super) {
    __extends(PlaceApi, _super);
    function PlaceApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * count place by search conditions
     * @summary count place
     * @param {PlaceApiCountPlaceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlaceApi
     */
    PlaceApi.prototype.countPlace = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return PlaceApiFp(this.configuration).countPlace(requestParameters.corporateID, requestParameters.cursor, requestParameters.id, requestParameters.limit, requestParameters.name, requestParameters.orderBy, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * create place
     * @summary create place
     * @param {PlaceApiCreatePlaceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlaceApi
     */
    PlaceApi.prototype.createPlace = function (requestParameters, options) {
        var _this = this;
        return PlaceApiFp(this.configuration).createPlace(requestParameters.body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * delete place
     * @summary delete place
     * @param {PlaceApiDeletePlaceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlaceApi
     */
    PlaceApi.prototype.deletePlace = function (requestParameters, options) {
        var _this = this;
        return PlaceApiFp(this.configuration).deletePlace(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * get place
     * @summary get place
     * @param {PlaceApiGetPlaceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlaceApi
     */
    PlaceApi.prototype.getPlace = function (requestParameters, options) {
        var _this = this;
        return PlaceApiFp(this.configuration).getPlace(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * get places
     * @summary get places
     * @param {PlaceApiGetPlacesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlaceApi
     */
    PlaceApi.prototype.getPlaces = function (requestParameters, options) {
        var _this = this;
        return PlaceApiFp(this.configuration).getPlaces(requestParameters.ids, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * patch place
     * @summary patch place
     * @param {PlaceApiPatchPlaceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlaceApi
     */
    PlaceApi.prototype.patchPlace = function (requestParameters, options) {
        var _this = this;
        return PlaceApiFp(this.configuration).patchPlace(requestParameters.id, requestParameters.body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * search place by search conditions
     * @summary search place
     * @param {PlaceApiSearchPlaceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlaceApi
     */
    PlaceApi.prototype.searchPlace = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return PlaceApiFp(this.configuration).searchPlace(requestParameters.corporateID, requestParameters.cursor, requestParameters.id, requestParameters.limit, requestParameters.name, requestParameters.orderBy, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * update place
     * @summary update place
     * @param {PlaceApiUpdatePlaceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlaceApi
     */
    PlaceApi.prototype.updatePlace = function (requestParameters, options) {
        var _this = this;
        return PlaceApiFp(this.configuration).updatePlace(requestParameters.id, requestParameters.body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return PlaceApi;
}(BaseAPI));
export { PlaceApi };
/**
 * ProductApi - axios parameter creator
 * @export
 */
export var ProductApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * count product by search conditions
         * @summary count product
         * @param {number} [corporateID]
         * @param {string} [cursor]
         * @param {string} [description]
         * @param {number} [id]
         * @param {number} [limit]
         * @param {string} [name]
         * @param {string} [orderBy]
         * @param {number} [ownerID]
         * @param {string} [ownerName]
         * @param {Array<number>} [paymentMethods]
         * @param {Array<number>} [paymentTypes]
         * @param {Array<string>} [photos]
         * @param {number} [productCategoryID]
         * @param {number} [quantity]
         * @param {number} [sortOrder]
         * @param {Array<string>} [startTimes]
         * @param {string} [stripePriceID]
         * @param {number} [timeRange]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countProduct: function (corporateID, cursor, description, id, limit, name, orderBy, ownerID, ownerName, paymentMethods, paymentTypes, photos, productCategoryID, quantity, sortOrder, startTimes, stripePriceID, timeRange, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/products/count";
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (corporateID !== undefined) {
                        localVarQueryParameter['corporateID'] = corporateID;
                    }
                    if (cursor !== undefined) {
                        localVarQueryParameter['cursor'] = cursor;
                    }
                    if (description !== undefined) {
                        localVarQueryParameter['description'] = description;
                    }
                    if (id !== undefined) {
                        localVarQueryParameter['id'] = id;
                    }
                    if (limit !== undefined) {
                        localVarQueryParameter['limit'] = limit;
                    }
                    if (name !== undefined) {
                        localVarQueryParameter['name'] = name;
                    }
                    if (orderBy !== undefined) {
                        localVarQueryParameter['orderBy'] = orderBy;
                    }
                    if (ownerID !== undefined) {
                        localVarQueryParameter['ownerID'] = ownerID;
                    }
                    if (ownerName !== undefined) {
                        localVarQueryParameter['ownerName'] = ownerName;
                    }
                    if (paymentMethods) {
                        localVarQueryParameter['paymentMethods'] = paymentMethods.join(COLLECTION_FORMATS.csv);
                    }
                    if (paymentTypes) {
                        localVarQueryParameter['paymentTypes'] = paymentTypes.join(COLLECTION_FORMATS.csv);
                    }
                    if (photos) {
                        localVarQueryParameter['photos'] = photos.join(COLLECTION_FORMATS.csv);
                    }
                    if (productCategoryID !== undefined) {
                        localVarQueryParameter['productCategoryID'] = productCategoryID;
                    }
                    if (quantity !== undefined) {
                        localVarQueryParameter['quantity'] = quantity;
                    }
                    if (sortOrder !== undefined) {
                        localVarQueryParameter['sortOrder'] = sortOrder;
                    }
                    if (startTimes) {
                        localVarQueryParameter['startTimes'] = startTimes.join(COLLECTION_FORMATS.csv);
                    }
                    if (stripePriceID !== undefined) {
                        localVarQueryParameter['stripePriceID'] = stripePriceID;
                    }
                    if (timeRange !== undefined) {
                        localVarQueryParameter['timeRange'] = timeRange;
                    }
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * create product
         * @summary create product
         * @param {ModelProduct} body Product
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProduct: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    if (body === null || body === undefined) {
                        throw new RequiredError('body', 'Required parameter body was null or undefined when calling createProduct.');
                    }
                    localVarPath = "/product";
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                    localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * delete product
         * @summary delete product
         * @param {number} id ProductID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProduct: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    if (id === null || id === undefined) {
                        throw new RequiredError('id', 'Required parameter id was null or undefined when calling deleteProduct.');
                    }
                    localVarPath = "/product/{id}"
                        .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * get product
         * @summary get product
         * @param {number} id ProductID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProduct: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    if (id === null || id === undefined) {
                        throw new RequiredError('id', 'Required parameter id was null or undefined when calling getProduct.');
                    }
                    localVarPath = "/product/{id}"
                        .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * get product for public
         * @summary get product for public
         * @param {number} corporateId corporateID
         * @param {number} id ProductID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductPublic: function (corporateId, id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'corporateId' is not null or undefined
                    if (corporateId === null || corporateId === undefined) {
                        throw new RequiredError('corporateId', 'Required parameter corporateId was null or undefined when calling getProductPublic.');
                    }
                    // verify required parameter 'id' is not null or undefined
                    if (id === null || id === undefined) {
                        throw new RequiredError('id', 'Required parameter id was null or undefined when calling getProductPublic.');
                    }
                    localVarPath = "/public/corporate/{corporateId}/product/{id}"
                        .replace("{" + "corporateId" + "}", encodeURIComponent(String(corporateId)))
                        .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * get products
         * @summary get products
         * @param {string} ids Comma Separated ProductID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProducts: function (ids, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'ids' is not null or undefined
                    if (ids === null || ids === undefined) {
                        throw new RequiredError('ids', 'Required parameter ids was null or undefined when calling getProducts.');
                    }
                    localVarPath = "/products/{ids}"
                        .replace("{" + "ids" + "}", encodeURIComponent(String(ids)));
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * patch product
         * @summary patch product
         * @param {number} id ProductID
         * @param {ModelProduct} body Product
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchProduct: function (id, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    if (id === null || id === undefined) {
                        throw new RequiredError('id', 'Required parameter id was null or undefined when calling patchProduct.');
                    }
                    // verify required parameter 'body' is not null or undefined
                    if (body === null || body === undefined) {
                        throw new RequiredError('body', 'Required parameter body was null or undefined when calling patchProduct.');
                    }
                    localVarPath = "/product/{id}"
                        .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                    localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * search product by search conditions
         * @summary search product
         * @param {number} [corporateID]
         * @param {string} [cursor]
         * @param {string} [description]
         * @param {number} [id]
         * @param {number} [limit]
         * @param {string} [name]
         * @param {string} [orderBy]
         * @param {number} [ownerID]
         * @param {string} [ownerName]
         * @param {Array<number>} [paymentMethods]
         * @param {Array<number>} [paymentTypes]
         * @param {Array<string>} [photos]
         * @param {number} [productCategoryID]
         * @param {number} [quantity]
         * @param {number} [sortOrder]
         * @param {Array<string>} [startTimes]
         * @param {string} [stripePriceID]
         * @param {number} [timeRange]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchProduct: function (corporateID, cursor, description, id, limit, name, orderBy, ownerID, ownerName, paymentMethods, paymentTypes, photos, productCategoryID, quantity, sortOrder, startTimes, stripePriceID, timeRange, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/products";
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (corporateID !== undefined) {
                        localVarQueryParameter['corporateID'] = corporateID;
                    }
                    if (cursor !== undefined) {
                        localVarQueryParameter['cursor'] = cursor;
                    }
                    if (description !== undefined) {
                        localVarQueryParameter['description'] = description;
                    }
                    if (id !== undefined) {
                        localVarQueryParameter['id'] = id;
                    }
                    if (limit !== undefined) {
                        localVarQueryParameter['limit'] = limit;
                    }
                    if (name !== undefined) {
                        localVarQueryParameter['name'] = name;
                    }
                    if (orderBy !== undefined) {
                        localVarQueryParameter['orderBy'] = orderBy;
                    }
                    if (ownerID !== undefined) {
                        localVarQueryParameter['ownerID'] = ownerID;
                    }
                    if (ownerName !== undefined) {
                        localVarQueryParameter['ownerName'] = ownerName;
                    }
                    if (paymentMethods) {
                        localVarQueryParameter['paymentMethods'] = paymentMethods.join(COLLECTION_FORMATS.csv);
                    }
                    if (paymentTypes) {
                        localVarQueryParameter['paymentTypes'] = paymentTypes.join(COLLECTION_FORMATS.csv);
                    }
                    if (photos) {
                        localVarQueryParameter['photos'] = photos.join(COLLECTION_FORMATS.csv);
                    }
                    if (productCategoryID !== undefined) {
                        localVarQueryParameter['productCategoryID'] = productCategoryID;
                    }
                    if (quantity !== undefined) {
                        localVarQueryParameter['quantity'] = quantity;
                    }
                    if (sortOrder !== undefined) {
                        localVarQueryParameter['sortOrder'] = sortOrder;
                    }
                    if (startTimes) {
                        localVarQueryParameter['startTimes'] = startTimes.join(COLLECTION_FORMATS.csv);
                    }
                    if (stripePriceID !== undefined) {
                        localVarQueryParameter['stripePriceID'] = stripePriceID;
                    }
                    if (timeRange !== undefined) {
                        localVarQueryParameter['timeRange'] = timeRange;
                    }
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * update product
         * @summary update product
         * @param {number} id ProductID
         * @param {ModelProduct} body Product
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProduct: function (id, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    if (id === null || id === undefined) {
                        throw new RequiredError('id', 'Required parameter id was null or undefined when calling updateProduct.');
                    }
                    // verify required parameter 'body' is not null or undefined
                    if (body === null || body === undefined) {
                        throw new RequiredError('body', 'Required parameter body was null or undefined when calling updateProduct.');
                    }
                    localVarPath = "/product/{id}"
                        .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                    localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
/**
 * ProductApi - functional programming interface
 * @export
 */
export var ProductApiFp = function (configuration) {
    return {
        /**
         * count product by search conditions
         * @summary count product
         * @param {number} [corporateID]
         * @param {string} [cursor]
         * @param {string} [description]
         * @param {number} [id]
         * @param {number} [limit]
         * @param {string} [name]
         * @param {string} [orderBy]
         * @param {number} [ownerID]
         * @param {string} [ownerName]
         * @param {Array<number>} [paymentMethods]
         * @param {Array<number>} [paymentTypes]
         * @param {Array<string>} [photos]
         * @param {number} [productCategoryID]
         * @param {number} [quantity]
         * @param {number} [sortOrder]
         * @param {Array<string>} [startTimes]
         * @param {string} [stripePriceID]
         * @param {number} [timeRange]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countProduct: function (corporateID, cursor, description, id, limit, name, orderBy, ownerID, ownerName, paymentMethods, paymentTypes, photos, productCategoryID, quantity, sortOrder, startTimes, stripePriceID, timeRange, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, ProductApiAxiosParamCreator(configuration).countProduct(corporateID, cursor, description, id, limit, name, orderBy, ownerID, ownerName, paymentMethods, paymentTypes, photos, productCategoryID, quantity, sortOrder, startTimes, stripePriceID, timeRange, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * create product
         * @summary create product
         * @param {ModelProduct} body Product
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProduct: function (body, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, ProductApiAxiosParamCreator(configuration).createProduct(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * delete product
         * @summary delete product
         * @param {number} id ProductID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProduct: function (id, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, ProductApiAxiosParamCreator(configuration).deleteProduct(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * get product
         * @summary get product
         * @param {number} id ProductID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProduct: function (id, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, ProductApiAxiosParamCreator(configuration).getProduct(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * get product for public
         * @summary get product for public
         * @param {number} corporateId corporateID
         * @param {number} id ProductID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductPublic: function (corporateId, id, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, ProductApiAxiosParamCreator(configuration).getProductPublic(corporateId, id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * get products
         * @summary get products
         * @param {string} ids Comma Separated ProductID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProducts: function (ids, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, ProductApiAxiosParamCreator(configuration).getProducts(ids, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * patch product
         * @summary patch product
         * @param {number} id ProductID
         * @param {ModelProduct} body Product
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchProduct: function (id, body, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, ProductApiAxiosParamCreator(configuration).patchProduct(id, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * search product by search conditions
         * @summary search product
         * @param {number} [corporateID]
         * @param {string} [cursor]
         * @param {string} [description]
         * @param {number} [id]
         * @param {number} [limit]
         * @param {string} [name]
         * @param {string} [orderBy]
         * @param {number} [ownerID]
         * @param {string} [ownerName]
         * @param {Array<number>} [paymentMethods]
         * @param {Array<number>} [paymentTypes]
         * @param {Array<string>} [photos]
         * @param {number} [productCategoryID]
         * @param {number} [quantity]
         * @param {number} [sortOrder]
         * @param {Array<string>} [startTimes]
         * @param {string} [stripePriceID]
         * @param {number} [timeRange]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchProduct: function (corporateID, cursor, description, id, limit, name, orderBy, ownerID, ownerName, paymentMethods, paymentTypes, photos, productCategoryID, quantity, sortOrder, startTimes, stripePriceID, timeRange, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, ProductApiAxiosParamCreator(configuration).searchProduct(corporateID, cursor, description, id, limit, name, orderBy, ownerID, ownerName, paymentMethods, paymentTypes, photos, productCategoryID, quantity, sortOrder, startTimes, stripePriceID, timeRange, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * update product
         * @summary update product
         * @param {number} id ProductID
         * @param {ModelProduct} body Product
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProduct: function (id, body, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, ProductApiAxiosParamCreator(configuration).updateProduct(id, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
    };
};
/**
 * ProductApi - factory interface
 * @export
 */
export var ProductApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         * count product by search conditions
         * @summary count product
         * @param {number} [corporateID]
         * @param {string} [cursor]
         * @param {string} [description]
         * @param {number} [id]
         * @param {number} [limit]
         * @param {string} [name]
         * @param {string} [orderBy]
         * @param {number} [ownerID]
         * @param {string} [ownerName]
         * @param {Array<number>} [paymentMethods]
         * @param {Array<number>} [paymentTypes]
         * @param {Array<string>} [photos]
         * @param {number} [productCategoryID]
         * @param {number} [quantity]
         * @param {number} [sortOrder]
         * @param {Array<string>} [startTimes]
         * @param {string} [stripePriceID]
         * @param {number} [timeRange]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countProduct: function (corporateID, cursor, description, id, limit, name, orderBy, ownerID, ownerName, paymentMethods, paymentTypes, photos, productCategoryID, quantity, sortOrder, startTimes, stripePriceID, timeRange, options) {
            return ProductApiFp(configuration).countProduct(corporateID, cursor, description, id, limit, name, orderBy, ownerID, ownerName, paymentMethods, paymentTypes, photos, productCategoryID, quantity, sortOrder, startTimes, stripePriceID, timeRange, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * create product
         * @summary create product
         * @param {ModelProduct} body Product
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProduct: function (body, options) {
            return ProductApiFp(configuration).createProduct(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * delete product
         * @summary delete product
         * @param {number} id ProductID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProduct: function (id, options) {
            return ProductApiFp(configuration).deleteProduct(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * get product
         * @summary get product
         * @param {number} id ProductID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProduct: function (id, options) {
            return ProductApiFp(configuration).getProduct(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * get product for public
         * @summary get product for public
         * @param {number} corporateId corporateID
         * @param {number} id ProductID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductPublic: function (corporateId, id, options) {
            return ProductApiFp(configuration).getProductPublic(corporateId, id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * get products
         * @summary get products
         * @param {string} ids Comma Separated ProductID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProducts: function (ids, options) {
            return ProductApiFp(configuration).getProducts(ids, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * patch product
         * @summary patch product
         * @param {number} id ProductID
         * @param {ModelProduct} body Product
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchProduct: function (id, body, options) {
            return ProductApiFp(configuration).patchProduct(id, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * search product by search conditions
         * @summary search product
         * @param {number} [corporateID]
         * @param {string} [cursor]
         * @param {string} [description]
         * @param {number} [id]
         * @param {number} [limit]
         * @param {string} [name]
         * @param {string} [orderBy]
         * @param {number} [ownerID]
         * @param {string} [ownerName]
         * @param {Array<number>} [paymentMethods]
         * @param {Array<number>} [paymentTypes]
         * @param {Array<string>} [photos]
         * @param {number} [productCategoryID]
         * @param {number} [quantity]
         * @param {number} [sortOrder]
         * @param {Array<string>} [startTimes]
         * @param {string} [stripePriceID]
         * @param {number} [timeRange]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchProduct: function (corporateID, cursor, description, id, limit, name, orderBy, ownerID, ownerName, paymentMethods, paymentTypes, photos, productCategoryID, quantity, sortOrder, startTimes, stripePriceID, timeRange, options) {
            return ProductApiFp(configuration).searchProduct(corporateID, cursor, description, id, limit, name, orderBy, ownerID, ownerName, paymentMethods, paymentTypes, photos, productCategoryID, quantity, sortOrder, startTimes, stripePriceID, timeRange, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * update product
         * @summary update product
         * @param {number} id ProductID
         * @param {ModelProduct} body Product
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProduct: function (id, body, options) {
            return ProductApiFp(configuration).updateProduct(id, body, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * ProductApi - object-oriented interface
 * @export
 * @class ProductApi
 * @extends {BaseAPI}
 */
var ProductApi = /** @class */ (function (_super) {
    __extends(ProductApi, _super);
    function ProductApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * count product by search conditions
     * @summary count product
     * @param {ProductApiCountProductRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductApi
     */
    ProductApi.prototype.countProduct = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return ProductApiFp(this.configuration).countProduct(requestParameters.corporateID, requestParameters.cursor, requestParameters.description, requestParameters.id, requestParameters.limit, requestParameters.name, requestParameters.orderBy, requestParameters.ownerID, requestParameters.ownerName, requestParameters.paymentMethods, requestParameters.paymentTypes, requestParameters.photos, requestParameters.productCategoryID, requestParameters.quantity, requestParameters.sortOrder, requestParameters.startTimes, requestParameters.stripePriceID, requestParameters.timeRange, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * create product
     * @summary create product
     * @param {ProductApiCreateProductRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductApi
     */
    ProductApi.prototype.createProduct = function (requestParameters, options) {
        var _this = this;
        return ProductApiFp(this.configuration).createProduct(requestParameters.body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * delete product
     * @summary delete product
     * @param {ProductApiDeleteProductRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductApi
     */
    ProductApi.prototype.deleteProduct = function (requestParameters, options) {
        var _this = this;
        return ProductApiFp(this.configuration).deleteProduct(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * get product
     * @summary get product
     * @param {ProductApiGetProductRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductApi
     */
    ProductApi.prototype.getProduct = function (requestParameters, options) {
        var _this = this;
        return ProductApiFp(this.configuration).getProduct(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * get product for public
     * @summary get product for public
     * @param {ProductApiGetProductPublicRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductApi
     */
    ProductApi.prototype.getProductPublic = function (requestParameters, options) {
        var _this = this;
        return ProductApiFp(this.configuration).getProductPublic(requestParameters.corporateId, requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * get products
     * @summary get products
     * @param {ProductApiGetProductsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductApi
     */
    ProductApi.prototype.getProducts = function (requestParameters, options) {
        var _this = this;
        return ProductApiFp(this.configuration).getProducts(requestParameters.ids, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * patch product
     * @summary patch product
     * @param {ProductApiPatchProductRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductApi
     */
    ProductApi.prototype.patchProduct = function (requestParameters, options) {
        var _this = this;
        return ProductApiFp(this.configuration).patchProduct(requestParameters.id, requestParameters.body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * search product by search conditions
     * @summary search product
     * @param {ProductApiSearchProductRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductApi
     */
    ProductApi.prototype.searchProduct = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return ProductApiFp(this.configuration).searchProduct(requestParameters.corporateID, requestParameters.cursor, requestParameters.description, requestParameters.id, requestParameters.limit, requestParameters.name, requestParameters.orderBy, requestParameters.ownerID, requestParameters.ownerName, requestParameters.paymentMethods, requestParameters.paymentTypes, requestParameters.photos, requestParameters.productCategoryID, requestParameters.quantity, requestParameters.sortOrder, requestParameters.startTimes, requestParameters.stripePriceID, requestParameters.timeRange, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * update product
     * @summary update product
     * @param {ProductApiUpdateProductRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductApi
     */
    ProductApi.prototype.updateProduct = function (requestParameters, options) {
        var _this = this;
        return ProductApiFp(this.configuration).updateProduct(requestParameters.id, requestParameters.body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ProductApi;
}(BaseAPI));
export { ProductApi };
/**
 * ProductCategoryApi - axios parameter creator
 * @export
 */
export var ProductCategoryApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * count productCategory by search conditions
         * @summary count productCategory
         * @param {number} [corporateID]
         * @param {string} [cursor]
         * @param {number} [id]
         * @param {number} [limit]
         * @param {string} [name]
         * @param {string} [orderBy]
         * @param {boolean} [workShopFlag]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countProductCategory: function (corporateID, cursor, id, limit, name, orderBy, workShopFlag, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/productCategories/count";
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (corporateID !== undefined) {
                        localVarQueryParameter['corporateID'] = corporateID;
                    }
                    if (cursor !== undefined) {
                        localVarQueryParameter['cursor'] = cursor;
                    }
                    if (id !== undefined) {
                        localVarQueryParameter['id'] = id;
                    }
                    if (limit !== undefined) {
                        localVarQueryParameter['limit'] = limit;
                    }
                    if (name !== undefined) {
                        localVarQueryParameter['name'] = name;
                    }
                    if (orderBy !== undefined) {
                        localVarQueryParameter['orderBy'] = orderBy;
                    }
                    if (workShopFlag !== undefined) {
                        localVarQueryParameter['workShopFlag'] = workShopFlag;
                    }
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * create productCategory
         * @summary create productCategory
         * @param {ModelProductCategory} body ProductCategory
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProductCategory: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    if (body === null || body === undefined) {
                        throw new RequiredError('body', 'Required parameter body was null or undefined when calling createProductCategory.');
                    }
                    localVarPath = "/productCategory";
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                    localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * delete productCategory
         * @summary delete productCategory
         * @param {number} id ProductCategoryID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProductCategory: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    if (id === null || id === undefined) {
                        throw new RequiredError('id', 'Required parameter id was null or undefined when calling deleteProductCategory.');
                    }
                    localVarPath = "/productCategory/{id}"
                        .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * get productCategories
         * @summary get productCategories
         * @param {string} ids Comma Separated ProductCategoryID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductCategories: function (ids, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'ids' is not null or undefined
                    if (ids === null || ids === undefined) {
                        throw new RequiredError('ids', 'Required parameter ids was null or undefined when calling getProductCategories.');
                    }
                    localVarPath = "/productCategories/{ids}"
                        .replace("{" + "ids" + "}", encodeURIComponent(String(ids)));
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * get productCategory
         * @summary get productCategory
         * @param {number} id ProductCategoryID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductCategory: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    if (id === null || id === undefined) {
                        throw new RequiredError('id', 'Required parameter id was null or undefined when calling getProductCategory.');
                    }
                    localVarPath = "/productCategory/{id}"
                        .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * patch productCategory
         * @summary patch productCategory
         * @param {number} id ProductCategoryID
         * @param {ModelProductCategory} body ProductCategory
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchProductCategory: function (id, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    if (id === null || id === undefined) {
                        throw new RequiredError('id', 'Required parameter id was null or undefined when calling patchProductCategory.');
                    }
                    // verify required parameter 'body' is not null or undefined
                    if (body === null || body === undefined) {
                        throw new RequiredError('body', 'Required parameter body was null or undefined when calling patchProductCategory.');
                    }
                    localVarPath = "/productCategory/{id}"
                        .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                    localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * search productCategory by search conditions
         * @summary search productCategory
         * @param {number} [corporateID]
         * @param {string} [cursor]
         * @param {number} [id]
         * @param {number} [limit]
         * @param {string} [name]
         * @param {string} [orderBy]
         * @param {boolean} [workShopFlag]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchProductCategory: function (corporateID, cursor, id, limit, name, orderBy, workShopFlag, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/productCategories";
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (corporateID !== undefined) {
                        localVarQueryParameter['corporateID'] = corporateID;
                    }
                    if (cursor !== undefined) {
                        localVarQueryParameter['cursor'] = cursor;
                    }
                    if (id !== undefined) {
                        localVarQueryParameter['id'] = id;
                    }
                    if (limit !== undefined) {
                        localVarQueryParameter['limit'] = limit;
                    }
                    if (name !== undefined) {
                        localVarQueryParameter['name'] = name;
                    }
                    if (orderBy !== undefined) {
                        localVarQueryParameter['orderBy'] = orderBy;
                    }
                    if (workShopFlag !== undefined) {
                        localVarQueryParameter['workShopFlag'] = workShopFlag;
                    }
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * update productCategory
         * @summary update productCategory
         * @param {number} id ProductCategoryID
         * @param {ModelProductCategory} body ProductCategory
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProductCategory: function (id, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    if (id === null || id === undefined) {
                        throw new RequiredError('id', 'Required parameter id was null or undefined when calling updateProductCategory.');
                    }
                    // verify required parameter 'body' is not null or undefined
                    if (body === null || body === undefined) {
                        throw new RequiredError('body', 'Required parameter body was null or undefined when calling updateProductCategory.');
                    }
                    localVarPath = "/productCategory/{id}"
                        .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                    localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
/**
 * ProductCategoryApi - functional programming interface
 * @export
 */
export var ProductCategoryApiFp = function (configuration) {
    return {
        /**
         * count productCategory by search conditions
         * @summary count productCategory
         * @param {number} [corporateID]
         * @param {string} [cursor]
         * @param {number} [id]
         * @param {number} [limit]
         * @param {string} [name]
         * @param {string} [orderBy]
         * @param {boolean} [workShopFlag]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countProductCategory: function (corporateID, cursor, id, limit, name, orderBy, workShopFlag, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, ProductCategoryApiAxiosParamCreator(configuration).countProductCategory(corporateID, cursor, id, limit, name, orderBy, workShopFlag, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * create productCategory
         * @summary create productCategory
         * @param {ModelProductCategory} body ProductCategory
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProductCategory: function (body, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, ProductCategoryApiAxiosParamCreator(configuration).createProductCategory(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * delete productCategory
         * @summary delete productCategory
         * @param {number} id ProductCategoryID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProductCategory: function (id, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, ProductCategoryApiAxiosParamCreator(configuration).deleteProductCategory(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * get productCategories
         * @summary get productCategories
         * @param {string} ids Comma Separated ProductCategoryID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductCategories: function (ids, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, ProductCategoryApiAxiosParamCreator(configuration).getProductCategories(ids, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * get productCategory
         * @summary get productCategory
         * @param {number} id ProductCategoryID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductCategory: function (id, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, ProductCategoryApiAxiosParamCreator(configuration).getProductCategory(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * patch productCategory
         * @summary patch productCategory
         * @param {number} id ProductCategoryID
         * @param {ModelProductCategory} body ProductCategory
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchProductCategory: function (id, body, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, ProductCategoryApiAxiosParamCreator(configuration).patchProductCategory(id, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * search productCategory by search conditions
         * @summary search productCategory
         * @param {number} [corporateID]
         * @param {string} [cursor]
         * @param {number} [id]
         * @param {number} [limit]
         * @param {string} [name]
         * @param {string} [orderBy]
         * @param {boolean} [workShopFlag]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchProductCategory: function (corporateID, cursor, id, limit, name, orderBy, workShopFlag, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, ProductCategoryApiAxiosParamCreator(configuration).searchProductCategory(corporateID, cursor, id, limit, name, orderBy, workShopFlag, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * update productCategory
         * @summary update productCategory
         * @param {number} id ProductCategoryID
         * @param {ModelProductCategory} body ProductCategory
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProductCategory: function (id, body, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, ProductCategoryApiAxiosParamCreator(configuration).updateProductCategory(id, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
    };
};
/**
 * ProductCategoryApi - factory interface
 * @export
 */
export var ProductCategoryApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         * count productCategory by search conditions
         * @summary count productCategory
         * @param {number} [corporateID]
         * @param {string} [cursor]
         * @param {number} [id]
         * @param {number} [limit]
         * @param {string} [name]
         * @param {string} [orderBy]
         * @param {boolean} [workShopFlag]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countProductCategory: function (corporateID, cursor, id, limit, name, orderBy, workShopFlag, options) {
            return ProductCategoryApiFp(configuration).countProductCategory(corporateID, cursor, id, limit, name, orderBy, workShopFlag, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * create productCategory
         * @summary create productCategory
         * @param {ModelProductCategory} body ProductCategory
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProductCategory: function (body, options) {
            return ProductCategoryApiFp(configuration).createProductCategory(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * delete productCategory
         * @summary delete productCategory
         * @param {number} id ProductCategoryID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProductCategory: function (id, options) {
            return ProductCategoryApiFp(configuration).deleteProductCategory(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * get productCategories
         * @summary get productCategories
         * @param {string} ids Comma Separated ProductCategoryID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductCategories: function (ids, options) {
            return ProductCategoryApiFp(configuration).getProductCategories(ids, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * get productCategory
         * @summary get productCategory
         * @param {number} id ProductCategoryID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductCategory: function (id, options) {
            return ProductCategoryApiFp(configuration).getProductCategory(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * patch productCategory
         * @summary patch productCategory
         * @param {number} id ProductCategoryID
         * @param {ModelProductCategory} body ProductCategory
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchProductCategory: function (id, body, options) {
            return ProductCategoryApiFp(configuration).patchProductCategory(id, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * search productCategory by search conditions
         * @summary search productCategory
         * @param {number} [corporateID]
         * @param {string} [cursor]
         * @param {number} [id]
         * @param {number} [limit]
         * @param {string} [name]
         * @param {string} [orderBy]
         * @param {boolean} [workShopFlag]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchProductCategory: function (corporateID, cursor, id, limit, name, orderBy, workShopFlag, options) {
            return ProductCategoryApiFp(configuration).searchProductCategory(corporateID, cursor, id, limit, name, orderBy, workShopFlag, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * update productCategory
         * @summary update productCategory
         * @param {number} id ProductCategoryID
         * @param {ModelProductCategory} body ProductCategory
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProductCategory: function (id, body, options) {
            return ProductCategoryApiFp(configuration).updateProductCategory(id, body, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * ProductCategoryApi - object-oriented interface
 * @export
 * @class ProductCategoryApi
 * @extends {BaseAPI}
 */
var ProductCategoryApi = /** @class */ (function (_super) {
    __extends(ProductCategoryApi, _super);
    function ProductCategoryApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * count productCategory by search conditions
     * @summary count productCategory
     * @param {ProductCategoryApiCountProductCategoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductCategoryApi
     */
    ProductCategoryApi.prototype.countProductCategory = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return ProductCategoryApiFp(this.configuration).countProductCategory(requestParameters.corporateID, requestParameters.cursor, requestParameters.id, requestParameters.limit, requestParameters.name, requestParameters.orderBy, requestParameters.workShopFlag, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * create productCategory
     * @summary create productCategory
     * @param {ProductCategoryApiCreateProductCategoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductCategoryApi
     */
    ProductCategoryApi.prototype.createProductCategory = function (requestParameters, options) {
        var _this = this;
        return ProductCategoryApiFp(this.configuration).createProductCategory(requestParameters.body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * delete productCategory
     * @summary delete productCategory
     * @param {ProductCategoryApiDeleteProductCategoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductCategoryApi
     */
    ProductCategoryApi.prototype.deleteProductCategory = function (requestParameters, options) {
        var _this = this;
        return ProductCategoryApiFp(this.configuration).deleteProductCategory(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * get productCategories
     * @summary get productCategories
     * @param {ProductCategoryApiGetProductCategoriesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductCategoryApi
     */
    ProductCategoryApi.prototype.getProductCategories = function (requestParameters, options) {
        var _this = this;
        return ProductCategoryApiFp(this.configuration).getProductCategories(requestParameters.ids, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * get productCategory
     * @summary get productCategory
     * @param {ProductCategoryApiGetProductCategoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductCategoryApi
     */
    ProductCategoryApi.prototype.getProductCategory = function (requestParameters, options) {
        var _this = this;
        return ProductCategoryApiFp(this.configuration).getProductCategory(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * patch productCategory
     * @summary patch productCategory
     * @param {ProductCategoryApiPatchProductCategoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductCategoryApi
     */
    ProductCategoryApi.prototype.patchProductCategory = function (requestParameters, options) {
        var _this = this;
        return ProductCategoryApiFp(this.configuration).patchProductCategory(requestParameters.id, requestParameters.body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * search productCategory by search conditions
     * @summary search productCategory
     * @param {ProductCategoryApiSearchProductCategoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductCategoryApi
     */
    ProductCategoryApi.prototype.searchProductCategory = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return ProductCategoryApiFp(this.configuration).searchProductCategory(requestParameters.corporateID, requestParameters.cursor, requestParameters.id, requestParameters.limit, requestParameters.name, requestParameters.orderBy, requestParameters.workShopFlag, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * update productCategory
     * @summary update productCategory
     * @param {ProductCategoryApiUpdateProductCategoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductCategoryApi
     */
    ProductCategoryApi.prototype.updateProductCategory = function (requestParameters, options) {
        var _this = this;
        return ProductCategoryApiFp(this.configuration).updateProductCategory(requestParameters.id, requestParameters.body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ProductCategoryApi;
}(BaseAPI));
export { ProductCategoryApi };
/**
 * ScheduleApi - axios parameter creator
 * @export
 */
export var ScheduleApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * count schedule by search conditions
         * @summary count schedule
         * @param {number} [applications]
         * @param {number} [capacity]
         * @param {number} [corporateID]
         * @param {string} [cursor]
         * @param {string} [endDateTime]
         * @param {Array<number>} [entryIDs]
         * @param {number} [id]
         * @param {number} [limit]
         * @param {number} [memberID]
         * @param {string} [memberName]
         * @param {string} [orderBy]
         * @param {number} [placeID]
         * @param {string} [placeName]
         * @param {Array<number>} [possibleProductIDs]
         * @param {string} [startDateTime]
         * @param {string} [startDateTimeFrom]
         * @param {string} [startDateTimeTo]
         * @param {number} [status]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countSchedule: function (applications, capacity, corporateID, cursor, endDateTime, entryIDs, id, limit, memberID, memberName, orderBy, placeID, placeName, possibleProductIDs, startDateTime, startDateTimeFrom, startDateTimeTo, status, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/schedules/count";
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (applications !== undefined) {
                        localVarQueryParameter['applications'] = applications;
                    }
                    if (capacity !== undefined) {
                        localVarQueryParameter['capacity'] = capacity;
                    }
                    if (corporateID !== undefined) {
                        localVarQueryParameter['corporateID'] = corporateID;
                    }
                    if (cursor !== undefined) {
                        localVarQueryParameter['cursor'] = cursor;
                    }
                    if (endDateTime !== undefined) {
                        localVarQueryParameter['endDateTime'] = endDateTime;
                    }
                    if (entryIDs) {
                        localVarQueryParameter['entryIDs'] = entryIDs.join(COLLECTION_FORMATS.csv);
                    }
                    if (id !== undefined) {
                        localVarQueryParameter['id'] = id;
                    }
                    if (limit !== undefined) {
                        localVarQueryParameter['limit'] = limit;
                    }
                    if (memberID !== undefined) {
                        localVarQueryParameter['memberID'] = memberID;
                    }
                    if (memberName !== undefined) {
                        localVarQueryParameter['memberName'] = memberName;
                    }
                    if (orderBy !== undefined) {
                        localVarQueryParameter['orderBy'] = orderBy;
                    }
                    if (placeID !== undefined) {
                        localVarQueryParameter['placeID'] = placeID;
                    }
                    if (placeName !== undefined) {
                        localVarQueryParameter['placeName'] = placeName;
                    }
                    if (possibleProductIDs) {
                        localVarQueryParameter['possibleProductIDs'] = possibleProductIDs.join(COLLECTION_FORMATS.csv);
                    }
                    if (startDateTime !== undefined) {
                        localVarQueryParameter['startDateTime'] = startDateTime;
                    }
                    if (startDateTimeFrom !== undefined) {
                        localVarQueryParameter['startDateTimeFrom'] = startDateTimeFrom;
                    }
                    if (startDateTimeTo !== undefined) {
                        localVarQueryParameter['startDateTimeTo'] = startDateTimeTo;
                    }
                    if (status !== undefined) {
                        localVarQueryParameter['status'] = status;
                    }
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * create bulk schedule
         * @summary create bulk schedule
         * @param {ModelBulkSchedules} body Schedules
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBulkSchedule: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    if (body === null || body === undefined) {
                        throw new RequiredError('body', 'Required parameter body was null or undefined when calling createBulkSchedule.');
                    }
                    localVarPath = "/schedule/bulk";
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                    localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * create schedule
         * @summary create schedule
         * @param {ModelSchedule} body Schedule
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSchedule: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    if (body === null || body === undefined) {
                        throw new RequiredError('body', 'Required parameter body was null or undefined when calling createSchedule.');
                    }
                    localVarPath = "/schedule";
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                    localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * delete schedule
         * @summary delete schedule
         * @param {number} id ScheduleID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSchedule: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    if (id === null || id === undefined) {
                        throw new RequiredError('id', 'Required parameter id was null or undefined when calling deleteSchedule.');
                    }
                    localVarPath = "/schedule/{id}"
                        .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * get schedule
         * @summary get schedule
         * @param {number} id ScheduleID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSchedule: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    if (id === null || id === undefined) {
                        throw new RequiredError('id', 'Required parameter id was null or undefined when calling getSchedule.');
                    }
                    localVarPath = "/schedule/{id}"
                        .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * get schedules
         * @summary get schedules
         * @param {string} ids Comma Separated ScheduleID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSchedules: function (ids, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'ids' is not null or undefined
                    if (ids === null || ids === undefined) {
                        throw new RequiredError('ids', 'Required parameter ids was null or undefined when calling getSchedules.');
                    }
                    localVarPath = "/schedules/{ids}"
                        .replace("{" + "ids" + "}", encodeURIComponent(String(ids)));
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * patch schedule
         * @summary patch schedule
         * @param {number} id ScheduleID
         * @param {ModelSchedule} body Schedule
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchSchedule: function (id, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    if (id === null || id === undefined) {
                        throw new RequiredError('id', 'Required parameter id was null or undefined when calling patchSchedule.');
                    }
                    // verify required parameter 'body' is not null or undefined
                    if (body === null || body === undefined) {
                        throw new RequiredError('body', 'Required parameter body was null or undefined when calling patchSchedule.');
                    }
                    localVarPath = "/schedule/{id}"
                        .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                    localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * search schedule by search conditions
         * @summary search schedule
         * @param {number} [applications]
         * @param {number} [capacity]
         * @param {number} [corporateID]
         * @param {string} [cursor]
         * @param {string} [endDateTime]
         * @param {Array<number>} [entryIDs]
         * @param {number} [id]
         * @param {number} [limit]
         * @param {number} [memberID]
         * @param {string} [memberName]
         * @param {string} [orderBy]
         * @param {number} [placeID]
         * @param {string} [placeName]
         * @param {Array<number>} [possibleProductIDs]
         * @param {string} [startDateTime]
         * @param {string} [startDateTimeFrom]
         * @param {string} [startDateTimeTo]
         * @param {number} [status]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchSchedule: function (applications, capacity, corporateID, cursor, endDateTime, entryIDs, id, limit, memberID, memberName, orderBy, placeID, placeName, possibleProductIDs, startDateTime, startDateTimeFrom, startDateTimeTo, status, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/schedules";
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (applications !== undefined) {
                        localVarQueryParameter['applications'] = applications;
                    }
                    if (capacity !== undefined) {
                        localVarQueryParameter['capacity'] = capacity;
                    }
                    if (corporateID !== undefined) {
                        localVarQueryParameter['corporateID'] = corporateID;
                    }
                    if (cursor !== undefined) {
                        localVarQueryParameter['cursor'] = cursor;
                    }
                    if (endDateTime !== undefined) {
                        localVarQueryParameter['endDateTime'] = endDateTime;
                    }
                    if (entryIDs) {
                        localVarQueryParameter['entryIDs'] = entryIDs.join(COLLECTION_FORMATS.csv);
                    }
                    if (id !== undefined) {
                        localVarQueryParameter['id'] = id;
                    }
                    if (limit !== undefined) {
                        localVarQueryParameter['limit'] = limit;
                    }
                    if (memberID !== undefined) {
                        localVarQueryParameter['memberID'] = memberID;
                    }
                    if (memberName !== undefined) {
                        localVarQueryParameter['memberName'] = memberName;
                    }
                    if (orderBy !== undefined) {
                        localVarQueryParameter['orderBy'] = orderBy;
                    }
                    if (placeID !== undefined) {
                        localVarQueryParameter['placeID'] = placeID;
                    }
                    if (placeName !== undefined) {
                        localVarQueryParameter['placeName'] = placeName;
                    }
                    if (possibleProductIDs) {
                        localVarQueryParameter['possibleProductIDs'] = possibleProductIDs.join(COLLECTION_FORMATS.csv);
                    }
                    if (startDateTime !== undefined) {
                        localVarQueryParameter['startDateTime'] = startDateTime;
                    }
                    if (startDateTimeFrom !== undefined) {
                        localVarQueryParameter['startDateTimeFrom'] = startDateTimeFrom;
                    }
                    if (startDateTimeTo !== undefined) {
                        localVarQueryParameter['startDateTimeTo'] = startDateTimeTo;
                    }
                    if (status !== undefined) {
                        localVarQueryParameter['status'] = status;
                    }
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * update schedule
         * @summary update schedule
         * @param {number} id ScheduleID
         * @param {ModelSchedule} body Schedule
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSchedule: function (id, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    if (id === null || id === undefined) {
                        throw new RequiredError('id', 'Required parameter id was null or undefined when calling updateSchedule.');
                    }
                    // verify required parameter 'body' is not null or undefined
                    if (body === null || body === undefined) {
                        throw new RequiredError('body', 'Required parameter body was null or undefined when calling updateSchedule.');
                    }
                    localVarPath = "/schedule/{id}"
                        .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                    localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
/**
 * ScheduleApi - functional programming interface
 * @export
 */
export var ScheduleApiFp = function (configuration) {
    return {
        /**
         * count schedule by search conditions
         * @summary count schedule
         * @param {number} [applications]
         * @param {number} [capacity]
         * @param {number} [corporateID]
         * @param {string} [cursor]
         * @param {string} [endDateTime]
         * @param {Array<number>} [entryIDs]
         * @param {number} [id]
         * @param {number} [limit]
         * @param {number} [memberID]
         * @param {string} [memberName]
         * @param {string} [orderBy]
         * @param {number} [placeID]
         * @param {string} [placeName]
         * @param {Array<number>} [possibleProductIDs]
         * @param {string} [startDateTime]
         * @param {string} [startDateTimeFrom]
         * @param {string} [startDateTimeTo]
         * @param {number} [status]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countSchedule: function (applications, capacity, corporateID, cursor, endDateTime, entryIDs, id, limit, memberID, memberName, orderBy, placeID, placeName, possibleProductIDs, startDateTime, startDateTimeFrom, startDateTimeTo, status, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, ScheduleApiAxiosParamCreator(configuration).countSchedule(applications, capacity, corporateID, cursor, endDateTime, entryIDs, id, limit, memberID, memberName, orderBy, placeID, placeName, possibleProductIDs, startDateTime, startDateTimeFrom, startDateTimeTo, status, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * create bulk schedule
         * @summary create bulk schedule
         * @param {ModelBulkSchedules} body Schedules
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBulkSchedule: function (body, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, ScheduleApiAxiosParamCreator(configuration).createBulkSchedule(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * create schedule
         * @summary create schedule
         * @param {ModelSchedule} body Schedule
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSchedule: function (body, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, ScheduleApiAxiosParamCreator(configuration).createSchedule(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * delete schedule
         * @summary delete schedule
         * @param {number} id ScheduleID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSchedule: function (id, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, ScheduleApiAxiosParamCreator(configuration).deleteSchedule(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * get schedule
         * @summary get schedule
         * @param {number} id ScheduleID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSchedule: function (id, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, ScheduleApiAxiosParamCreator(configuration).getSchedule(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * get schedules
         * @summary get schedules
         * @param {string} ids Comma Separated ScheduleID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSchedules: function (ids, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, ScheduleApiAxiosParamCreator(configuration).getSchedules(ids, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * patch schedule
         * @summary patch schedule
         * @param {number} id ScheduleID
         * @param {ModelSchedule} body Schedule
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchSchedule: function (id, body, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, ScheduleApiAxiosParamCreator(configuration).patchSchedule(id, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * search schedule by search conditions
         * @summary search schedule
         * @param {number} [applications]
         * @param {number} [capacity]
         * @param {number} [corporateID]
         * @param {string} [cursor]
         * @param {string} [endDateTime]
         * @param {Array<number>} [entryIDs]
         * @param {number} [id]
         * @param {number} [limit]
         * @param {number} [memberID]
         * @param {string} [memberName]
         * @param {string} [orderBy]
         * @param {number} [placeID]
         * @param {string} [placeName]
         * @param {Array<number>} [possibleProductIDs]
         * @param {string} [startDateTime]
         * @param {string} [startDateTimeFrom]
         * @param {string} [startDateTimeTo]
         * @param {number} [status]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchSchedule: function (applications, capacity, corporateID, cursor, endDateTime, entryIDs, id, limit, memberID, memberName, orderBy, placeID, placeName, possibleProductIDs, startDateTime, startDateTimeFrom, startDateTimeTo, status, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, ScheduleApiAxiosParamCreator(configuration).searchSchedule(applications, capacity, corporateID, cursor, endDateTime, entryIDs, id, limit, memberID, memberName, orderBy, placeID, placeName, possibleProductIDs, startDateTime, startDateTimeFrom, startDateTimeTo, status, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * update schedule
         * @summary update schedule
         * @param {number} id ScheduleID
         * @param {ModelSchedule} body Schedule
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSchedule: function (id, body, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, ScheduleApiAxiosParamCreator(configuration).updateSchedule(id, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
    };
};
/**
 * ScheduleApi - factory interface
 * @export
 */
export var ScheduleApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         * count schedule by search conditions
         * @summary count schedule
         * @param {number} [applications]
         * @param {number} [capacity]
         * @param {number} [corporateID]
         * @param {string} [cursor]
         * @param {string} [endDateTime]
         * @param {Array<number>} [entryIDs]
         * @param {number} [id]
         * @param {number} [limit]
         * @param {number} [memberID]
         * @param {string} [memberName]
         * @param {string} [orderBy]
         * @param {number} [placeID]
         * @param {string} [placeName]
         * @param {Array<number>} [possibleProductIDs]
         * @param {string} [startDateTime]
         * @param {string} [startDateTimeFrom]
         * @param {string} [startDateTimeTo]
         * @param {number} [status]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countSchedule: function (applications, capacity, corporateID, cursor, endDateTime, entryIDs, id, limit, memberID, memberName, orderBy, placeID, placeName, possibleProductIDs, startDateTime, startDateTimeFrom, startDateTimeTo, status, options) {
            return ScheduleApiFp(configuration).countSchedule(applications, capacity, corporateID, cursor, endDateTime, entryIDs, id, limit, memberID, memberName, orderBy, placeID, placeName, possibleProductIDs, startDateTime, startDateTimeFrom, startDateTimeTo, status, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * create bulk schedule
         * @summary create bulk schedule
         * @param {ModelBulkSchedules} body Schedules
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBulkSchedule: function (body, options) {
            return ScheduleApiFp(configuration).createBulkSchedule(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * create schedule
         * @summary create schedule
         * @param {ModelSchedule} body Schedule
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSchedule: function (body, options) {
            return ScheduleApiFp(configuration).createSchedule(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * delete schedule
         * @summary delete schedule
         * @param {number} id ScheduleID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSchedule: function (id, options) {
            return ScheduleApiFp(configuration).deleteSchedule(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * get schedule
         * @summary get schedule
         * @param {number} id ScheduleID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSchedule: function (id, options) {
            return ScheduleApiFp(configuration).getSchedule(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * get schedules
         * @summary get schedules
         * @param {string} ids Comma Separated ScheduleID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSchedules: function (ids, options) {
            return ScheduleApiFp(configuration).getSchedules(ids, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * patch schedule
         * @summary patch schedule
         * @param {number} id ScheduleID
         * @param {ModelSchedule} body Schedule
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchSchedule: function (id, body, options) {
            return ScheduleApiFp(configuration).patchSchedule(id, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * search schedule by search conditions
         * @summary search schedule
         * @param {number} [applications]
         * @param {number} [capacity]
         * @param {number} [corporateID]
         * @param {string} [cursor]
         * @param {string} [endDateTime]
         * @param {Array<number>} [entryIDs]
         * @param {number} [id]
         * @param {number} [limit]
         * @param {number} [memberID]
         * @param {string} [memberName]
         * @param {string} [orderBy]
         * @param {number} [placeID]
         * @param {string} [placeName]
         * @param {Array<number>} [possibleProductIDs]
         * @param {string} [startDateTime]
         * @param {string} [startDateTimeFrom]
         * @param {string} [startDateTimeTo]
         * @param {number} [status]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchSchedule: function (applications, capacity, corporateID, cursor, endDateTime, entryIDs, id, limit, memberID, memberName, orderBy, placeID, placeName, possibleProductIDs, startDateTime, startDateTimeFrom, startDateTimeTo, status, options) {
            return ScheduleApiFp(configuration).searchSchedule(applications, capacity, corporateID, cursor, endDateTime, entryIDs, id, limit, memberID, memberName, orderBy, placeID, placeName, possibleProductIDs, startDateTime, startDateTimeFrom, startDateTimeTo, status, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * update schedule
         * @summary update schedule
         * @param {number} id ScheduleID
         * @param {ModelSchedule} body Schedule
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSchedule: function (id, body, options) {
            return ScheduleApiFp(configuration).updateSchedule(id, body, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * ScheduleApi - object-oriented interface
 * @export
 * @class ScheduleApi
 * @extends {BaseAPI}
 */
var ScheduleApi = /** @class */ (function (_super) {
    __extends(ScheduleApi, _super);
    function ScheduleApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * count schedule by search conditions
     * @summary count schedule
     * @param {ScheduleApiCountScheduleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScheduleApi
     */
    ScheduleApi.prototype.countSchedule = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return ScheduleApiFp(this.configuration).countSchedule(requestParameters.applications, requestParameters.capacity, requestParameters.corporateID, requestParameters.cursor, requestParameters.endDateTime, requestParameters.entryIDs, requestParameters.id, requestParameters.limit, requestParameters.memberID, requestParameters.memberName, requestParameters.orderBy, requestParameters.placeID, requestParameters.placeName, requestParameters.possibleProductIDs, requestParameters.startDateTime, requestParameters.startDateTimeFrom, requestParameters.startDateTimeTo, requestParameters.status, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * create bulk schedule
     * @summary create bulk schedule
     * @param {ScheduleApiCreateBulkScheduleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScheduleApi
     */
    ScheduleApi.prototype.createBulkSchedule = function (requestParameters, options) {
        var _this = this;
        return ScheduleApiFp(this.configuration).createBulkSchedule(requestParameters.body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * create schedule
     * @summary create schedule
     * @param {ScheduleApiCreateScheduleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScheduleApi
     */
    ScheduleApi.prototype.createSchedule = function (requestParameters, options) {
        var _this = this;
        return ScheduleApiFp(this.configuration).createSchedule(requestParameters.body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * delete schedule
     * @summary delete schedule
     * @param {ScheduleApiDeleteScheduleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScheduleApi
     */
    ScheduleApi.prototype.deleteSchedule = function (requestParameters, options) {
        var _this = this;
        return ScheduleApiFp(this.configuration).deleteSchedule(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * get schedule
     * @summary get schedule
     * @param {ScheduleApiGetScheduleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScheduleApi
     */
    ScheduleApi.prototype.getSchedule = function (requestParameters, options) {
        var _this = this;
        return ScheduleApiFp(this.configuration).getSchedule(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * get schedules
     * @summary get schedules
     * @param {ScheduleApiGetSchedulesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScheduleApi
     */
    ScheduleApi.prototype.getSchedules = function (requestParameters, options) {
        var _this = this;
        return ScheduleApiFp(this.configuration).getSchedules(requestParameters.ids, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * patch schedule
     * @summary patch schedule
     * @param {ScheduleApiPatchScheduleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScheduleApi
     */
    ScheduleApi.prototype.patchSchedule = function (requestParameters, options) {
        var _this = this;
        return ScheduleApiFp(this.configuration).patchSchedule(requestParameters.id, requestParameters.body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * search schedule by search conditions
     * @summary search schedule
     * @param {ScheduleApiSearchScheduleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScheduleApi
     */
    ScheduleApi.prototype.searchSchedule = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return ScheduleApiFp(this.configuration).searchSchedule(requestParameters.applications, requestParameters.capacity, requestParameters.corporateID, requestParameters.cursor, requestParameters.endDateTime, requestParameters.entryIDs, requestParameters.id, requestParameters.limit, requestParameters.memberID, requestParameters.memberName, requestParameters.orderBy, requestParameters.placeID, requestParameters.placeName, requestParameters.possibleProductIDs, requestParameters.startDateTime, requestParameters.startDateTimeFrom, requestParameters.startDateTimeTo, requestParameters.status, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * update schedule
     * @summary update schedule
     * @param {ScheduleApiUpdateScheduleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScheduleApi
     */
    ScheduleApi.prototype.updateSchedule = function (requestParameters, options) {
        var _this = this;
        return ScheduleApiFp(this.configuration).updateSchedule(requestParameters.id, requestParameters.body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ScheduleApi;
}(BaseAPI));
export { ScheduleApi };
/**
 * StripeApi - axios parameter creator
 * @export
 */
export var StripeApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * attach payment method
         * @summary attach payment method
         * @param {string} id PaymentMethodID
         * @param {ModelStripePaymentMethodAttachParams} body StripePaymentMethodAttachParams
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        attachStripePaymentMethod: function (id, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    if (id === null || id === undefined) {
                        throw new RequiredError('id', 'Required parameter id was null or undefined when calling attachStripePaymentMethod.');
                    }
                    // verify required parameter 'body' is not null or undefined
                    if (body === null || body === undefined) {
                        throw new RequiredError('body', 'Required parameter body was null or undefined when calling attachStripePaymentMethod.');
                    }
                    localVarPath = "/stripe/payment-method/attach/{id}"
                        .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                    localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * cancel payment intent
         * @summary cancel payment intent
         * @param {string} id PaymentIntentID
         * @param {ModelStripeCancelPaymentIntentParams} body StripeCancelPaymentIntentParams
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelStripePaymentIntent: function (id, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    if (id === null || id === undefined) {
                        throw new RequiredError('id', 'Required parameter id was null or undefined when calling cancelStripePaymentIntent.');
                    }
                    // verify required parameter 'body' is not null or undefined
                    if (body === null || body === undefined) {
                        throw new RequiredError('body', 'Required parameter body was null or undefined when calling cancelStripePaymentIntent.');
                    }
                    localVarPath = "/stripe/payment-intent/{id}"
                        .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                    localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * cancel subscription
         * @summary cancel subscription
         * @param {string} id SubscriptionID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelStripeSubscription: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    if (id === null || id === undefined) {
                        throw new RequiredError('id', 'Required parameter id was null or undefined when calling cancelStripeSubscription.');
                    }
                    localVarPath = "/stripe/subscription/{id}"
                        .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * create customer
         * @summary create customer
         * @param {ModelStripeCustomerParams} body StripeCustomerParams
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStripeCustomer: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    if (body === null || body === undefined) {
                        throw new RequiredError('body', 'Required parameter body was null or undefined when calling createStripeCustomer.');
                    }
                    localVarPath = "/stripe/customer";
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                    localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * create payment intent
         * @summary create payment intent
         * @param {ModelStripePaymentIntentParams} body StripePaymentIntentParams
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStripePaymentIntent: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    if (body === null || body === undefined) {
                        throw new RequiredError('body', 'Required parameter body was null or undefined when calling createStripePaymentIntent.');
                    }
                    localVarPath = "/stripe/payment-intent";
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                    localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * create refund
         * @summary create refund
         * @param {ModelStripeRefundParams} body StripeRefundParams
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStripeRefund: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    if (body === null || body === undefined) {
                        throw new RequiredError('body', 'Required parameter body was null or undefined when calling createStripeRefund.');
                    }
                    localVarPath = "/stripe/refund";
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                    localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * create subscription
         * @summary create subscription
         * @param {ModelStripeSubscriptionParams} body StripeSubscriptionParams
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStripeSubscription: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    if (body === null || body === undefined) {
                        throw new RequiredError('body', 'Required parameter body was null or undefined when calling createStripeSubscription.');
                    }
                    localVarPath = "/stripe/subscription";
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                    localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * delete customer
         * @summary delete customer
         * @param {string} id CustomerID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteStripeCustomer: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    if (id === null || id === undefined) {
                        throw new RequiredError('id', 'Required parameter id was null or undefined when calling deleteStripeCustomer.');
                    }
                    localVarPath = "/stripe/customer/{id}"
                        .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * detach payment method
         * @summary detach payment method
         * @param {string} id PaymentMethodID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        detachStripePaymentMethod: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    if (id === null || id === undefined) {
                        throw new RequiredError('id', 'Required parameter id was null or undefined when calling detachStripePaymentMethod.');
                    }
                    localVarPath = "/stripe/payment-method/detach/{id}"
                        .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * get customer
         * @summary get customer
         * @param {string} id CustomerID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStripeCustomer: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    if (id === null || id === undefined) {
                        throw new RequiredError('id', 'Required parameter id was null or undefined when calling getStripeCustomer.');
                    }
                    localVarPath = "/stripe/customer/{id}"
                        .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * get payment intent
         * @summary get payment intent
         * @param {string} id PaymentIntentID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStripePaymentIntent: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    if (id === null || id === undefined) {
                        throw new RequiredError('id', 'Required parameter id was null or undefined when calling getStripePaymentIntent.');
                    }
                    localVarPath = "/stripe/payment-intent/{id}"
                        .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * get refund
         * @summary get refund
         * @param {string} id RefundID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStripeRefund: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    if (id === null || id === undefined) {
                        throw new RequiredError('id', 'Required parameter id was null or undefined when calling getStripeRefund.');
                    }
                    localVarPath = "/stripe/refund/{id}"
                        .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * get subscription
         * @summary get subscription
         * @param {string} id SubscriptionID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStripeSubscription: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    if (id === null || id === undefined) {
                        throw new RequiredError('id', 'Required parameter id was null or undefined when calling getStripeSubscription.');
                    }
                    localVarPath = "/stripe/subscription/{id}"
                        .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * search customer
         * @summary search customer
         * @param {string} [email]
         * @param {string} [endingBefore]
         * @param {number} [limit]
         * @param {string} [startingAfter]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchStripeCustomer: function (email, endingBefore, limit, startingAfter, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/stripe/customers";
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (email !== undefined) {
                        localVarQueryParameter['email'] = email;
                    }
                    if (endingBefore !== undefined) {
                        localVarQueryParameter['endingBefore'] = endingBefore;
                    }
                    if (limit !== undefined) {
                        localVarQueryParameter['limit'] = limit;
                    }
                    if (startingAfter !== undefined) {
                        localVarQueryParameter['startingAfter'] = startingAfter;
                    }
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * search payment intent
         * @summary search payment intent
         * @param {string} [customerID]
         * @param {string} [endingBefore]
         * @param {number} [limit]
         * @param {string} [startingAfter]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchStripePaymentIntent: function (customerID, endingBefore, limit, startingAfter, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/stripe/payment-intents";
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (customerID !== undefined) {
                        localVarQueryParameter['customerID'] = customerID;
                    }
                    if (endingBefore !== undefined) {
                        localVarQueryParameter['endingBefore'] = endingBefore;
                    }
                    if (limit !== undefined) {
                        localVarQueryParameter['limit'] = limit;
                    }
                    if (startingAfter !== undefined) {
                        localVarQueryParameter['startingAfter'] = startingAfter;
                    }
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * search payment method
         * @summary search payment method
         * @param {string} [customerID]
         * @param {string} [endingBefore]
         * @param {number} [limit]
         * @param {string} [startingAfter]
         * @param {string} [type]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchStripePaymentMethod: function (customerID, endingBefore, limit, startingAfter, type, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/stripe/payment-methods";
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (customerID !== undefined) {
                        localVarQueryParameter['customerID'] = customerID;
                    }
                    if (endingBefore !== undefined) {
                        localVarQueryParameter['endingBefore'] = endingBefore;
                    }
                    if (limit !== undefined) {
                        localVarQueryParameter['limit'] = limit;
                    }
                    if (startingAfter !== undefined) {
                        localVarQueryParameter['startingAfter'] = startingAfter;
                    }
                    if (type !== undefined) {
                        localVarQueryParameter['type'] = type;
                    }
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * search refund
         * @summary search refund
         * @param {string} [endingBefore]
         * @param {number} [limit]
         * @param {string} [paymentIntentID]
         * @param {string} [startingAfter]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchStripeRefund: function (endingBefore, limit, paymentIntentID, startingAfter, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/stripe/refunds";
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (endingBefore !== undefined) {
                        localVarQueryParameter['endingBefore'] = endingBefore;
                    }
                    if (limit !== undefined) {
                        localVarQueryParameter['limit'] = limit;
                    }
                    if (paymentIntentID !== undefined) {
                        localVarQueryParameter['paymentIntentID'] = paymentIntentID;
                    }
                    if (startingAfter !== undefined) {
                        localVarQueryParameter['startingAfter'] = startingAfter;
                    }
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * search subscription
         * @summary search subscription
         * @param {string} [customerID]
         * @param {string} [endingBefore]
         * @param {number} [limit]
         * @param {string} [priceID]
         * @param {string} [startingAfter]
         * @param {string} [status]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchStripeSubscription: function (customerID, endingBefore, limit, priceID, startingAfter, status, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/stripe/subscriptions";
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (customerID !== undefined) {
                        localVarQueryParameter['customerID'] = customerID;
                    }
                    if (endingBefore !== undefined) {
                        localVarQueryParameter['endingBefore'] = endingBefore;
                    }
                    if (limit !== undefined) {
                        localVarQueryParameter['limit'] = limit;
                    }
                    if (priceID !== undefined) {
                        localVarQueryParameter['priceID'] = priceID;
                    }
                    if (startingAfter !== undefined) {
                        localVarQueryParameter['startingAfter'] = startingAfter;
                    }
                    if (status !== undefined) {
                        localVarQueryParameter['status'] = status;
                    }
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * update customer
         * @summary update customer
         * @param {string} id CustomerID
         * @param {ModelStripeCustomerParams} body StripeCustomerParams
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStripeCustomer: function (id, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    if (id === null || id === undefined) {
                        throw new RequiredError('id', 'Required parameter id was null or undefined when calling updateStripeCustomer.');
                    }
                    // verify required parameter 'body' is not null or undefined
                    if (body === null || body === undefined) {
                        throw new RequiredError('body', 'Required parameter body was null or undefined when calling updateStripeCustomer.');
                    }
                    localVarPath = "/stripe/customer/{id}"
                        .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                    localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * update payment intent
         * @summary update payment intent
         * @param {string} id PaymentIntentID
         * @param {ModelStripePaymentIntentParams} body StripePaymentIntentParams
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStripePaymentIntent: function (id, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    if (id === null || id === undefined) {
                        throw new RequiredError('id', 'Required parameter id was null or undefined when calling updateStripePaymentIntent.');
                    }
                    // verify required parameter 'body' is not null or undefined
                    if (body === null || body === undefined) {
                        throw new RequiredError('body', 'Required parameter body was null or undefined when calling updateStripePaymentIntent.');
                    }
                    localVarPath = "/stripe/payment-intent/{id}"
                        .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                    localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * update subscription
         * @summary update subscription
         * @param {string} id SubscriptionID
         * @param {ModelStripeSubscriptionParams} body StripeSubscriptionParams
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStripeSubscription: function (id, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    if (id === null || id === undefined) {
                        throw new RequiredError('id', 'Required parameter id was null or undefined when calling updateStripeSubscription.');
                    }
                    // verify required parameter 'body' is not null or undefined
                    if (body === null || body === undefined) {
                        throw new RequiredError('body', 'Required parameter body was null or undefined when calling updateStripeSubscription.');
                    }
                    localVarPath = "/stripe/subscription/{id}"
                        .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                    localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
/**
 * StripeApi - functional programming interface
 * @export
 */
export var StripeApiFp = function (configuration) {
    return {
        /**
         * attach payment method
         * @summary attach payment method
         * @param {string} id PaymentMethodID
         * @param {ModelStripePaymentMethodAttachParams} body StripePaymentMethodAttachParams
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        attachStripePaymentMethod: function (id, body, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, StripeApiAxiosParamCreator(configuration).attachStripePaymentMethod(id, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * cancel payment intent
         * @summary cancel payment intent
         * @param {string} id PaymentIntentID
         * @param {ModelStripeCancelPaymentIntentParams} body StripeCancelPaymentIntentParams
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelStripePaymentIntent: function (id, body, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, StripeApiAxiosParamCreator(configuration).cancelStripePaymentIntent(id, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * cancel subscription
         * @summary cancel subscription
         * @param {string} id SubscriptionID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelStripeSubscription: function (id, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, StripeApiAxiosParamCreator(configuration).cancelStripeSubscription(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * create customer
         * @summary create customer
         * @param {ModelStripeCustomerParams} body StripeCustomerParams
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStripeCustomer: function (body, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, StripeApiAxiosParamCreator(configuration).createStripeCustomer(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * create payment intent
         * @summary create payment intent
         * @param {ModelStripePaymentIntentParams} body StripePaymentIntentParams
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStripePaymentIntent: function (body, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, StripeApiAxiosParamCreator(configuration).createStripePaymentIntent(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * create refund
         * @summary create refund
         * @param {ModelStripeRefundParams} body StripeRefundParams
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStripeRefund: function (body, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, StripeApiAxiosParamCreator(configuration).createStripeRefund(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * create subscription
         * @summary create subscription
         * @param {ModelStripeSubscriptionParams} body StripeSubscriptionParams
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStripeSubscription: function (body, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, StripeApiAxiosParamCreator(configuration).createStripeSubscription(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * delete customer
         * @summary delete customer
         * @param {string} id CustomerID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteStripeCustomer: function (id, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, StripeApiAxiosParamCreator(configuration).deleteStripeCustomer(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * detach payment method
         * @summary detach payment method
         * @param {string} id PaymentMethodID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        detachStripePaymentMethod: function (id, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, StripeApiAxiosParamCreator(configuration).detachStripePaymentMethod(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * get customer
         * @summary get customer
         * @param {string} id CustomerID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStripeCustomer: function (id, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, StripeApiAxiosParamCreator(configuration).getStripeCustomer(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * get payment intent
         * @summary get payment intent
         * @param {string} id PaymentIntentID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStripePaymentIntent: function (id, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, StripeApiAxiosParamCreator(configuration).getStripePaymentIntent(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * get refund
         * @summary get refund
         * @param {string} id RefundID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStripeRefund: function (id, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, StripeApiAxiosParamCreator(configuration).getStripeRefund(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * get subscription
         * @summary get subscription
         * @param {string} id SubscriptionID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStripeSubscription: function (id, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, StripeApiAxiosParamCreator(configuration).getStripeSubscription(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * search customer
         * @summary search customer
         * @param {string} [email]
         * @param {string} [endingBefore]
         * @param {number} [limit]
         * @param {string} [startingAfter]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchStripeCustomer: function (email, endingBefore, limit, startingAfter, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, StripeApiAxiosParamCreator(configuration).searchStripeCustomer(email, endingBefore, limit, startingAfter, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * search payment intent
         * @summary search payment intent
         * @param {string} [customerID]
         * @param {string} [endingBefore]
         * @param {number} [limit]
         * @param {string} [startingAfter]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchStripePaymentIntent: function (customerID, endingBefore, limit, startingAfter, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, StripeApiAxiosParamCreator(configuration).searchStripePaymentIntent(customerID, endingBefore, limit, startingAfter, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * search payment method
         * @summary search payment method
         * @param {string} [customerID]
         * @param {string} [endingBefore]
         * @param {number} [limit]
         * @param {string} [startingAfter]
         * @param {string} [type]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchStripePaymentMethod: function (customerID, endingBefore, limit, startingAfter, type, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, StripeApiAxiosParamCreator(configuration).searchStripePaymentMethod(customerID, endingBefore, limit, startingAfter, type, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * search refund
         * @summary search refund
         * @param {string} [endingBefore]
         * @param {number} [limit]
         * @param {string} [paymentIntentID]
         * @param {string} [startingAfter]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchStripeRefund: function (endingBefore, limit, paymentIntentID, startingAfter, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, StripeApiAxiosParamCreator(configuration).searchStripeRefund(endingBefore, limit, paymentIntentID, startingAfter, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * search subscription
         * @summary search subscription
         * @param {string} [customerID]
         * @param {string} [endingBefore]
         * @param {number} [limit]
         * @param {string} [priceID]
         * @param {string} [startingAfter]
         * @param {string} [status]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchStripeSubscription: function (customerID, endingBefore, limit, priceID, startingAfter, status, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, StripeApiAxiosParamCreator(configuration).searchStripeSubscription(customerID, endingBefore, limit, priceID, startingAfter, status, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * update customer
         * @summary update customer
         * @param {string} id CustomerID
         * @param {ModelStripeCustomerParams} body StripeCustomerParams
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStripeCustomer: function (id, body, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, StripeApiAxiosParamCreator(configuration).updateStripeCustomer(id, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * update payment intent
         * @summary update payment intent
         * @param {string} id PaymentIntentID
         * @param {ModelStripePaymentIntentParams} body StripePaymentIntentParams
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStripePaymentIntent: function (id, body, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, StripeApiAxiosParamCreator(configuration).updateStripePaymentIntent(id, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * update subscription
         * @summary update subscription
         * @param {string} id SubscriptionID
         * @param {ModelStripeSubscriptionParams} body StripeSubscriptionParams
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStripeSubscription: function (id, body, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, StripeApiAxiosParamCreator(configuration).updateStripeSubscription(id, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
    };
};
/**
 * StripeApi - factory interface
 * @export
 */
export var StripeApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         * attach payment method
         * @summary attach payment method
         * @param {string} id PaymentMethodID
         * @param {ModelStripePaymentMethodAttachParams} body StripePaymentMethodAttachParams
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        attachStripePaymentMethod: function (id, body, options) {
            return StripeApiFp(configuration).attachStripePaymentMethod(id, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * cancel payment intent
         * @summary cancel payment intent
         * @param {string} id PaymentIntentID
         * @param {ModelStripeCancelPaymentIntentParams} body StripeCancelPaymentIntentParams
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelStripePaymentIntent: function (id, body, options) {
            return StripeApiFp(configuration).cancelStripePaymentIntent(id, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * cancel subscription
         * @summary cancel subscription
         * @param {string} id SubscriptionID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelStripeSubscription: function (id, options) {
            return StripeApiFp(configuration).cancelStripeSubscription(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * create customer
         * @summary create customer
         * @param {ModelStripeCustomerParams} body StripeCustomerParams
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStripeCustomer: function (body, options) {
            return StripeApiFp(configuration).createStripeCustomer(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * create payment intent
         * @summary create payment intent
         * @param {ModelStripePaymentIntentParams} body StripePaymentIntentParams
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStripePaymentIntent: function (body, options) {
            return StripeApiFp(configuration).createStripePaymentIntent(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * create refund
         * @summary create refund
         * @param {ModelStripeRefundParams} body StripeRefundParams
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStripeRefund: function (body, options) {
            return StripeApiFp(configuration).createStripeRefund(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * create subscription
         * @summary create subscription
         * @param {ModelStripeSubscriptionParams} body StripeSubscriptionParams
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStripeSubscription: function (body, options) {
            return StripeApiFp(configuration).createStripeSubscription(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * delete customer
         * @summary delete customer
         * @param {string} id CustomerID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteStripeCustomer: function (id, options) {
            return StripeApiFp(configuration).deleteStripeCustomer(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * detach payment method
         * @summary detach payment method
         * @param {string} id PaymentMethodID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        detachStripePaymentMethod: function (id, options) {
            return StripeApiFp(configuration).detachStripePaymentMethod(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * get customer
         * @summary get customer
         * @param {string} id CustomerID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStripeCustomer: function (id, options) {
            return StripeApiFp(configuration).getStripeCustomer(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * get payment intent
         * @summary get payment intent
         * @param {string} id PaymentIntentID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStripePaymentIntent: function (id, options) {
            return StripeApiFp(configuration).getStripePaymentIntent(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * get refund
         * @summary get refund
         * @param {string} id RefundID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStripeRefund: function (id, options) {
            return StripeApiFp(configuration).getStripeRefund(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * get subscription
         * @summary get subscription
         * @param {string} id SubscriptionID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStripeSubscription: function (id, options) {
            return StripeApiFp(configuration).getStripeSubscription(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * search customer
         * @summary search customer
         * @param {string} [email]
         * @param {string} [endingBefore]
         * @param {number} [limit]
         * @param {string} [startingAfter]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchStripeCustomer: function (email, endingBefore, limit, startingAfter, options) {
            return StripeApiFp(configuration).searchStripeCustomer(email, endingBefore, limit, startingAfter, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * search payment intent
         * @summary search payment intent
         * @param {string} [customerID]
         * @param {string} [endingBefore]
         * @param {number} [limit]
         * @param {string} [startingAfter]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchStripePaymentIntent: function (customerID, endingBefore, limit, startingAfter, options) {
            return StripeApiFp(configuration).searchStripePaymentIntent(customerID, endingBefore, limit, startingAfter, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * search payment method
         * @summary search payment method
         * @param {string} [customerID]
         * @param {string} [endingBefore]
         * @param {number} [limit]
         * @param {string} [startingAfter]
         * @param {string} [type]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchStripePaymentMethod: function (customerID, endingBefore, limit, startingAfter, type, options) {
            return StripeApiFp(configuration).searchStripePaymentMethod(customerID, endingBefore, limit, startingAfter, type, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * search refund
         * @summary search refund
         * @param {string} [endingBefore]
         * @param {number} [limit]
         * @param {string} [paymentIntentID]
         * @param {string} [startingAfter]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchStripeRefund: function (endingBefore, limit, paymentIntentID, startingAfter, options) {
            return StripeApiFp(configuration).searchStripeRefund(endingBefore, limit, paymentIntentID, startingAfter, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * search subscription
         * @summary search subscription
         * @param {string} [customerID]
         * @param {string} [endingBefore]
         * @param {number} [limit]
         * @param {string} [priceID]
         * @param {string} [startingAfter]
         * @param {string} [status]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchStripeSubscription: function (customerID, endingBefore, limit, priceID, startingAfter, status, options) {
            return StripeApiFp(configuration).searchStripeSubscription(customerID, endingBefore, limit, priceID, startingAfter, status, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * update customer
         * @summary update customer
         * @param {string} id CustomerID
         * @param {ModelStripeCustomerParams} body StripeCustomerParams
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStripeCustomer: function (id, body, options) {
            return StripeApiFp(configuration).updateStripeCustomer(id, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * update payment intent
         * @summary update payment intent
         * @param {string} id PaymentIntentID
         * @param {ModelStripePaymentIntentParams} body StripePaymentIntentParams
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStripePaymentIntent: function (id, body, options) {
            return StripeApiFp(configuration).updateStripePaymentIntent(id, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * update subscription
         * @summary update subscription
         * @param {string} id SubscriptionID
         * @param {ModelStripeSubscriptionParams} body StripeSubscriptionParams
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStripeSubscription: function (id, body, options) {
            return StripeApiFp(configuration).updateStripeSubscription(id, body, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * StripeApi - object-oriented interface
 * @export
 * @class StripeApi
 * @extends {BaseAPI}
 */
var StripeApi = /** @class */ (function (_super) {
    __extends(StripeApi, _super);
    function StripeApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * attach payment method
     * @summary attach payment method
     * @param {StripeApiAttachStripePaymentMethodRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StripeApi
     */
    StripeApi.prototype.attachStripePaymentMethod = function (requestParameters, options) {
        var _this = this;
        return StripeApiFp(this.configuration).attachStripePaymentMethod(requestParameters.id, requestParameters.body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * cancel payment intent
     * @summary cancel payment intent
     * @param {StripeApiCancelStripePaymentIntentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StripeApi
     */
    StripeApi.prototype.cancelStripePaymentIntent = function (requestParameters, options) {
        var _this = this;
        return StripeApiFp(this.configuration).cancelStripePaymentIntent(requestParameters.id, requestParameters.body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * cancel subscription
     * @summary cancel subscription
     * @param {StripeApiCancelStripeSubscriptionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StripeApi
     */
    StripeApi.prototype.cancelStripeSubscription = function (requestParameters, options) {
        var _this = this;
        return StripeApiFp(this.configuration).cancelStripeSubscription(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * create customer
     * @summary create customer
     * @param {StripeApiCreateStripeCustomerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StripeApi
     */
    StripeApi.prototype.createStripeCustomer = function (requestParameters, options) {
        var _this = this;
        return StripeApiFp(this.configuration).createStripeCustomer(requestParameters.body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * create payment intent
     * @summary create payment intent
     * @param {StripeApiCreateStripePaymentIntentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StripeApi
     */
    StripeApi.prototype.createStripePaymentIntent = function (requestParameters, options) {
        var _this = this;
        return StripeApiFp(this.configuration).createStripePaymentIntent(requestParameters.body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * create refund
     * @summary create refund
     * @param {StripeApiCreateStripeRefundRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StripeApi
     */
    StripeApi.prototype.createStripeRefund = function (requestParameters, options) {
        var _this = this;
        return StripeApiFp(this.configuration).createStripeRefund(requestParameters.body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * create subscription
     * @summary create subscription
     * @param {StripeApiCreateStripeSubscriptionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StripeApi
     */
    StripeApi.prototype.createStripeSubscription = function (requestParameters, options) {
        var _this = this;
        return StripeApiFp(this.configuration).createStripeSubscription(requestParameters.body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * delete customer
     * @summary delete customer
     * @param {StripeApiDeleteStripeCustomerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StripeApi
     */
    StripeApi.prototype.deleteStripeCustomer = function (requestParameters, options) {
        var _this = this;
        return StripeApiFp(this.configuration).deleteStripeCustomer(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * detach payment method
     * @summary detach payment method
     * @param {StripeApiDetachStripePaymentMethodRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StripeApi
     */
    StripeApi.prototype.detachStripePaymentMethod = function (requestParameters, options) {
        var _this = this;
        return StripeApiFp(this.configuration).detachStripePaymentMethod(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * get customer
     * @summary get customer
     * @param {StripeApiGetStripeCustomerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StripeApi
     */
    StripeApi.prototype.getStripeCustomer = function (requestParameters, options) {
        var _this = this;
        return StripeApiFp(this.configuration).getStripeCustomer(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * get payment intent
     * @summary get payment intent
     * @param {StripeApiGetStripePaymentIntentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StripeApi
     */
    StripeApi.prototype.getStripePaymentIntent = function (requestParameters, options) {
        var _this = this;
        return StripeApiFp(this.configuration).getStripePaymentIntent(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * get refund
     * @summary get refund
     * @param {StripeApiGetStripeRefundRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StripeApi
     */
    StripeApi.prototype.getStripeRefund = function (requestParameters, options) {
        var _this = this;
        return StripeApiFp(this.configuration).getStripeRefund(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * get subscription
     * @summary get subscription
     * @param {StripeApiGetStripeSubscriptionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StripeApi
     */
    StripeApi.prototype.getStripeSubscription = function (requestParameters, options) {
        var _this = this;
        return StripeApiFp(this.configuration).getStripeSubscription(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * search customer
     * @summary search customer
     * @param {StripeApiSearchStripeCustomerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StripeApi
     */
    StripeApi.prototype.searchStripeCustomer = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return StripeApiFp(this.configuration).searchStripeCustomer(requestParameters.email, requestParameters.endingBefore, requestParameters.limit, requestParameters.startingAfter, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * search payment intent
     * @summary search payment intent
     * @param {StripeApiSearchStripePaymentIntentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StripeApi
     */
    StripeApi.prototype.searchStripePaymentIntent = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return StripeApiFp(this.configuration).searchStripePaymentIntent(requestParameters.customerID, requestParameters.endingBefore, requestParameters.limit, requestParameters.startingAfter, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * search payment method
     * @summary search payment method
     * @param {StripeApiSearchStripePaymentMethodRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StripeApi
     */
    StripeApi.prototype.searchStripePaymentMethod = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return StripeApiFp(this.configuration).searchStripePaymentMethod(requestParameters.customerID, requestParameters.endingBefore, requestParameters.limit, requestParameters.startingAfter, requestParameters.type, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * search refund
     * @summary search refund
     * @param {StripeApiSearchStripeRefundRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StripeApi
     */
    StripeApi.prototype.searchStripeRefund = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return StripeApiFp(this.configuration).searchStripeRefund(requestParameters.endingBefore, requestParameters.limit, requestParameters.paymentIntentID, requestParameters.startingAfter, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * search subscription
     * @summary search subscription
     * @param {StripeApiSearchStripeSubscriptionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StripeApi
     */
    StripeApi.prototype.searchStripeSubscription = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return StripeApiFp(this.configuration).searchStripeSubscription(requestParameters.customerID, requestParameters.endingBefore, requestParameters.limit, requestParameters.priceID, requestParameters.startingAfter, requestParameters.status, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * update customer
     * @summary update customer
     * @param {StripeApiUpdateStripeCustomerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StripeApi
     */
    StripeApi.prototype.updateStripeCustomer = function (requestParameters, options) {
        var _this = this;
        return StripeApiFp(this.configuration).updateStripeCustomer(requestParameters.id, requestParameters.body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * update payment intent
     * @summary update payment intent
     * @param {StripeApiUpdateStripePaymentIntentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StripeApi
     */
    StripeApi.prototype.updateStripePaymentIntent = function (requestParameters, options) {
        var _this = this;
        return StripeApiFp(this.configuration).updateStripePaymentIntent(requestParameters.id, requestParameters.body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * update subscription
     * @summary update subscription
     * @param {StripeApiUpdateStripeSubscriptionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StripeApi
     */
    StripeApi.prototype.updateStripeSubscription = function (requestParameters, options) {
        var _this = this;
        return StripeApiFp(this.configuration).updateStripeSubscription(requestParameters.id, requestParameters.body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return StripeApi;
}(BaseAPI));
export { StripeApi };
/**
 * SubscriptionApi - axios parameter creator
 * @export
 */
export var SubscriptionApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * count subscription by search conditions
         * @summary count subscription
         * @param {boolean} [active]
         * @param {number} [amount]
         * @param {number} [corporateID]
         * @param {string} [cursor]
         * @param {number} [customerID]
         * @param {string} [customerName]
         * @param {string} [endAt]
         * @param {number} [id]
         * @param {number} [limit]
         * @param {number} [maxCount]
         * @param {string} [orderBy]
         * @param {number} [productID]
         * @param {string} [startAt]
         * @param {string} [stripePriceID]
         * @param {string} [stripeSubscriptionID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countSubscription: function (active, amount, corporateID, cursor, customerID, customerName, endAt, id, limit, maxCount, orderBy, productID, startAt, stripePriceID, stripeSubscriptionID, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/subscriptions/count";
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (active !== undefined) {
                        localVarQueryParameter['active'] = active;
                    }
                    if (amount !== undefined) {
                        localVarQueryParameter['amount'] = amount;
                    }
                    if (corporateID !== undefined) {
                        localVarQueryParameter['corporateID'] = corporateID;
                    }
                    if (cursor !== undefined) {
                        localVarQueryParameter['cursor'] = cursor;
                    }
                    if (customerID !== undefined) {
                        localVarQueryParameter['customerID'] = customerID;
                    }
                    if (customerName !== undefined) {
                        localVarQueryParameter['customerName'] = customerName;
                    }
                    if (endAt !== undefined) {
                        localVarQueryParameter['endAt'] = endAt;
                    }
                    if (id !== undefined) {
                        localVarQueryParameter['id'] = id;
                    }
                    if (limit !== undefined) {
                        localVarQueryParameter['limit'] = limit;
                    }
                    if (maxCount !== undefined) {
                        localVarQueryParameter['maxCount'] = maxCount;
                    }
                    if (orderBy !== undefined) {
                        localVarQueryParameter['orderBy'] = orderBy;
                    }
                    if (productID !== undefined) {
                        localVarQueryParameter['productID'] = productID;
                    }
                    if (startAt !== undefined) {
                        localVarQueryParameter['startAt'] = startAt;
                    }
                    if (stripePriceID !== undefined) {
                        localVarQueryParameter['stripePriceID'] = stripePriceID;
                    }
                    if (stripeSubscriptionID !== undefined) {
                        localVarQueryParameter['stripeSubscriptionID'] = stripeSubscriptionID;
                    }
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * create subscription
         * @summary create subscription
         * @param {ModelSubscription} body Subscription
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSubscription: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    if (body === null || body === undefined) {
                        throw new RequiredError('body', 'Required parameter body was null or undefined when calling createSubscription.');
                    }
                    localVarPath = "/subscription";
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                    localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * delete subscription
         * @summary delete subscription
         * @param {number} id SubscriptionID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSubscription: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    if (id === null || id === undefined) {
                        throw new RequiredError('id', 'Required parameter id was null or undefined when calling deleteSubscription.');
                    }
                    localVarPath = "/subscription/{id}"
                        .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * get subscription
         * @summary get subscription
         * @param {number} id SubscriptionID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscription: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    if (id === null || id === undefined) {
                        throw new RequiredError('id', 'Required parameter id was null or undefined when calling getSubscription.');
                    }
                    localVarPath = "/subscription/{id}"
                        .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * get subscriptions
         * @summary get subscriptions
         * @param {string} ids Comma Separated SubscriptionID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscriptions: function (ids, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'ids' is not null or undefined
                    if (ids === null || ids === undefined) {
                        throw new RequiredError('ids', 'Required parameter ids was null or undefined when calling getSubscriptions.');
                    }
                    localVarPath = "/subscriptions/{ids}"
                        .replace("{" + "ids" + "}", encodeURIComponent(String(ids)));
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * patch subscription
         * @summary patch subscription
         * @param {number} id SubscriptionID
         * @param {ModelSubscription} body Subscription
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchSubscription: function (id, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    if (id === null || id === undefined) {
                        throw new RequiredError('id', 'Required parameter id was null or undefined when calling patchSubscription.');
                    }
                    // verify required parameter 'body' is not null or undefined
                    if (body === null || body === undefined) {
                        throw new RequiredError('body', 'Required parameter body was null or undefined when calling patchSubscription.');
                    }
                    localVarPath = "/subscription/{id}"
                        .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                    localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * search subscription by search conditions
         * @summary search subscription
         * @param {boolean} [active]
         * @param {number} [amount]
         * @param {number} [corporateID]
         * @param {string} [cursor]
         * @param {number} [customerID]
         * @param {string} [customerName]
         * @param {string} [endAt]
         * @param {number} [id]
         * @param {number} [limit]
         * @param {number} [maxCount]
         * @param {string} [orderBy]
         * @param {number} [productID]
         * @param {string} [startAt]
         * @param {string} [stripePriceID]
         * @param {string} [stripeSubscriptionID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchSubscription: function (active, amount, corporateID, cursor, customerID, customerName, endAt, id, limit, maxCount, orderBy, productID, startAt, stripePriceID, stripeSubscriptionID, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/subscriptions";
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (active !== undefined) {
                        localVarQueryParameter['active'] = active;
                    }
                    if (amount !== undefined) {
                        localVarQueryParameter['amount'] = amount;
                    }
                    if (corporateID !== undefined) {
                        localVarQueryParameter['corporateID'] = corporateID;
                    }
                    if (cursor !== undefined) {
                        localVarQueryParameter['cursor'] = cursor;
                    }
                    if (customerID !== undefined) {
                        localVarQueryParameter['customerID'] = customerID;
                    }
                    if (customerName !== undefined) {
                        localVarQueryParameter['customerName'] = customerName;
                    }
                    if (endAt !== undefined) {
                        localVarQueryParameter['endAt'] = endAt;
                    }
                    if (id !== undefined) {
                        localVarQueryParameter['id'] = id;
                    }
                    if (limit !== undefined) {
                        localVarQueryParameter['limit'] = limit;
                    }
                    if (maxCount !== undefined) {
                        localVarQueryParameter['maxCount'] = maxCount;
                    }
                    if (orderBy !== undefined) {
                        localVarQueryParameter['orderBy'] = orderBy;
                    }
                    if (productID !== undefined) {
                        localVarQueryParameter['productID'] = productID;
                    }
                    if (startAt !== undefined) {
                        localVarQueryParameter['startAt'] = startAt;
                    }
                    if (stripePriceID !== undefined) {
                        localVarQueryParameter['stripePriceID'] = stripePriceID;
                    }
                    if (stripeSubscriptionID !== undefined) {
                        localVarQueryParameter['stripeSubscriptionID'] = stripeSubscriptionID;
                    }
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * update subscription
         * @summary update subscription
         * @param {number} id SubscriptionID
         * @param {ModelSubscription} body Subscription
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSubscription: function (id, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    if (id === null || id === undefined) {
                        throw new RequiredError('id', 'Required parameter id was null or undefined when calling updateSubscription.');
                    }
                    // verify required parameter 'body' is not null or undefined
                    if (body === null || body === undefined) {
                        throw new RequiredError('body', 'Required parameter body was null or undefined when calling updateSubscription.');
                    }
                    localVarPath = "/subscription/{id}"
                        .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                    localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
/**
 * SubscriptionApi - functional programming interface
 * @export
 */
export var SubscriptionApiFp = function (configuration) {
    return {
        /**
         * count subscription by search conditions
         * @summary count subscription
         * @param {boolean} [active]
         * @param {number} [amount]
         * @param {number} [corporateID]
         * @param {string} [cursor]
         * @param {number} [customerID]
         * @param {string} [customerName]
         * @param {string} [endAt]
         * @param {number} [id]
         * @param {number} [limit]
         * @param {number} [maxCount]
         * @param {string} [orderBy]
         * @param {number} [productID]
         * @param {string} [startAt]
         * @param {string} [stripePriceID]
         * @param {string} [stripeSubscriptionID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countSubscription: function (active, amount, corporateID, cursor, customerID, customerName, endAt, id, limit, maxCount, orderBy, productID, startAt, stripePriceID, stripeSubscriptionID, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, SubscriptionApiAxiosParamCreator(configuration).countSubscription(active, amount, corporateID, cursor, customerID, customerName, endAt, id, limit, maxCount, orderBy, productID, startAt, stripePriceID, stripeSubscriptionID, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * create subscription
         * @summary create subscription
         * @param {ModelSubscription} body Subscription
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSubscription: function (body, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, SubscriptionApiAxiosParamCreator(configuration).createSubscription(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * delete subscription
         * @summary delete subscription
         * @param {number} id SubscriptionID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSubscription: function (id, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, SubscriptionApiAxiosParamCreator(configuration).deleteSubscription(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * get subscription
         * @summary get subscription
         * @param {number} id SubscriptionID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscription: function (id, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, SubscriptionApiAxiosParamCreator(configuration).getSubscription(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * get subscriptions
         * @summary get subscriptions
         * @param {string} ids Comma Separated SubscriptionID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscriptions: function (ids, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, SubscriptionApiAxiosParamCreator(configuration).getSubscriptions(ids, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * patch subscription
         * @summary patch subscription
         * @param {number} id SubscriptionID
         * @param {ModelSubscription} body Subscription
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchSubscription: function (id, body, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, SubscriptionApiAxiosParamCreator(configuration).patchSubscription(id, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * search subscription by search conditions
         * @summary search subscription
         * @param {boolean} [active]
         * @param {number} [amount]
         * @param {number} [corporateID]
         * @param {string} [cursor]
         * @param {number} [customerID]
         * @param {string} [customerName]
         * @param {string} [endAt]
         * @param {number} [id]
         * @param {number} [limit]
         * @param {number} [maxCount]
         * @param {string} [orderBy]
         * @param {number} [productID]
         * @param {string} [startAt]
         * @param {string} [stripePriceID]
         * @param {string} [stripeSubscriptionID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchSubscription: function (active, amount, corporateID, cursor, customerID, customerName, endAt, id, limit, maxCount, orderBy, productID, startAt, stripePriceID, stripeSubscriptionID, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, SubscriptionApiAxiosParamCreator(configuration).searchSubscription(active, amount, corporateID, cursor, customerID, customerName, endAt, id, limit, maxCount, orderBy, productID, startAt, stripePriceID, stripeSubscriptionID, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * update subscription
         * @summary update subscription
         * @param {number} id SubscriptionID
         * @param {ModelSubscription} body Subscription
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSubscription: function (id, body, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, SubscriptionApiAxiosParamCreator(configuration).updateSubscription(id, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
    };
};
/**
 * SubscriptionApi - factory interface
 * @export
 */
export var SubscriptionApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         * count subscription by search conditions
         * @summary count subscription
         * @param {boolean} [active]
         * @param {number} [amount]
         * @param {number} [corporateID]
         * @param {string} [cursor]
         * @param {number} [customerID]
         * @param {string} [customerName]
         * @param {string} [endAt]
         * @param {number} [id]
         * @param {number} [limit]
         * @param {number} [maxCount]
         * @param {string} [orderBy]
         * @param {number} [productID]
         * @param {string} [startAt]
         * @param {string} [stripePriceID]
         * @param {string} [stripeSubscriptionID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countSubscription: function (active, amount, corporateID, cursor, customerID, customerName, endAt, id, limit, maxCount, orderBy, productID, startAt, stripePriceID, stripeSubscriptionID, options) {
            return SubscriptionApiFp(configuration).countSubscription(active, amount, corporateID, cursor, customerID, customerName, endAt, id, limit, maxCount, orderBy, productID, startAt, stripePriceID, stripeSubscriptionID, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * create subscription
         * @summary create subscription
         * @param {ModelSubscription} body Subscription
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSubscription: function (body, options) {
            return SubscriptionApiFp(configuration).createSubscription(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * delete subscription
         * @summary delete subscription
         * @param {number} id SubscriptionID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSubscription: function (id, options) {
            return SubscriptionApiFp(configuration).deleteSubscription(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * get subscription
         * @summary get subscription
         * @param {number} id SubscriptionID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscription: function (id, options) {
            return SubscriptionApiFp(configuration).getSubscription(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * get subscriptions
         * @summary get subscriptions
         * @param {string} ids Comma Separated SubscriptionID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscriptions: function (ids, options) {
            return SubscriptionApiFp(configuration).getSubscriptions(ids, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * patch subscription
         * @summary patch subscription
         * @param {number} id SubscriptionID
         * @param {ModelSubscription} body Subscription
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchSubscription: function (id, body, options) {
            return SubscriptionApiFp(configuration).patchSubscription(id, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * search subscription by search conditions
         * @summary search subscription
         * @param {boolean} [active]
         * @param {number} [amount]
         * @param {number} [corporateID]
         * @param {string} [cursor]
         * @param {number} [customerID]
         * @param {string} [customerName]
         * @param {string} [endAt]
         * @param {number} [id]
         * @param {number} [limit]
         * @param {number} [maxCount]
         * @param {string} [orderBy]
         * @param {number} [productID]
         * @param {string} [startAt]
         * @param {string} [stripePriceID]
         * @param {string} [stripeSubscriptionID]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchSubscription: function (active, amount, corporateID, cursor, customerID, customerName, endAt, id, limit, maxCount, orderBy, productID, startAt, stripePriceID, stripeSubscriptionID, options) {
            return SubscriptionApiFp(configuration).searchSubscription(active, amount, corporateID, cursor, customerID, customerName, endAt, id, limit, maxCount, orderBy, productID, startAt, stripePriceID, stripeSubscriptionID, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * update subscription
         * @summary update subscription
         * @param {number} id SubscriptionID
         * @param {ModelSubscription} body Subscription
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSubscription: function (id, body, options) {
            return SubscriptionApiFp(configuration).updateSubscription(id, body, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * SubscriptionApi - object-oriented interface
 * @export
 * @class SubscriptionApi
 * @extends {BaseAPI}
 */
var SubscriptionApi = /** @class */ (function (_super) {
    __extends(SubscriptionApi, _super);
    function SubscriptionApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * count subscription by search conditions
     * @summary count subscription
     * @param {SubscriptionApiCountSubscriptionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionApi
     */
    SubscriptionApi.prototype.countSubscription = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return SubscriptionApiFp(this.configuration).countSubscription(requestParameters.active, requestParameters.amount, requestParameters.corporateID, requestParameters.cursor, requestParameters.customerID, requestParameters.customerName, requestParameters.endAt, requestParameters.id, requestParameters.limit, requestParameters.maxCount, requestParameters.orderBy, requestParameters.productID, requestParameters.startAt, requestParameters.stripePriceID, requestParameters.stripeSubscriptionID, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * create subscription
     * @summary create subscription
     * @param {SubscriptionApiCreateSubscriptionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionApi
     */
    SubscriptionApi.prototype.createSubscription = function (requestParameters, options) {
        var _this = this;
        return SubscriptionApiFp(this.configuration).createSubscription(requestParameters.body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * delete subscription
     * @summary delete subscription
     * @param {SubscriptionApiDeleteSubscriptionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionApi
     */
    SubscriptionApi.prototype.deleteSubscription = function (requestParameters, options) {
        var _this = this;
        return SubscriptionApiFp(this.configuration).deleteSubscription(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * get subscription
     * @summary get subscription
     * @param {SubscriptionApiGetSubscriptionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionApi
     */
    SubscriptionApi.prototype.getSubscription = function (requestParameters, options) {
        var _this = this;
        return SubscriptionApiFp(this.configuration).getSubscription(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * get subscriptions
     * @summary get subscriptions
     * @param {SubscriptionApiGetSubscriptionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionApi
     */
    SubscriptionApi.prototype.getSubscriptions = function (requestParameters, options) {
        var _this = this;
        return SubscriptionApiFp(this.configuration).getSubscriptions(requestParameters.ids, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * patch subscription
     * @summary patch subscription
     * @param {SubscriptionApiPatchSubscriptionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionApi
     */
    SubscriptionApi.prototype.patchSubscription = function (requestParameters, options) {
        var _this = this;
        return SubscriptionApiFp(this.configuration).patchSubscription(requestParameters.id, requestParameters.body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * search subscription by search conditions
     * @summary search subscription
     * @param {SubscriptionApiSearchSubscriptionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionApi
     */
    SubscriptionApi.prototype.searchSubscription = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return SubscriptionApiFp(this.configuration).searchSubscription(requestParameters.active, requestParameters.amount, requestParameters.corporateID, requestParameters.cursor, requestParameters.customerID, requestParameters.customerName, requestParameters.endAt, requestParameters.id, requestParameters.limit, requestParameters.maxCount, requestParameters.orderBy, requestParameters.productID, requestParameters.startAt, requestParameters.stripePriceID, requestParameters.stripeSubscriptionID, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * update subscription
     * @summary update subscription
     * @param {SubscriptionApiUpdateSubscriptionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionApi
     */
    SubscriptionApi.prototype.updateSubscription = function (requestParameters, options) {
        var _this = this;
        return SubscriptionApiFp(this.configuration).updateSubscription(requestParameters.id, requestParameters.body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return SubscriptionApi;
}(BaseAPI));
export { SubscriptionApi };
/**
 * UserApi - axios parameter creator
 * @export
 */
export var UserApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * count user by search conditions
         * @summary count user
         * @param {string} [cursor]
         * @param {string} [email]
         * @param {string} [id]
         * @param {number} [limit]
         * @param {string} [orderBy]
         * @param {number} [relationID]
         * @param {number} [userType]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countUser: function (cursor, email, id, limit, orderBy, relationID, userType, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/users/count";
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (cursor !== undefined) {
                        localVarQueryParameter['cursor'] = cursor;
                    }
                    if (email !== undefined) {
                        localVarQueryParameter['email'] = email;
                    }
                    if (id !== undefined) {
                        localVarQueryParameter['id'] = id;
                    }
                    if (limit !== undefined) {
                        localVarQueryParameter['limit'] = limit;
                    }
                    if (orderBy !== undefined) {
                        localVarQueryParameter['orderBy'] = orderBy;
                    }
                    if (relationID !== undefined) {
                        localVarQueryParameter['relationID'] = relationID;
                    }
                    if (userType !== undefined) {
                        localVarQueryParameter['userType'] = userType;
                    }
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * create user
         * @summary create user
         * @param {ModelUser} body User
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUser: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_a) {
                    // verify required parameter 'body' is not null or undefined
                    if (body === null || body === undefined) {
                        throw new RequiredError('body', 'Required parameter body was null or undefined when calling createUser.');
                    }
                    localVarPath = "/user";
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                    localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * delete user
         * @summary delete user
         * @param {string} id UserID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUser: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    if (id === null || id === undefined) {
                        throw new RequiredError('id', 'Required parameter id was null or undefined when calling deleteUser.');
                    }
                    localVarPath = "/user/{id}"
                        .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * get user
         * @summary get user
         * @param {string} id UserID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUser: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    if (id === null || id === undefined) {
                        throw new RequiredError('id', 'Required parameter id was null or undefined when calling getUser.');
                    }
                    localVarPath = "/user/{id}"
                        .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * get users
         * @summary get users
         * @param {string} ids Comma Separated UserID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsers: function (ids, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'ids' is not null or undefined
                    if (ids === null || ids === undefined) {
                        throw new RequiredError('ids', 'Required parameter ids was null or undefined when calling getUsers.');
                    }
                    localVarPath = "/users/{ids}"
                        .replace("{" + "ids" + "}", encodeURIComponent(String(ids)));
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * patch user
         * @summary patch user
         * @param {string} id UserID
         * @param {ModelUser} body User
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchUser: function (id, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    if (id === null || id === undefined) {
                        throw new RequiredError('id', 'Required parameter id was null or undefined when calling patchUser.');
                    }
                    // verify required parameter 'body' is not null or undefined
                    if (body === null || body === undefined) {
                        throw new RequiredError('body', 'Required parameter body was null or undefined when calling patchUser.');
                    }
                    localVarPath = "/user/{id}"
                        .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                    localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * search user by search conditions
         * @summary search user
         * @param {string} [cursor]
         * @param {string} [email]
         * @param {string} [id]
         * @param {number} [limit]
         * @param {string} [orderBy]
         * @param {number} [relationID]
         * @param {number} [userType]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchUser: function (cursor, email, id, limit, orderBy, relationID, userType, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/users";
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (cursor !== undefined) {
                        localVarQueryParameter['cursor'] = cursor;
                    }
                    if (email !== undefined) {
                        localVarQueryParameter['email'] = email;
                    }
                    if (id !== undefined) {
                        localVarQueryParameter['id'] = id;
                    }
                    if (limit !== undefined) {
                        localVarQueryParameter['limit'] = limit;
                    }
                    if (orderBy !== undefined) {
                        localVarQueryParameter['orderBy'] = orderBy;
                    }
                    if (relationID !== undefined) {
                        localVarQueryParameter['relationID'] = relationID;
                    }
                    if (userType !== undefined) {
                        localVarQueryParameter['userType'] = userType;
                    }
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * update user
         * @summary update user
         * @param {string} id UserID
         * @param {ModelUser} body User
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUser: function (id, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, Promise, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, query, key, key, headersFromBaseOptions, needsSerialization;
                return __generator(this, function (_a) {
                    // verify required parameter 'id' is not null or undefined
                    if (id === null || id === undefined) {
                        throw new RequiredError('id', 'Required parameter id was null or undefined when calling updateUser.');
                    }
                    // verify required parameter 'body' is not null or undefined
                    if (body === null || body === undefined) {
                        throw new RequiredError('body', 'Required parameter body was null or undefined when calling updateUser.');
                    }
                    localVarPath = "/user/{id}"
                        .replace("{" + "id" + "}", encodeURIComponent(String(id)));
                    localVarUrlObj = new URL(localVarPath, 'https://example.com');
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    query = new URLSearchParams(localVarUrlObj.search);
                    for (key in localVarQueryParameter) {
                        query.set(key, localVarQueryParameter[key]);
                    }
                    for (key in options.query) {
                        query.set(key, options.query[key]);
                    }
                    localVarUrlObj.search = (new URLSearchParams(query)).toString();
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
                    localVarRequestOptions.data = needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");
                    return [2 /*return*/, {
                            url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
/**
 * UserApi - functional programming interface
 * @export
 */
export var UserApiFp = function (configuration) {
    return {
        /**
         * count user by search conditions
         * @summary count user
         * @param {string} [cursor]
         * @param {string} [email]
         * @param {string} [id]
         * @param {number} [limit]
         * @param {string} [orderBy]
         * @param {number} [relationID]
         * @param {number} [userType]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countUser: function (cursor, email, id, limit, orderBy, relationID, userType, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, UserApiAxiosParamCreator(configuration).countUser(cursor, email, id, limit, orderBy, relationID, userType, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * create user
         * @summary create user
         * @param {ModelUser} body User
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUser: function (body, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, UserApiAxiosParamCreator(configuration).createUser(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * delete user
         * @summary delete user
         * @param {string} id UserID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUser: function (id, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, UserApiAxiosParamCreator(configuration).deleteUser(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * get user
         * @summary get user
         * @param {string} id UserID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUser: function (id, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, UserApiAxiosParamCreator(configuration).getUser(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * get users
         * @summary get users
         * @param {string} ids Comma Separated UserID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsers: function (ids, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, UserApiAxiosParamCreator(configuration).getUsers(ids, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * patch user
         * @summary patch user
         * @param {string} id UserID
         * @param {ModelUser} body User
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchUser: function (id, body, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, UserApiAxiosParamCreator(configuration).patchUser(id, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * search user by search conditions
         * @summary search user
         * @param {string} [cursor]
         * @param {string} [email]
         * @param {string} [id]
         * @param {number} [limit]
         * @param {string} [orderBy]
         * @param {number} [relationID]
         * @param {number} [userType]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchUser: function (cursor, email, id, limit, orderBy, relationID, userType, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, UserApiAxiosParamCreator(configuration).searchUser(cursor, email, id, limit, orderBy, relationID, userType, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
        /**
         * update user
         * @summary update user
         * @param {string} id UserID
         * @param {ModelUser} body User
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUser: function (id, body, options) {
            return __awaiter(this, void 0, Promise, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, UserApiAxiosParamCreator(configuration).updateUser(id, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, function (axios, basePath) {
                                    if (axios === void 0) { axios = globalAxios; }
                                    if (basePath === void 0) { basePath = BASE_PATH; }
                                    var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                                    return axios.request(axiosRequestArgs);
                                }];
                    }
                });
            });
        },
    };
};
/**
 * UserApi - factory interface
 * @export
 */
export var UserApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         * count user by search conditions
         * @summary count user
         * @param {string} [cursor]
         * @param {string} [email]
         * @param {string} [id]
         * @param {number} [limit]
         * @param {string} [orderBy]
         * @param {number} [relationID]
         * @param {number} [userType]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countUser: function (cursor, email, id, limit, orderBy, relationID, userType, options) {
            return UserApiFp(configuration).countUser(cursor, email, id, limit, orderBy, relationID, userType, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * create user
         * @summary create user
         * @param {ModelUser} body User
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUser: function (body, options) {
            return UserApiFp(configuration).createUser(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * delete user
         * @summary delete user
         * @param {string} id UserID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUser: function (id, options) {
            return UserApiFp(configuration).deleteUser(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * get user
         * @summary get user
         * @param {string} id UserID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUser: function (id, options) {
            return UserApiFp(configuration).getUser(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * get users
         * @summary get users
         * @param {string} ids Comma Separated UserID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsers: function (ids, options) {
            return UserApiFp(configuration).getUsers(ids, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * patch user
         * @summary patch user
         * @param {string} id UserID
         * @param {ModelUser} body User
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchUser: function (id, body, options) {
            return UserApiFp(configuration).patchUser(id, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * search user by search conditions
         * @summary search user
         * @param {string} [cursor]
         * @param {string} [email]
         * @param {string} [id]
         * @param {number} [limit]
         * @param {string} [orderBy]
         * @param {number} [relationID]
         * @param {number} [userType]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchUser: function (cursor, email, id, limit, orderBy, relationID, userType, options) {
            return UserApiFp(configuration).searchUser(cursor, email, id, limit, orderBy, relationID, userType, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * update user
         * @summary update user
         * @param {string} id UserID
         * @param {ModelUser} body User
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUser: function (id, body, options) {
            return UserApiFp(configuration).updateUser(id, body, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * UserApi - object-oriented interface
 * @export
 * @class UserApi
 * @extends {BaseAPI}
 */
var UserApi = /** @class */ (function (_super) {
    __extends(UserApi, _super);
    function UserApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * count user by search conditions
     * @summary count user
     * @param {UserApiCountUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    UserApi.prototype.countUser = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return UserApiFp(this.configuration).countUser(requestParameters.cursor, requestParameters.email, requestParameters.id, requestParameters.limit, requestParameters.orderBy, requestParameters.relationID, requestParameters.userType, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * create user
     * @summary create user
     * @param {UserApiCreateUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    UserApi.prototype.createUser = function (requestParameters, options) {
        var _this = this;
        return UserApiFp(this.configuration).createUser(requestParameters.body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * delete user
     * @summary delete user
     * @param {UserApiDeleteUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    UserApi.prototype.deleteUser = function (requestParameters, options) {
        var _this = this;
        return UserApiFp(this.configuration).deleteUser(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * get user
     * @summary get user
     * @param {UserApiGetUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    UserApi.prototype.getUser = function (requestParameters, options) {
        var _this = this;
        return UserApiFp(this.configuration).getUser(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * get users
     * @summary get users
     * @param {UserApiGetUsersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    UserApi.prototype.getUsers = function (requestParameters, options) {
        var _this = this;
        return UserApiFp(this.configuration).getUsers(requestParameters.ids, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * patch user
     * @summary patch user
     * @param {UserApiPatchUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    UserApi.prototype.patchUser = function (requestParameters, options) {
        var _this = this;
        return UserApiFp(this.configuration).patchUser(requestParameters.id, requestParameters.body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * search user by search conditions
     * @summary search user
     * @param {UserApiSearchUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    UserApi.prototype.searchUser = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return UserApiFp(this.configuration).searchUser(requestParameters.cursor, requestParameters.email, requestParameters.id, requestParameters.limit, requestParameters.orderBy, requestParameters.relationID, requestParameters.userType, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * update user
     * @summary update user
     * @param {UserApiUpdateUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    UserApi.prototype.updateUser = function (requestParameters, options) {
        var _this = this;
        return UserApiFp(this.configuration).updateUser(requestParameters.id, requestParameters.body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return UserApi;
}(BaseAPI));
export { UserApi };
